// IMPORTANT - DO NOT USE JQUERY IN FILE
// TODO - should .style.display = "" be changed to adding/removing hide class?
// TODO - #reviews (etc) url hash needs to click on the tab once it is scrolled to
(function () {
    // Localized variables kept in localizeddetails file
    var localizedJS = new localizedDetails(), 
      glide = new Glide4imprint(),
      prodScrollerJS = new prodScroller(),
      animate = new animations4i(),
      restrictedPricingDialog = new dialog4i(),
      guaranteeDialog = new dialog4i(),
      threeSixtyDialog = new dialog4i(),
      artInstDialog = new dialog4i(),
      prop65Dialog = new dialog4i(),
      zoomDialog = new dialog4i(),
      tooltips = new toolTips(),
      copyTabs = new tabs4i(),
      detailTabs = new tabs4i(),
      scrollerTabs = new tabs4i(),
      steppingQty = document.getElementById('litSteppingQty') ? parseInt(document.getElementById('litSteppingQty').value) : "",
      antiForgeryToken = { "__RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value },
      selBaseTrim = document.getElementById('selectedColorID'),
      catAlias = document.getElementById('CatalogAlias').value,
      isSuspended = document.getElementById("isSuspended") ? document.getElementById("isSuspended").value == 'True' : false,
      isApparelItem = document.getElementsByClassName('isApparelItem')[0].value == "True",
      isGFeed = document.getElementById('GFeedPanel'),
      currencySymbol = document.getElementById('tdCurrencySymbol').value,
      nibInkInput = document.getElementById('nibInkSelection'),
      adhesiveInput = document.getElementById('adhesiveSelection'),
      recolorAvailable = document.getElementById("isRecolorable"),
      reportSKU = document.getElementById('ReportSKU').value,
      ukShippingCost = document.getElementById('UKShippingCost').value, // is this used? 
      ukTaxRate = document.getElementById('UKTaxRate').value,
      baseExtra = document.getElementById('BaseExtra').value, //is this used?
      txtTimer = null,
      isMobile = getComputedStyle(document.getElementsByClassName('contactPanel')[0]).display == 'none',
      isDesktop = getComputedStyle(document.getElementsByClassName('prodNumber')[0]).cssFloat == 'none',
      isTabMobile = getComputedStyle(document.getElementsByClassName('prodNumber')[0]).cssFloat == 'left',
      isGlide = document.getElementsByClassName("glide")[0] ? true : false,
      processing = false,
      selectedProdColor,
      lastFocus,
      zoomSlider,
      mainImgSlider = new tns({
        container: document.getElementById('main-slider'),
        rewind: true,
        lazyload: true,
        prevButton: document.getElementById('leftArrowClick'),
        nextButton: document.getElementById('rightArrowClick'),
        speed: 500,
        nav: true,
        navPosition: "bottom"
      });
  	
  	glide.Init(arrBreak, arrPrice, steppingQty);
 	//console.log(arrBreak);
 	//console.log(arrPrice);
 		      			
  	var sliderGlide = (function(){
  		var glidePrice,
  		glideTotal,
  		glideQuantity,
  		glideAmountSaved,
  		glideDiscountDiv,
  		glideTotalDiv,
  		glideQtyDiv,
  		glideToolTip,
  		glideWrapper,
  		glideSlider,
  		step2Btn,
  		glideMinPoint,
  		glideMaxPoint,
  		singleBreak,
  		isGFeed,
		
		initVariables = function(){
  			glidePrice = document.getElementById('lblPrice'), 
		  	glideTotal = document.getElementById("lblTotal"), 
		  	glideQuantity = document.getElementById("txtQty"), 
		  	glideAmountSaved = document.getElementById("YouSaveBox"), 
		  	glideDiscountDiv = document.getElementById("divYouSave"),
		    	glideTotalDiv = document.getElementById("litGlideTotal"), 
		    	glideQtyDiv = document.getElementById("lblQuantityTxtCaption"), 
		    	glideToolTip = document.querySelector(".glideToolTip"), 
		    	glideWrapper = document.querySelector(".glide"), 
		    	glideSlider = document.querySelector(".glideSlider"),
		  	step2Btn = document.querySelector(".step1"),
		  	glideMinPoint = glide.MinPoint(),
		  	glideMaxPoint = glide.MaxPoint(),
		  	singleBreak = arrBreak[2] <= 0,
		    	isGFeed = document.getElementById('GFeedPanel') ? true : false;
  		},
  		init = function(){
  			if(isGlide){
  				initVariables();
  				
  				glideToolTip.classList.add("invisible"); // adding to prevent visual jump before styling - can be removed after next release 11/1
  				
				glideSlider.setAttribute("min", glideMinPoint);
				glideSlider.setAttribute("max", glideMaxPoint);

				/* IE11 does not support input event on ranges - boo 
				** aka we'd have to use just the on change event but this
				** will not update the tooltip qty and price as you slide, only when you finish sliding
				*/
				// https://www.impressivewebs.com/onchange-vs-oninput-for-range-sliders/
				// internet explorer
				glideSlider.addEventListener("change", function(e){
					e.preventDefault();
					updatePrice(glideSlider.value.toString());
				});
				
				// firefox and chrome
				glideSlider.addEventListener("input", function(e){
					e.preventDefault();
					updatePrice(glideSlider.value.toString());
				});
				
				window.addEventListener("resize", function(){
					if(window.innerWidth >= 800){
						updateToolTip(); //recalculate the tooltip position 
					}
				});

        			glideQuantity.addEventListener('keyup', function (e) {
          				if (isGFeed) {
           		 			document.getElementById('GFeedPanel').parentNode.removeChild(document.getElementById('GFeedPanel'));
           		 			glideTotalDiv.classList.remove("hide");
          					glideQtyDiv.classList.remove("hide");
          					glideWrapper.lastElementChild.classList.remove("hide"); //unit price
          				}
          				if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) { //enter key
            					textUpdateSliderFinish(glideQuantity.value, true);
          				} else {
            					textUpdateSlider(glideQuantity.value, true);
          				}
          				return false;
        			});
        			
        			// when using up/down arrows on right side of input
        			glideQuantity.addEventListener('change', function () { 
        				textUpdateSliderFinish(glideQuantity.value, true);
        			});
        			
        			// If editing update the slider with the appropriate qty
	      			if (editQty > 0) {
	        			if (!isApparelItem) {
	          				textUpdateSliderFinish(editQty, false);
	        			} else {
	          				CalcPrice();
	        			}
	      			}
	      			// updates the tooltip after everything on page has loaded and is in correct position
	      			setTimeout(function () { 
      					updateToolTip();
      					glideToolTip.classList.remove("invisible"); //show tooltip after set correctly - prevents the visual jump
    				}, 600);
	      		}
  		},
  		updateToolTip = function(){
  			// position
  			var val = parseInt(glideSlider.value, 10);
  			var pos = (val - glideMinPoint)/(glideMaxPoint - glideMinPoint);
			var glideThumbWidth = 34;
			var thumbCorrect = glideThumbWidth * (pos - 0.5) * -1;
			var titlepos = Math.round(( pos * glideSlider.offsetWidth ) - glideThumbWidth/4 + thumbCorrect );
			glideToolTip.style.left = (titlepos + 20) + "px";

			// content
			var qty = glideSlider.value;
			var firstDigit = glide.GetBreakSegment(qty);
      			var quantity = glide.GetSlideQty(firstDigit, qty);
			glideToolTip.textContent = quantity;
  		},
  		textUpdateSlider = function(qty, focus) {
      			if (txtTimer != null) {
        			clearTimeout(txtTimer);
      			}
      			var updateTime = 750;
      			if (qty > lowestQty) updateTime = 750;
      			txtTimer = setTimeout(function () {
        			textUpdateSliderFinish(qty, focus);
      			}, updateTime);
    		},
    		checkForSingleQtyBreak = function() {
      			// The glide slider will be disabled if there is only one break, so need to fill the price each in with the one price
      			if (singleBreak) {
        			var price = arrPrice[1];
        			var qty = arrBreak[1];
        			glideQuantity.value = qty;
        			glidePrice.value = currencySymbol + price.toFixed(2);
        			glideTotal.innerHTML = currencySymbol + (price * qty).toFixed(2);
        			document.querySelector('.glideWrapper').classList.add('hide');
      			}
    		},
    		updatePrice = function(qty) {  		
      			var firstDigit = glide.GetBreakSegment(qty);
      			var quantity = glide.GetSlideQty(firstDigit, qty);
      			
      			if (isGFeed) {
        			var oldquant = isApparelItem ? parseInt(glideQuantity.innerHTML) : parseInt(glideQuantity.value);
        			if (oldquant !== quantity) {
        				if(document.getElementById('GFeedPanel')){
          					document.getElementById('GFeedPanel').style.display = "none";
          				}
          				glideTotalDiv.classList.remove("hide");
         				glideQtyDiv.classList.remove("hide");
          				glideWrapper.lastElementChild.classList.remove("hide"); //unit price
        			}
      			}
      			if (glide.MinBreakQty() <= quantity) {
        			if (firstDigit != null) {
          				var newPrice = glide.GetPriceEstimate(firstDigit, quantity, qty);
          				var startPrice = arrPrice[1]; // pricing always starts at index 1
          			
          				updateToolTip();
          				
          				//glidePrice.innerHTML = currencySymbol + newPrice.toFixed(2);
          				glidePrice.value = currencySymbol + newPrice.toFixed(2);
          				glideTotal.innerHTML = currencySymbol + (newPrice * quantity).toFixed(2);
          				glideQuantity.value = quantity;
          				
          				if (Math.round(newPrice * 100) >= Math.round(startPrice * 100)) {
            					if (!glideAmountSaved.classList.contains("invisible")) {
              					glideAmountSaved.classList.add("invisible");
            					}
          				} else {
            					if (glideAmountSaved.classList.contains("invisible")) {
              					glideAmountSaved.classList.remove("invisible");
            					}
            					glideDiscountDiv.innerHTML = (currencySymbol + ((startPrice * quantity) - (newPrice * quantity)).toFixed(2));
          				}
          				enableBtn();
        			}
      			}
    		},
    		triggerChange = function(){
  			var event = document.createEvent("Event");
  			event.initEvent("change", true, true);
  			glideSlider.dispatchEvent(event);
    		},
    		enableBtn = function(){
    			step2Btn.classList.remove('disabledBtn');
        		step2Btn.classList.add('bkgdBlue');
        		step2Btn.classList.add('whiteLink');
    		}, 	
    		/*clearGlideErrors = function(){
    			if(document.querySelector(".qtyErrorMsg")){ document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg")); }
    			glideQuantity.classList.remove("input-validation-error");
        		glideQuantity.setAttribute('aria-invalid', 'false');
        		enableBtn();
    		},
    		glideError = function(){
    			if(document.querySelector(".qtyErrorMsg")){
    				document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
    			}
    			glideQtyDiv.parentNode.insertAdjacentHTML('beforebegin', '<div class="clear qtyErrorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="quantityError" class="btnToHyp text16 underline marginTop10">Minimum quantity for this item is ' + lowestQty + '.</button></div>');
			document.getElementById("quantityError").focus();
			step2Btn.classList.remove('bkgdBlue');
    			step2Btn.classList.remove('whiteLink');
    			step2Btn.classList.add('disabledBtn');
			glideQuantity.classList.add("input-validation-error");
        		glideQuantity.setAttribute('aria-invalid', 'true');
			document.getElementById("quantityError").addEventListener("click", function(e){
				e.preventDefault();
				glideQuantity.focus();
			});
			return false;
    		},*/
    		textUpdateSliderFinish = function(quantity, focus) {	
    			quantity = Math.round(quantity); // if decimals are used in the input box
      			if(quantity == "" || quantity < 0){ //enforce min quantity
      				glideQuantity.value = lowestQty;
      				glideSlider.value = glide.SetSlideQty(lowestQty);
	          		triggerChange();
      			}
      			if (glide.IsNumeric(quantity)) {
        			enableBtn();
        			qty = parseInt(quantity);
        			var SlideQty = qty;
        			var quantBoxValue = glideQuantity.value;
        			var price;
        			if (lowestQty > qty) qty = lowestQty;  //enforce min quantity   		
        			
      				// Only update the slider if there are multiple qty breaks
      				if (singleBreak) { // example: /product/6289/Soft-Carrying-Case
      					price = glidePrice.value.trim().substring(1); // Trims the currency symbol
        				glideTotal.innerHTML = (currencySymbol + (price * qty).toFixed(2));
      				}else{
      					var lastBreakQty = glide.MaxBreakQty();
      					// glideMaxPoint contains the maximum slide val and not quantity, cannot accurately compare the two - requires a conversion
      					if (qty > lastBreakQty) { // If the qty is greater than the end of the slider, need to set the value to slide to to the last break
	        				glideSlider.value = glide.SetSlideQty(lastBreakQty);
	        				triggerChange();
	        			}else{
          				    	//glideSlider.dispatchEvent(new Event('change')); // does not work in IE 11
      						glideSlider.value = glide.SetSlideQty(quantBoxValue);
          				    	triggerChange();
          				}
      				}
      				// The slider doesn't deal in qtys, just percentages, so sometimes it will adjust the qty when it does
      				// its percentage calculation if the user typed a qty. This will reset it to the user entered value.
      				if (qty > SlideQty) {
        				glideQuantity.value = qty;
        				glideToolTip.textContent = qty;
        				price = glidePrice.value.trim().substring(1); // Trims the currency symbol
        				glideTotal.innerHTML = (currencySymbol + (price * qty).toFixed(2));
      				} else {
    					if (parseInt(glideQuantity.value) != qty) {
    						const enforcedStepQty = glide.EnforceSteppingQty(qty, steppingQty);
	      					if (enforcedStepQty == qty) {
	        					glideQuantity.value = qty;
	        					glideToolTip.textContent = qty;
	        					price = glidePrice.value.trim().substring(1);
	        					glideTotal.innerHTML = (currencySymbol + (price * qty).toFixed(2));
	      					} else {
	      						glideSlider.value = glide.SetSlideQty(enforcedStepQty);
	      				    		triggerChange();
	      					}
    					}
      				}
    			}
    		};
  		return{
  			Init: init,
  			CheckForSingleQtyBreak: checkForSingleQtyBreak,
  			UpdateToolTip: updateToolTip
  		};
  	})(),
  	
      ajaxActions = (function () {
        var serialize = function (form) {
          /*!
           * Serialize all form data into a query string
           * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
           * @param  {Node}   form The form to serialize
           * @return {String}      The serialized form data
           */
          // Setup our serialized data
          var serialized = [];
          // Loop through each field in the form
          for (var i = 0; i < form.elements.length; i++) {
            var field = form.elements[i];
            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;
            // If a multi-select, get all selections
            if (field.type === 'select-multiple') {
              for (var n = 0; n < field.options.length; n++) {
                if (!field.options[n].selected) continue;
                serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
              }
            }
            // Convert field data to a query string
            else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
              serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
            }
          }
          return serialized.join('&');
        },
          getCustomerImagePage = function (e) {
            e.preventDefault();
            var vals = this.id.split('_');
            var page = vals[1];
            loadingPage(document.getElementById('CustomerImagesContainer'));
            var getImagesRequest = ajax({
              url: removeTrailingSlash("/productmvc/customerimages/" + prodID + "/" + page),
              method: "GET"
            });
            getImagesRequest.then(function (response, xhr) {
              document.getElementById('customerImagesTSTab').innerHTML = '';
              document.getElementById('customerImagesTSTab').innerHTML = response;
              initCustomerImagesPages();
              lazyloadImages.update();
              document.getElementById("detailTabs").scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
              hideLoading(document.getElementById('CustomerImagesContainer'));
            });
            getImagesRequest.catch(function (response, xhr) {
              hideLoading(document.getElementById('CustomerImagesContainer'));
            });
          },
          getQAPage = function (e) {
            e.preventDefault();
            var vals = this.id.split('_');
            var page = vals[1];
            loadingPage(document.getElementById('QandAContainer'));
            var getQuestionsPages = ajax({
              url: removeTrailingSlash("/productmvc/qandapage/" + prodID + "/" + page),
              method: "GET"
            });
            getQuestionsPages.then(function (response, xhr) {
              document.getElementById('QandAPage').innerHTML = '';
              document.getElementById('QandAPage').innerHTML = response;
              initQAPages();
              document.getElementById("QandAContainer").scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
              hideLoading(document.getElementById('QandAContainer'));
              questionEvents();
            });
            getQuestionsPages.catch(function (response, xhr) {
              hideLoading(document.getElementById('QandAContainer'));
            });
          },
          getStoryPage = function (e) {
            e.preventDefault();
            var vals = this.id.split('_');
            var page = vals[1];
            loadingPage(document.getElementById('SuccessStoriesContainer'));
            var getStories = ajax({
              url: removeTrailingSlash("/productmvc/successstories/" + prodID + "/" + page),
              method: "GET"
            });
            getStories.then(function (response, xhr) {
              document.getElementById('successStoriesTSTab').innerHTML = '';
              document.getElementById('successStoriesTSTab').innerHTML = response;
              initSuccessPages();
              document.getElementById("detailTabs").scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
              hideLoading(document.getElementById('SuccessStoriesContainer'));
            });
            getStories.catch(function (response, xhr) {
              hideLoading(document.getElementById('SuccessStoriesContainer'));
            });
          },
          getReviewPage = function (e) {
            e.preventDefault();
            var vals = this.id.split('_');
            var page = vals[1];
            loadingPage(document.getElementById('ReviewsContainer'));
  
            var getReviewsRequest = ajax({
              url: removeTrailingSlash("/productmvc/reviews/" + prodID + "/" + page + "/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + document.getElementById('reviewsFilter').value),
              method: "GET"
            });
            getReviewsRequest.then(function (response, xhr) {
              document.getElementById('reviewsTSTab').innerHTML = '';
              document.getElementById('reviewsTSTab').innerHTML = response;
  
              initReviewPages();
              initReviewFilters();
              reviewEvents();
              document.getElementById("reviewFilters").scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
              hideLoading(document.getElementById('ReviewsContainer'));
            });
            getReviewsRequest.catch(function (response, xhr) {
              hideLoading(document.getElementById('ReviewsContainer'));
            });
          },
          getFitRatingPage = function (e) {
            e.preventDefault();
            var vals = this.id.split('_');
            var page = vals[1];
            loadingPage(document.getElementById('FitRatingContainer'));
            var getFitRating = ajax({
              url: removeTrailingSlash("/productmvc/customerfitrating/" + prodID + "/" + page + "/" + document.getElementById('fitRatingFilter').value),
              method: "GET"
            });
            getFitRating.then(function (response, xhr) {
              document.getElementById('customerfitcomments').innerHTML = '';
              document.getElementById('customerfitcomments').innerHTML = response;
              initFitRatingPages();
              document.getElementById("detailTabs").scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
              hideLoading(document.getElementById('FitRatingContainer'));
            });
          },
          loadSizing = function (basetrim, noPrice) {
            document.getElementsByClassName('sizeGridLoadingImg')[0].classList.remove('hide');
            //console.log("prodID " + prodID);
            //console.log("basetrim " + basetrim);
            //console.log("editID " + editID);
            //console.log("noPrice " + noPrice);
            var loadSizesRequest = ajax({
              url: '/productmvc/loadsizeoptions',
              method: 'POST',
              data: {
                'ProductID': prodID,
                'Color': basetrim,
                'EditID': editID,
                'HidePricing': noPrice
              },
              timeout: 20000
            });
            loadSizesRequest.then(function (response, xhr) {
              //console.log("loadSizesRequest.then");
              document.getElementById('SizingGrid').innerHTML = response;
              //tooltips.init(); //glide tooltip commenting out - already initialized
  
              if (editID < 0 && qryStr > 0) {
                document.getElementsByClassName('txtApparelQty')[0].value = lowestQty;
              }
              CalcPrice();
              if (noPrice) {
                document.getElementsByClassName('showp')[0].classList.add('hide');
                document.getElementsByClassName('showpm')[0].classList.remove('hide');
              }
  
              if (document.getElementsByClassName("addMoreSizes")[0]) {
                addSizesEvent();
              } else if (document.getElementsByClassName('clearAllSizes')[0]) { // occurs when editing
                clearSizesEvent();
              }
  
              var sizingInputs = [].slice.call(document.getElementsByClassName('txtApparelQty'));
              sizingInputs.forEach(function (el, index, array) {
                el.addEventListener("focusout", sizeInputsEvent);
                el.addEventListener("keyup", sizeInputsEvent);
              });
  
              CheckQueryString();
  
              if (document.getElementById("GFeedPanel")) {
                document.getElementById('GFeedPanel').style.display = "block";
                if (document.getElementById("GFeedPanel").style.display == "block") {
                  // apparel pricing is repeated, should be hidden until gfeed is hidden, then shown
                  document.getElementById("pricingarea").classList.add("hide");
                } else {
                  document.getElementById("pricingarea").classList.remove("hide");
                }
              }
              pricingHandlers();
              document.getElementsByClassName('sizeGridLoadingImg')[0].classList.add('hide');
            });
            loadSizesRequest.catch(function (response, xhr) {
              //console.log("loadSizesRequest.catch");
              document.getElementById('SizingGrid').innerHTML = ('<div role="alert"aria-atomic="true" class="margin10 padding10 borderDkRed textDkRed clear">An error occured when looking up the available sizes. Please select ' + localizedJS.Color + ' again, or call us toll free at ' + localizedJS.PhoneNumber + ' for further assistance.</div>');
              document.getElementsByClassName('sizeGridLoadingImg')[0].classList.add('hide');
            });
          },
          loadOptionalExtras = function () {
            var qty = GetQty();
            if (!isNaN(qty)) {
              var optExtrasRequest = ajax({
                method: "POST",
                url: "/productattribute/optionalextras",
                data: {
                  'ProductID': prodID,
                  'Quantity': qty
                },
                timeout: 15000
              }).then(function (response, xhr) {
                optionalExtras = response;
  
                if (response != null && response.extras.length > 0) {
                  var ExtrasText = "";
  
                  for (var i = 0; i < response.extras.length; i++) {
                    var checkit = "";
                    if (editID > 0) {
                      if (document.querySelector('.SelectedOptionalExtras').value.indexOf('*' + response.extras[i].id + ',') != -1) {
                        checkit = " checked = 'checked'";
                        ajaxActions.UpdateOptionalExtraPrice(); // set price in "Current Selection" section
                      }
                    }
  
                    var unitprice = response.extras[i].unitprice;
                    var qty = document.querySelector(".selectedQty") ? document.querySelector(".selectedQty").innerHTML : "";
                    var totalprice;
                    if (!isNaN(unitprice) && qty != "") {
                      totalprice = (unitprice * qty).toFixed(2);
                    }
                    ExtrasText += "<div class='imprintLocCheck clear'>";
                    ExtrasText += "<input class='inlineMiddle optionalExtra' type='checkbox' value='" + response.extras[i].id + "' id='opt" + response.extras[i].id + "' name='opt" + response.extras[i].id + "'" + checkit + " />";
                    ExtrasText += "<label class='inlineMiddle' for='opt" + response.extras[i].id + "'>" + response.extras[i].displayname + "</label>";
                    if (!isNaN(totalprice)) {
                      ExtrasText += " - <span class='inlineMiddle'>For an Additional " + currencySymbol + totalprice + " (" + formatMoney(response.extras[i].unitprice) + " per piece)</span><br />";
                    }
                    ExtrasText += "<span class='textDarkestGray paddingLeft10 text14 inlineMiddle'>(" + response.extras[i].displaydesc + ")</span>";
                    ExtrasText += "</div>";
                  }
                  	document.getElementById('haloOptions').innerHTML = ExtrasText;
    		     var optionalExtras = [].slice.call(document.getElementsByClassName("optionalExtra"));
    		     optionalExtras.forEach(function (elem, index, array) {
    		     	elem.addEventListener("change", function() {
    		     		AddSelectedExtra(elem);
    		     	});
    		     });
                  document.getElementById('PD_OptionalExtra').style.display = "block";
                }
              }).catch(function (response, xhr) {
                document.getElementById('PD_OptionalExtra').style.display = "none";
              });
            }
          },
          reviewChange = function () {
            loadingPage(document.getElementById('ReviewsContainer'));
            var reviewChange = ajax({
              url: removeTrailingSlash("/productmvc/reviews/" + prodID + "/1/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + document.getElementById('reviewsFilter').value),
              method: "GET"
            });
            reviewChange.then(function (response, xhr) {
              document.getElementById('reviewsTSTab').innerHTML = '';
              document.getElementById('reviewsTSTab').innerHTML = response;
              initReviewPages();
              initReviewFilters();
              hideLoading(document.getElementById('ReviewsContainer'));
            });
          },
          loadAllReviews = function () {
            loadingPage(document.getElementById('ReviewsContainer'));
            var getAllReviews = ajax({
              url: "/productmvc/reviews/" + prodID + "/1",
              method: "GET"
            });
            getAllReviews.then(function (response, xhr) {
              hideLoading(document.getElementById('ReviewsContainer'));
              document.getElementById('reviewsTSTab').innerHTML = '';
              document.getElementById('reviewsTSTab').innerHTML = response;
              initReviewPages();
              initReviewFilters();
            });
          },
          reviewFilterChange = function (chosenFilter) {
            loadingPage(document.getElementById('ReviewsContainer'));
            var getReviews = ajax({
              url: removeTrailingSlash("/productmvc/reviews/" + prodID + "/1/" + document.getElementById('reviewsPerPage').value + "/" + document.getElementById('reviewsOrderBy').value + "/" + chosenFilter),
              method: "GET"
            });
            getReviews.then(function (response, xhr) {
              document.getElementById('reviewsTSTab').innerHTML = '';
              document.getElementById('reviewsTSTab').innerHTML = response;
              initReviewPages();
              initReviewFilters();
              document.getElementById('reviewsOrderBy').focus();
              document.getElementById('readAllReviews').addEventListener("click", loadAllReviews);
            });
          },
          deleteRestrictedCart = function (cart) {
            var dcid = document.getElementById('restrictedPricingProduct').getAttribute('data-cart-item');
            var deleteItem = ajax({
              method: "POST",
              url: "/cart/deleteitem",
              data: {
                cartId: cart,
                cartItemId: dcid
              },
              headers: antiForgeryToken
            });
            deleteItem.then(function (response, xhr) {
              //not sure what to do if they remove from cart, I think take them to the cart page for now
              //window.location.href = cartUrl;
              restrictedPricingDialog.close();
              RestrictedPricing.Close(); // page was broken if this wasnt done - quick fix
            });
          },
          getJumpToColors = function (color) {
            var getColorOptions = ajax({
              url: '/product/productcoloroptions',
              method: 'post',
              data: serialize(document.getElementById('productColors').getElementsByTagName('form')[0]) + '&chosenColorID=' + color
            });
            getColorOptions.then(function (response, xhr) {
              colorOptionsClicksOff();
              document.getElementById('productColors').innerHTML = response;
              initProductColorScroller();
              if (document.getElementById('removeColorFilter')) {
                document.getElementById('removeColorFilter').focus();
              } else {
                document.getElementById('jumpToColor').focus();
              }
              colorOptionsClicks();
              SaveProdColor(document.getElementsByClassName('imgBox')[0]);
              document.getElementsByClassName('imgBox')[0].classList.add("imgActive");
              tooltips.init(); // color tooltip
            });
          },
          loadAdhesiveOptions = function () {
            //console.log("loadAdhesiveOptions");
            var baseTrim = selBaseTrim.value;
            if (baseTrim != undefined && baseTrim != "" && typeof prodID != 'undefined') {
              var adhesiveRequest = ajax({
                method: "POST",
                url: "/productattribute/adhesive",
                data: {
                  'ProductID': prodID,
                  'Color': baseTrim
                },
                timeout: 15000
              }).then(function (response, xhr) {
                adhSidesOptions = response;
                //var parsedData = JSON.parse(response);
                if (response != null && response.adhesive.length > 0) {
                  adhSidesOptions = response; // Set to the global object for use when the user is making selections
                  var AdhesiveOptions = [];
                  var AdhSideOptions = [];
                  var AdhesiveOptionIDs = [];
                  var AdhesiveSideIDs = [];
                  var EditAdhesiveValue = '';
                  var EditAdhSideValue = '';
  
                  for (var i = 0; i < response.adhesive.length; i++) {
                    var optionFound = false;
                    // Look to see if the option has already been added to the adhesive option array
                    for (var j = 0; j < AdhesiveOptions.length; j++) {
                      if (!optionFound && AdhesiveOptions[j] == response.adhesive[i].adh) {
                        optionFound = true;
                      }
                    }
                    // if the adhesive option was not found, add the option to the array for display
                    if (!optionFound) {
                      AdhesiveOptions[AdhesiveOptions.length] = response.adhesive[i].adh;
                      AdhesiveOptionIDs[AdhesiveOptionIDs.length] = response.adhesive[i].id;
                    } else {
                      optionFound = false; // Reset the variable for the color check
                    }
                    // Look to see if the option has already been added to the side option array
                    for (var k = 0; k < AdhSideOptions.length; k++) {
                      if (!optionFound && AdhSideOptions[k] == response.adhesive[i].side) {
                        optionFound = true;
                      }
                    }
                    // if the side option was not found, add the option to the array for display
                    if (!optionFound) {
                      AdhSideOptions[AdhSideOptions.length] = response.adhesive[i].side;
                      AdhesiveSideIDs[AdhesiveSideIDs.length] = response.adhesive[i].id;
                    }
                    if (editID > 0) {
                      if (response.adhesive[i].id == adhesiveInput.value) {
                        EditAdhSideValue = response.adhesive[i].side;
                        EditAdhesiveValue = response.adhesive[i].adh;
                      }
                    }
                  }
  
                  // All adhesive and side options have been located, now display them
                  //console.log("AdhesiveOptions " + AdhesiveOptions);
                  //console.log("AdhesiveOptions.length " + AdhesiveOptions.length);
                  if (AdhesiveOptions.length >= 1) {
                    AdhesiveOptions.sort();
  
                    var adhesiveInputs = [].slice.call(document.getElementById("adhesiveOptions").querySelectorAll("input"));
                    //console.log("adhesiveInputs " + adhesiveInputs);
  
                    adhesiveInputs.forEach(function (el, index, array) {
                      el.removeEventListener('click', adhesiveOptionChanged); // Unbind the handler from any previous radio buttons
                    });
  
                    document.getElementById('adhesiveOptions').innerHTML = ''; // Remove any previously displayed radio buttons
                    var checked = false;
  
                    for (var x = 0; x < AdhesiveOptions.length; x++) {
                      var inputId = "adhesive" + x;
                      var adhDiv = document.createElement("div");
                      adhDiv.classList.add("floatLeft");
                      adhDiv.classList.add("marginRight10");
                      adhDiv.classList.add("marginTop5");
                      adhDiv.classList.add("clear");
                      //var adhRadio = '<input type="radio" id="' + inputId + '" name="adhesive" tabindex="0" value="' + AdhSideOptions[x] + '"';
                      var adhRadio;
                      if (AdhesiveOptions.length == 1) {
                      	adhRadio = '<input type="radio" id="' + inputId + '" name="adhesive" disabled tabindex="0" value="' + AdhesiveOptions[x] + '"';
                      }
                      else {
                            adhRadio = '<input type="radio" id="' + inputId + '" name="adhesive" tabindex="0" value="' + AdhesiveOptions[x] + '"';
                      }
                      // Set up the selected option, the first option by default if the item is not being edited
                      if ((editID > 0 && AdhesiveOptions[x] == EditAdhesiveValue) || (editID <= 0 && x == 0)) {
                        adhRadio += ' checked';
                        checked = true;
                      }
  
                      adhRadio += ' />';
                      //adhRadio += '<label for="' + inputId + '" name="' + AdhSideOptions[x] + '">' + AdhesiveOptions[x] + '</label><input type="hidden" value="' + AdhesiveOptionIDs[x] + '" />';
                      adhRadio += '<label for="' + inputId + '" name="' + AdhesiveOptions[x] + '">' + AdhesiveOptions[x] + '</label><input type="hidden" value="' + AdhesiveOptionIDs[x] + '" />';
  
                      adhDiv.innerHTML = adhRadio;
                      document.getElementById('adhesiveOptions').appendChild(adhDiv);
                    }
  
                    if (!checked) {
                      document.getElementById('adhesive0').checked = true;
                    }
  
                    document.querySelector('.PD_Adhesive').style.display = "block";
  
                    //console.log("adhesiveInputs2 " + adhesiveInputs);
                    adhesiveInputs = [].slice.call(document.getElementById("adhesiveOptions").querySelectorAll("input"));
                    //console.log("adhesiveInputs3 " + adhesiveInputs);
                    adhesiveInputs.forEach(function (el, index, array) {
                      el.addEventListener('click', adhesiveOptionChanged); // Bind the handler to the new radio buttons
                    });
                  } else {
                    document.querySelector('.PD_Adhesive').style.display = "none";
                  }
  
                  //console.log("AdhSideOptions " + AdhSideOptions);
                  //console.log("AdhSideOptions.length " + AdhSideOptions.length);
  
                  if (AdhSideOptions.length >= 1) {
                    AdhSideOptions.sort();
  
                    var adhSideInputs = [].slice.call(document.getElementById("adhSideOptions").querySelectorAll("input"));
                    //console.log("adhSideInputs " + adhSideInputs );
  
                    adhSideInputs.forEach(function (el, index, array) {
                      el.removeEventListener('click', adhesiveOptionChanged); // Unbind the handler from any previous radio buttons
                    });
  
                    document.getElementById('adhSideOptions').innerHTML = ''; // Remove any previously displayed options
                    var checked = false;
  
                    for (var i = 0; i < AdhSideOptions.length; i++) {
                      var adhesiveSide = "adhesiveSide" + i;
                      var adhSideRadioDiv = document.createElement("div");
                      adhSideRadioDiv.classList.add("floatLeft");
                      adhSideRadioDiv.classList.add("marginRight10");
                      adhSideRadioDiv.classList.add("marginTop5");
                      adhSideRadioDiv.classList.add("clear");
                      var adhSideRadio;
                      if (AdhSideOptions.length == 1) {
                      	adhSideRadio = '<input type="radio" id="' + adhesiveSide + '" name="ink" disabled tabindex="0" value="' + AdhSideOptions[i] + '"';
                      }
                      else {
                        	adhSideRadio = '<input type="radio" id="' + adhesiveSide + '" name="ink" tabindex="0" value="' + AdhSideOptions[i] + '"';
                      }
                      // Set up the selected option, the first option by default if the item is not being edited
                      if ((editID > 0 && AdhSideOptions[i] == EditAdhSideValue) || (editID <= 0 && i == 0)) {
                        adhSideRadio += ' checked';
                        checked = true;
                      }
  
                      adhSideRadio += ' />';
                      adhSideRadio += '<label for="' + adhesiveSide + '" name="' + AdhSideOptions[i] + '">' + AdhSideOptions[i] + '</label><input type="hidden" value="' + AdhesiveSideIDs[i] + '" />';
                      adhSideRadioDiv.innerHTML = adhSideRadio;
                      document.getElementById('adhSideOptions').appendChild(adhSideRadioDiv);
                    }
  
                    if (!checked) {
                      document.getElementById('adhesiveSide0').checked = true;
                    }
  
                    document.querySelector('.PD_AdhesiveSide').style.display = "block";
  
                    //console.log("adhSideInputs2 " + adhesiveInputs);
                    adhSideInputs = [].slice.call(document.getElementById("adhSideOptions").querySelectorAll("input"));
                    //console.log("adhSideInputs3 " + adhesiveInputs);
                    adhSideInputs.forEach(function (el, index, array) {
                      el.addEventListener('click', adhesiveOptionChanged); // Bind the handler to the new radio buttons
                    });
                  } else {
                    document.querySelector('.PD_AdhesiveSide').style.display = "none";
                  }
  
                  if (adhSidesOptions.adhesive.length > 0 && (AdhesiveOptions.length >= 1 || AdhSideOptions.length >= 1)) {
                    // If there is a nib or color selection to be made, set the default selections into the hidden input
                    // Edit mode implications?
                    adhesiveOptionChanged();
                    // Do the initial pass on the ink colors to make sure only the available ones are displayed
                    toggleAvailableAdhesiveSides();
                  }
  
                } else {
                  document.querySelector('.PD_Adhesive').style.display = "none";
                  document.querySelector('.PD_AdhesiveSide').style.display = "none";
                }
              }).catch(function (response, xhr) {
                document.querySelector('.PD_Adhesive').style.display = "none";
                document.querySelector('.PD_AdhesiveSide').style.display = "none";
              });
            }
          },
          loadNibInkColor = function () {
            var selectedColorID = selBaseTrim.value;
            if (selectedColorID != undefined && selectedColorID != "" && typeof prodID != 'undefined') {
              var nibinkRequest = ajax({
                method: "POST",
                url: "/productattribute/nibink",
                data: {
                  'ProductID': prodID,
                  'Color': selectedColorID,
                  'EditID': editID
                },
                timeout: 15000
              }).then(function (response, xhr) {
                nibInkOptions = response;
                //console.log("nibInkOptions " + nibInkOptions);
                //var parsedData = response; //JSON.parse(response);
                if (response != null && response.inknib.length > 0) {
                  nibInkOptions = response; // Set to the global object for use when the user is making selections
  
                  var NibOptions = [];
                  var ColorOptions = [];
                  var ProductColorAttributeIDs = [];
                  var EditNibValue = '';
                  var EditInkColorValue = '';
  
                  for (var i = 0; i < response.inknib.length; i++) {
                    var optionFound = false;
                    // Look to see if the option has already been added to the nib option array
                    for (var j = 0; j < NibOptions.length; j++) {
                      if (!optionFound && NibOptions[j] == response.inknib[i].nib) {
                        optionFound = true;
                      }
                    }
                    // if the nib option was not found, add the option to the array for display
                    if (!optionFound) {
                      NibOptions[NibOptions.length] = response.inknib[i].nib;
                    } else {
                      optionFound = false; // Reset the variable for the color check
                    }
                    // Look to see if the option has already been added to the color option array
                    for (var j = 0; j < ColorOptions.length; j++) {
                      if (!optionFound && ColorOptions[j] == response.inknib[i].ink) {
                        optionFound = true;
                      }
                    }
                    // if the nib option was not found, add the option to the array for display
                    if (!optionFound) {
                      ColorOptions[ColorOptions.length] = response.inknib[i].ink;
                      ProductColorAttributeIDs[ProductColorAttributeIDs.length] = response.inknib[i].id;
                    }
                    if (editID > 0) {
                      if (response.inknib[i].id == nibInkInput.value) {
                        EditInkColorValue = response.inknib[i].ink;
                        EditNibValue = response.inknib[i].nib;
                      }
                    }
                  }
                  //console.log("NibOptions " + NibOptions);
                  // All color and nib options have been located, now display them
                  if (NibOptions.length > 0) {
                    //console.log("niboptions true");
                    //NibOptions.sort();
                    var nibChecks = [].slice.call(document.getElementById("nibOptions").querySelectorAll("input"));
                    //console.log("nibChecks 1 " + nibChecks);
                    //nibChecks.forEach(function (el, index, array) {
                    //  console.log("el  " + el + " index "  + index + " array " + array);
                    //});
                    //console.log("document.getElementById " + document.getElementById("nibOptions").querySelectorAll("input") );
                    nibChecks.forEach(function (el, index, array) {
                      el.removeEventListener("change", NibInkOptionChanged); // Bind the handler to the new radio buttons
                    });
                    document.getElementById('nibOptions').innerHTML = ''; // Remove any previously displayed radio buttons
                    var checked = false;
                    for (var i = 0; i < NibOptions.length; i++) {
                      var inputId = "nib" + i;
                      var radioNibDiv = document.createElement("div");
                      radioNibDiv.classList.add("floatLeft");
                      radioNibDiv.classList.add("marginRight10");
                      radioNibDiv.classList.add("marginTop5");
                      radioNibDiv.classList.add("clear");
                      var radioNib;
                      if (NibOptions.length == 1) {
                      	radioNib = '<input type="radio" id="' + inputId + '" name="nib" disabled tabindex="0" value="' + NibOptions[i] + '"';
  			  }
  			  else {
                      	radioNib = '<input type="radio" id="' + inputId + '" name="nib" tabindex="0" value="' + NibOptions[i] + '"';
  			  }
                      // Set up the selected option, the first option by default if the item is not being edited
                      if ((editID > 0 && NibOptions[i] == EditNibValue) || (editID <= 0 && i == 0)) {
                        //console.log("edit id true");
                        radioNib += ' checked';
                        checked = true;
                      }
                      radioNib += ' />';
                      //radioNib += '<label for="' + inputId + '" name="' + ColorOptions[i] + '">' + NibOptions[i] + '</label>';
                      radioNib += '<label for="' + inputId + '" name="' + NibOptions[i] + '">' + NibOptions[i] + '</label>';
                      radioNibDiv.innerHTML = radioNib;
                      document.getElementById('nibOptions').insertBefore(radioNibDiv, document.getElementById('nibOptions').firstChild); //prepend
                    }
                    if (!checked) {
                      //console.log("!checked if hit");
                      document.getElementById('nib0').checked = true;
                    }
                    document.querySelector('.PD_NibSize').style.display = "block";
                    //console.log("pre nib check foreach");
  
                    //console.log("nibChecks 2" + nibChecks);
                    nibChecks = [].slice.call(document.getElementById("nibOptions").querySelectorAll("input"));
                    //console.log("nibChecks 3" + nibChecks);
                    nibChecks.forEach(function (el, index, array) {
                      el.addEventListener("change", NibInkOptionChanged); // Bind the handler to the new radio buttons
                    });
                  } else {
                    document.querySelector('.PD_NibSize').style.display = "none";
                  }
                  //console.log("ColorOptions " + ColorOptions);
                  if (ColorOptions.length > 0) {
                    //console.log("color options true");
                    //ColorOptions.sort();
                    //ProductColorAttributeIDs.sort();
                    var inkChecks = [].slice.call(document.getElementById("inkColorOptions").querySelectorAll("input"));
                    inkChecks.forEach(function (el, index, array) {
                      el.removeEventListener("change", NibInkOptionChanged); // Bind the handler to the new radio buttons
                    });
                    document.getElementById('inkColorOptions').innerHTML = ''; // Remove any previously displayed options
                    var checked = false;
                    for (var i = 0; i < ColorOptions.length; i++) {
                      var inkId = "ink" + i;
                      var radioInkDiv = document.createElement('div');
                      radioInkDiv.classList.add("floatLeft");
                      radioInkDiv.classList.add("marginRight10");
                      radioInkDiv.classList.add("marginTop5");
                      radioInkDiv.classList.add("clear");
                      var radioInk;
                      if (ColorOptions.length == 1) {
                     	radioInk = '<input type="radio" id="' + inkId + '" name="ink" disabled tabindex="0" value="' + ColorOptions[i] + '"';
                      }
                      else {
                       	radioInk = '<input type="radio" id="' + inkId + '" name="ink" tabindex="0" value="' + ColorOptions[i] + '"';
                      }
                      // Set up the selected option, the first option by default if the item is not being edited
                      if ((editID > 0 && ColorOptions[i] == EditInkColorValue) || (editID <= 0 && i == 0)) {
                        radioInk += ' checked';
                        checked = true;
                      }
                      radioInk += ' />';
                      //radioBtn += '<label for="' + inkId + '" name="' + ColorOptions[i] + '">' + ColorOptions[i] + '</label><input type="hidden" tabindex="0" value="' + ProductColorAttributeIDs[i] + '" /></div>';
                      //Allows the hidden input to be assigned a class so the value can be updated via javascript
                      var colorName = "colorName" + ColorOptions[i];
                      radioInk += '<label for="' + inkId + '" name="' + ColorOptions[i] + '">' + ColorOptions[i] + '</label><input class="' + colorName + ' inkColorValue" type="hidden" tabindex="0" value="' + ProductColorAttributeIDs[i] + '" />';
                      radioInkDiv.innerHTML = radioInk;
                      document.getElementById('inkColorOptions').append(radioInkDiv);
                    }
                    if (!checked) {
                      document.getElementById('ink0').checked = true;
                    }
                    document.querySelector('.PD_InkColor').style.display = "block";
                    //console.log("inkChecks " + inkChecks);
                    inkChecks = [].slice.call(document.getElementById("inkColorOptions").querySelectorAll("input"));
                    //console.log("inkChecks2 " + inkChecks);
  
                    inkChecks.forEach(function (el, index, array) {
                      el.addEventListener("change", NibInkOptionChanged); // Bind the handler to the new radio buttons
                    });
                    /*if (NibOptions.length < 2) {
                      // The nib section is not shown, but the ink color section is, so the step number needs to be changed. Take the number from nib section.
                      // COMMENTED OUT - numbers are no longer in the headings and do not exist
                      //document.querySelector('.PD_InkColor').querySelector('.PD_ChoiceHeading_Num').innerHTML = document.querySelector('.PD_NibSize').querySelector('.PD_ChoiceHeading_Num').innerHTML;
                    }*/
                  } else {
                    document.querySelector('.PD_InkColor').style.display = "none";
                  }
                  //console.log("nibInkOptions " + nibInkOptions);
                  if (nibInkOptions.inknib.length > 0 && (NibOptions.length >= 1 || ColorOptions.length >= 1)) {
                    // If there is a nib or color selection to be made, set the default selections into the hidden input
                    // Edit mode implications?
                    NibInkOptionChanged();
                    // Do the initial pass on the ink colors to make sure only the available ones are displayed
                    toggleAvailableInkColors();
                  }
                } else {
                  document.querySelector('.PD_NibSize').style.display = "none";
                  document.querySelector('.PD_InkColor').style.display = "none";
                }
              }).catch(function (response, xhr) {
                document.querySelector('.PD_NibSize').style.display = "none";
                document.querySelector('.PD_InkColor').style.display = "none";
              });
            }
          },
          sampleRequest = function () {
            if (document.getElementsByClassName('sampleError')[0]) {
              document.getElementsByClassName('sampleError')[0].parentNode.removeChild(document.getElementsByClassName('sampleError')[0]);
            }
            if (document.getElementsByClassName('sampleCancel')[0]) {
              document.getElementsByClassName('sampleCancel')[0].parentNode.removeChild(document.getElementsByClassName('sampleCancel')[0]);
            }
            animate.fadeIn(document.getElementById('imgSampleReq1Loading'));
            var getSampleRequest = ajax({
              url: removeTrailingSlash('/productmvc/samplerequest/' + catAlias),
              method: 'GET'
            });
            getSampleRequest.then(function (response, xhr) {
              animate.fadeOut(document.getElementById('imgSampleReq1Loading'));
              document.getElementsByClassName('sampleBtnContainer')[0].style.display = "none";
  		document.querySelector(".sampleRequest1").setAttribute("aria-expanded", "true");
  		
              //If the user is able to place a sample request display the sample request form otherwise let them know when they are not able to.
              if (response.Status == 'success') {
                document.getElementById('samplePanel').classList.add('hide');
                document.getElementById('samplePanel').innerHTML = response.HtmlString;
                animate.slideDown(document.getElementById('samplePanel'));
                document.getElementById('SampleRequestForm').scrollIntoView({
                  behavior: "smooth"
                });
                document.getElementById('FirstName').focus();
  
                var loadSample = new samplePage(s, s_account);
                loadSample.init(); //load event handlers on buttons loaded in ajax	
                
                document.getElementById("cancelSampleRequest").addEventListener("click", function(e){
                	e.preventDefault();
                	document.querySelector(".sampleRequest1").setAttribute("aria-expanded", "false");
                });
              } else {
                document.getElementsByClassName('sampleRequestPanel')[0].insertAdjacentHTML('afterend', response.HtmlString);
              }
            });
          },
          fitRatingChange = function (fitFilter) {
            loadingPage(document.getElementById('FitRatingContainer'));
            var getFitRatings = ajax({
              url: removeTrailingSlash("/productmvc/customerfitrating/" + prodID + "/1/" + fitFilter),
              method: "GET"
            });
            getFitRatings.then(function (response, xhr) {
              document.getElementById('customerfitcomments').innerHTML = '';
              document.getElementById('customerfitcomments').innerHTML = response;
              initFitRatingPages();
            });
            hideLoading(document.getElementById('FitRatingContainer'));
          },
          submitQuestion = function () {
            var data = {
              catalogAlias: catAlias,
              productQuestion: document.getElementById('prodQstn').value
            };
            var postQuestion = ajax({
              url: "/productmvc/saveproductquestion",
              method: "POST",
              data: data
            });
            postQuestion.then(function (response, xhr) {
              if (response.success == "true") {
                document.getElementsByClassName('btnSubmitProdQuestion')[0].parentNode.parentNode.insertAdjacentHTML('afterend', '<p class="prodQuestionMsg clear textsemibold textBlue" role="status">' + response.message + '</p>');
                document.getElementById('prodQstn').value = '';
                document.getElementsByClassName("btnSubmitProdQuestion")[0].focus();
              } else {
                document.getElementsByClassName('btnSubmitProdQuestion')[0].parentNode.parentNode.insertAdjacentHTML('afterend', '<p class="prodQuestionMsg clear textsemibold textDkRed" role="status">' + response.message + '</p>');
                document.getElementById('prodQstn').focus();
              }
            });
          },
          positiveReview = function (e) {
            e.preventDefault();
            var el = e.currentTarget;
            if (el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]) {
              el.parentNode.getElementsByClassName('reviewRemarkMsg')[0].parentNode.removeChild(el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]);
            }
            var reviewID = el.parentNode.getElementsByClassName('reviewID')[0].value;
            var data = {
              reportSKU: reportSKU,
              reviewID: reviewID,
              positiveReview: true,
              negativeReview: false,
              catalogAlias: catAlias
            };
            var postPosReview = ajax({
              url: "/productmvc/reviewremark",
              method: "POST",
              data: data
            });
            postPosReview.then(function (response, xhr) {
              if (response.success == "true") {
                el.nextElementSibling.insertAdjacentHTML('afterend', '<p class="clear textBlue textsemibold reviewRemarkMsg paddingTop10" role="status">' + response.message + '</p>');
              } else {
                el.nextElementSibling.insertAdjacentHTML('afterend', '<p class="clear textDkRed textsemibold reviewRemarkMsg paddingTop10" role="status">' + response.message + '</p>');
              }
            });
          },
          negativeReview = function (e) {
            e.preventDefault();
            var el = e.currentTarget;
            if (el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]) {
              el.parentNode.getElementsByClassName('reviewRemarkMsg')[0].parentNode.removeChild(el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]);
            }
            var reviewID = el.parentNode.getElementsByClassName('reviewID')[0].value;
            var data = {
              reportSKU: reportSKU,
              reviewID: reviewID,
              positiveReview: false,
              negativeReview: true,
              catalogAlias: catAlias
            };
            var postReview = ajax({
              url: "/productmvc/reviewremark",
              method: "POST",
              data: data
            });
            postReview.then(function (response, xhr) {
              if (response.success == "true") {
                el.insertAdjacentHTML('afterend', '<p class="clear textBlue textsemibold reviewRemarkMsg paddingTop10" role="status">' + response.message + '</p>');
              } else {
                el.insertAdjacentHTML('afterend', '<p class="clear textDkRed textsemibold reviewRemarkMsg paddingTop10" role="status">' + response.message + '</p>');
              }
            });
          },
          positiveAnswer = function (e) {
            e.preventDefault();
            var el = e.currentTarget;
            var reviewID = el.parentNode.parentNode.getElementsByClassName('QA_ID')[0].value;
            var data = {
              answerID: reviewID,
              answerHelful: true,
              catalogAlias: catAlias
            };
            if (el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]) {
              el.parentNode.getElementsByClassName('reviewRemarkMsg')[0].parentNode.removeChild(el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]);
            }
            var answerHelpful = ajax({
              url: "/product/answerhelpful",
              method: "POST",
              data: data
            });
            answerHelpful.then(function (response, xhr) {
              if (response.success == "true") {
                el.nextElementSibling.insertAdjacentHTML('afterend', '<p class="clear textBlue textsemibold reviewRemarkMsg paddingBtm10" role="status">' + response.message + '</p>');
              } else {
                el.nextElementSibling.insertAdjacentHTML('afterend', '<p class="clear textDkRed textsemibold reviewRemarkMsg paddingBtm10" role="status">' + response.message + '</p>');
              }
            });
          },
          negativeAnswer = function (e) {
            e.preventDefault();
            var el = e.currentTarget;
            var reviewID = el.parentNode.parentNode.getElementsByClassName('QA_ID')[0].value;
            if (el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]) {
              el.parentNode.getElementsByClassName('reviewRemarkMsg')[0].parentNode.removeChild(el.parentNode.getElementsByClassName('reviewRemarkMsg')[0]);
            }
            var data = {
              answerID: reviewID,
              answerHelful: false,
              catalogAlias: catAlias
            };
            var answerHelpful = ajax({
              url: "/product/answerhelpful",
              method: "POST",
              data: data
            });
            answerHelpful.then(function (response, xhr) {
              if (response.success == "true") {
                el.insertAdjacentHTML('afterend', '<p class="clear textBlue textsemibold reviewRemarkMsg paddingBtm10" role="status">' + response.message + '</p>');
              } else {
                el.insertAdjacentHTML('afterend', '<p class="clear textDkRed textsemibold reviewRemarkMsg paddingBtm10" role="status">' + response.message + '</p>');
              }
            });
          },
          submitAnswer = function (element, data) {
            var submitAnswerRequest = ajax({
              url: "/product/submitquickanswer",
              method: "POST",
              data: data
            });
            submitAnswerRequest.then(function (response, xhr) {
              if (response.success == "true") {
                animate.slideUp(element.parentNode.parentNode);
                element.parentNode.parentNode.previousElementSibling.setAttribute("aria-expanded", "false");
                element.parentNode.parentNode.previousElementSibling.getElementsByTagName("svg")[0].setAttribute("class", "textDkGray rotate180");
                element.parentNode.parentNode.previousElementSibling.focus();
                element.parentNode.parentNode.previousElementSibling.insertAdjacentHTML('afterend', '<p class="clear textBlue textsemibold prodAnswerMsg" role="alert" aria-atomic="true">' + response.message + '</p>');
              } else {
                animate.slideUp(element.parentNode.parentNode);
                element.parentNode.parentNode.previousElementSibling.setAttribute("aria-expanded", "false");
                element.parentNode.parentNode.previousElementSibling.getElementsByTagName("svg")[0].setAttribute("class", "textDkGray rotate180");
                element.parentNode.parentNode.previousElementSibling.focus();
                element.parentNode.parentNode.previousElementSibling.insertAdjacentHTML('afterend', '<p class="clear textDkRed textsemibold prodAnswerMsg" role="alert" aria-atomic="true">' + response.message + '</p>');
              }
            });
          },
          submitQuickAnswer = function (data) {
            var submitQuestion = ajax({
              url: "/productmvc/submitquickanswer",
              method: "POST",
              data: data
            });
            submitQuestion.then(function (response, xhr) {
              document.getElementsByClassName('quickAnswerContent')[0].innerHTML = '';
              if (response.success == "true") {
                document.getElementsByClassName('addQuickAnswer')[0].style.display = "block";
                document.getElementsByClassName('quickAnswerContent')[0].insertAdjacentHTML('afterend', '<span class=\"quickAnswSubmitMsg textBlue\" role=\"status\">' + response.message + '</span>');
              } else {
                document.getElementsByClassName('addQuickAnswer')[0].style.display = "block";
                document.getElementsByClassName('quickAnswerContent')[0].insertAdjacentHTML('afterend', '<span class=\"quickAnswSubmitMsg textDkRed\" role=\"status\">' + response.message + '</span>');
              }
              //questionEvents();
            });
          },
          loadMiniRating = function () {
            var getMiniRating = ajax({
              url: '/productmvc/minirating',
              method: 'POST',
              data: {
                'catalias': catAlias
              }
            });
            getMiniRating.then(function (response, xhr) {
              var newDiv = document.createElement('div');
              newDiv.innerHTML = response;
              if (document.getElementById('ratingSpot')) {
                document.getElementById('ratingSpot').appendChild(newDiv);
              }
              if (document.getElementById("minirating")) {
                if (isMobile) {
                  document.getElementById("ratingSpot").classList.remove("Rating");
                  document.getElementById("ratingSpot").classList.add("marginLeft15");
                  var stars = [].slice.call(document.getElementById("minirating").getElementsByClassName("ratingStarBase")[0].getElementsByTagName("svg"));
                  stars.forEach(function (el, index, array) {
                    el.height = "15";
                    el.width = "15";
                  });
                  var starBkgd = [].slice.call(document.getElementById("minirating").getElementsByClassName("starBackground"));
                  starBkgd.forEach(function (el, index, array) {
                    el.width = "80";
                  });
                  var starFrgd = [].slice.call(document.getElementById("minirating").getElementsByClassName("starForeground"));
                  starFrgd.forEach(function (el, index, array) {
                    el.width = "76";
                  });
                }
                document.getElementsByClassName('allReviews')[0].addEventListener('click', function (e) {
                  if (document.getElementsByTagName('a.anchor[name="reivews"]')[0]) {
                    return;
                  }
                  e.preventDefault();
                  document.getElementById('detailTabs').scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                  });
                  animate.slideUp(document.getElementById('ministars'), 100);
                  //allow the tabs to 'appear'
                  setTimeout(function () {
                    document.getElementById('reviewsTS').getElementsByClassName('tabLink')[0].click();
                  }, 2500);
                });
                document.getElementById('miniReviewLink').addEventListener('click', function (e) {
                  e.preventDefault();
                  if (document.getElementById('ministars').classList.contains('hide')) {
                    animate.slideDown(document.getElementById('ministars'), 50);
                    document.getElementById('miniReviewLink').setAttribute("aria-expanded", "true");
                    document.getElementById('ministars').setAttribute("aria-hidden", "false");
                    document.getElementsByClassName('allReviews')[0].focus();
                    document.getElementById('ministars').addEventListener('keydown', function (e) {
                      if (e.which == 27) {
                        animate.slideUp(document.getElementById('ministars'), 100);
                        document.getElementById('miniReviewLink').focus();
                      }
                    });
                  } else {
                    animate.slideUp(document.getElementById('ministars'), 100);
                    document.getElementById('miniReviewLink').setAttribute("aria-expanded", "false");
                    document.getElementById('ministars').setAttribute("aria-hidden", "true");
                    this.focus();
                  }
                });
                FixIE11SVG();
              }
            });
          },
          getRelatedProducts = function () {
            var getRelatedScroller = ajax({
              url: '/productmvc/GetRelatedProductsScrollerAsync',
              method: 'POST',
              data: {
                'productID': prodID
              }
            });
            getRelatedScroller.then(function (response, xhr) {
              var newDiv = document.createElement('div');
              newDiv.innerHTML = response;
              document.getElementById('relatedProductsContainer').appendChild(newDiv);
              document.getElementById('relatedProductsContainer').getElementsByClassName('spinner')[0].classList.add('hide');
              prodScrollerJS.InitSliderLessItems("RelatedItems");
            });
          },
          getDetailTabs = function () {
            var page = 1;
            if (window.location.href.match(/\/page\/(\d*)/) != null) {
              page = window.location.href.match(/\/page\/(\d*)/)[1];
            }
            var detailsTabs = ajax({
              url: '/productmvc/GetDetailsTabAsync',
              method: 'POST',
              data: {
                'productID': prodID,
                'infoType': document.getElementById('InfoType').value,
                'qID': document.getElementById('QuestionID').value,
                'rFilter': document.getElementById('ReviewFilter').value,
                'fitRatingFilter': document.getElementById('FitCommentFilter').value,
                page: page
              }
            });
            detailsTabs.then(function (response, xhr) {
              var newDiv = document.createElement('div');
              newDiv.innerHTML = response;
              document.getElementById('detailTabs').appendChild(newDiv);
              showHideTabs();
              window.addEventListener("resize", showHideTabs);
              detailTabs.init(document.getElementById("detailTabs"));
              setDetailTabEvents();
              document.getElementById('detailTabs').getElementsByClassName('spinner')[0].classList.add('hide');
              FixIE11SVG();
            });
          },
          getItemCategories = function () {
            var getItemCats = ajax({
              url: '/productmvc/GetItemCategoriesAsync',
              method: 'POST',
              data: {
                'productID': prodID
              }
            });
            getItemCats.then(function (response, xhr) {
              var newDiv = document.createElement('div');
              newDiv.innerHTML = response;
              document.getElementsByClassName('itemCats')[0].appendChild(newDiv);
              document.getElementsByClassName('itemCats')[0].getElementsByClassName('spinner')[0].classList.add('hide');
            });
          },
          getTabbedScroller = function () {
            var getTabProducts = ajax({
              url: '/productmvc/GetTabProductScrollerAsync',
              method: 'POST',
              data: {
                'productID': prodID
              }
            });
            getTabProducts.then(function (response, xhr) {
              var newDiv = document.createElement('div');
              newDiv.innerHTML = response;
              document.getElementById('tabProd').appendChild(newDiv);
              if (document.getElementById("SimilarItemsPanel")) {
                prodScrollerJS.InitSliderLessItems("SimilarItems");
              }
              if (document.getElementById("MoreUpscaleItemsPanel")) {
                prodScrollerJS.InitSliderLessItems("MoreUpscaleItems");
              }
              if (document.getElementById("MoreUpscaleItemsPanel")) {
                prodScrollerJS.InitSliderLessItems("MoreUpscaleItems");
              }
              if (document.getElementById("LowerpriceItemsPanel")) {
                prodScrollerJS.InitSliderLessItems("LowerpriceItems");
              }
              if (document.getElementById("LowerMinQtyItemsPanel")) {
                prodScrollerJS.InitSliderLessItems("LowerMinQtyItems");
              }
              if (document.getElementById("FasterItemsPanel")) {
                prodScrollerJS.InitSliderLessItems("FasterItems");
              }
              if (isMobile) {
                document.getElementById("MoreUpscaleItemsTab").parentNode.parentNode.removeChild(document.getElementById("MoreUpscaleItemsTab").parentNode);
                document.getElementById("MoreUpscaleItemsPanel").parentNode.removeChild(document.getElementById("MoreUpscaleItemsPanel"));
              }
              document.getElementById('tabProd').getElementsByClassName('spinner')[0].classList.add('hide');
              scrollerTabs.init(document.getElementById("prodScrollerTabs"));
              scrollerTabs.initTab(document.getElementById("SimilarItemsTab"));
            });
          },
          getAlternativeItems = function () {
            var getAltRelated = ajax({
              url: '/productmvc/GetAltRelProductsAsync',
              method: 'POST',
              data: {
                'productID': prodID
              }
            });
            getAltRelated.then(function (response, xhr) {
              var newDiv = document.createElement('div');
              newDiv.innerHTML = response;
              document.getElementById('altrelated').appendChild(newDiv);
              prodScrollerJS.InitSliderLessItems("altrelated");
              document.getElementById('altrelated').getElementsByClassName('spinner')[0].classList.add('hide');
            });
            getAltRelated.catch(function (response, xhr) {
              document.getElementById('altrelated').innerHTML = '';
            });
          },
          getAlternativeItemsList = function () {
            var getAltItems = ajax({
              url: '/productmvc/GetAltItemsAsync',
              method: 'POST',
              data: {
                'productID': prodID
              }
            });
            getAltItems.then(function (response, xhr) {
              var newDiv = document.createElement('div');
              newDiv.innerHTML = response;
              document.getElementById('altitemslist').appendChild(newDiv);
              prodScrollerJS.InitSliderLessItems("altitemslist");
              document.getElementById('altitemslist').getElementsByClassName('spinner')[0].classList.add('hide');
              FixIE11SVG();
            });
          },
          getPropSixtyFive = function (e) {
            e.preventDefault();
            var getProp65 = ajax({
              url: '/product/prop65',
              method: 'post',
              data: {
                'ProductID': prodID
              }
            });
            getProp65.then(function (response, xhr) {
              document.getElementById('prop65content').innerHTML = response;
              if (document.getElementsByClassName('loadingModal')[0]) {
                document.getElementsByClassName('loadingModal')[0].style.display = "none";
              }
            });
            getProp65.catch(function (response, xhr) {
              document.getElementById('prop65content').innerHTML = "There was an issue loading the warnings, please refresh the page and try again.";
              if (document.getElementsByClassName('loadingModal')[0]) {
                document.getElementsByClassName('loadingModal')[0].style.display = "none";
              }
            });
          },
          updateOptionalExtraPrice = function () {
            var qty = GetQty();
            if (!isNaN(qty)) {
              var optExtraRequest = ajax({
                method: "POST",
                url: "/productattribute/optionalextras",
                data: {
                  'ProductID': prodID,
                  'Quantity': qty
                },
                timeout: 15000
              }).then(function (response, xhr) {
                if (response != null && response.extras.length > 0) {
                  var ExtrasText = "";
                  var totalprice = parseFloat(document.getElementById('lblTotal').innerHTML.replace(currencySymbol, '').trim());
                  for (var i = 0; i < response.extras.length; i++) {
                    var currentselection = document.getElementById('SelectedOptionalExtras').value;
                    if (currentselection.indexOf('*' + response.extras[i].id + ',') != -1) { // check here if extraID is in .SelectedOptionalExtras
                      var qty = GetQty();
                      var unitprice = parseFloat(response.extras[i].unitprice);
                      var optionaltotal = qty * unitprice;
                      totalprice = totalprice + optionaltotal;
  
                      ExtrasText += "<div class='extraDetailsLine padding10 text14'>";
                      ExtrasText += "<div class='inlineMiddle noPadding c-sm-third-2 c-xs-full textsemibold'>" + response.extras[i].displayname + "</div>";
                      ExtrasText += "<div class='inlineMiddle noPadding c-sm-third-1 c-xs-full'><p class='floatRightOnMedium'>" + GetQty() + "  @  " + currencySymbol + unitprice.toFixed(2) + " each = " + currencySymbol + optionaltotal.toFixed(2) + "</p></div>";
                      ExtrasText += "</div>";
                    }
                  }
  
                  if (totalprice != parseFloat(document.getElementById('lblTotal').innerHTML.replace(currencySymbol, '').trim())) {
                    // only need to show this if the total price is different from the quantity selected price
                    document.getElementById('grandTotal').innerHTML = totalprice;
                  }
  
                  document.getElementById('selectedOptionalExtraResult').innerHTML = ExtrasText;
                  document.getElementById('selectedOptionalSummary').innerHTML = ExtrasText;
                  document.getElementById('selectedOptionalExtraResult').style.display = "block";
                  document.querySelector('.optionalExtrasLoadingImg').style.display = "none";
                }
              });
            }
          },
          getExtras = function (triggerElement) {
            var chkdImprintLoc = 0;
            var ExtrasTotal = 0.00;
  
            var locChecks = [].slice.call(document.querySelectorAll(".chkbxImprintLocation"));
            locChecks.forEach(function (el, index, array) {
              if (el.checked) {
                chkdImprintLoc++;
              }
            });
  
            var qty = GetQty();
           // if (chkdImprintLoc > 0 && !isNaN(qty)) {
           if( !isNaN(qty)) {
              GetSelectedImprintColors();
              GetSelectedImprintLocations();
  
              if (listImprintLocationIDs.length == 0 || listProductImprintLocationIDs.length == 0 || listSelectedColors.length == 0) {
                if (document.querySelector(".PD_Step_2").querySelector(".errorMsg")) {
                  document.querySelector(".PD_Step_2").querySelector(".errorMsg").parentNode.removeChild(document.querySelector(".PD_Step_2").querySelector(".errorMsg"));
                }
                if (totalImprintColors > 0) {
                  document.querySelector('.imprint-location').insertAdjacentHTML('beforebegin', '<div class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="imprintError" class="btnToHyp text16 underline marginTop10">Please select at least one imprint location and one imprint ' + localizedJS.Color + '.</button></div>');
                  document.getElementById("imprintError").focus();
                  document.getElementById("imprintError").addEventListener("click", function(e){
        	         e.preventDefault();
        	         document.querySelector(".chkbxImprintLocation").focus();
                  });
                  return false;
                }
              }
  
              var arrImprintLocationIDs = listImprintLocationIDs;
              var arrProductImprintLocationIDs = listProductImprintLocationIDs;
              var arrImprintColorsIDs = listSelectedColors;
              var baseTrimColor = selBaseTrim.value.split('/');
  
              var OrderSummary = {
                ProductID: prodID,
                Quantity: qty,
                ImprintColors: arrImprintColorsIDs,
                ImprintLocations: arrImprintLocationIDs,
                BaseColorID: baseTrimColor[0],
                TrimColorID: baseTrimColor[1],
                EditID: editID,
                ProductImprintLocations: arrProductImprintLocationIDs,
                NibColorAttributeID: GetNibColorAttributeID(),
                AdhesiveAttributeID: GetAdhesiveAttributeID(),
                IsReorder: document.getElementById("isReorder").value.toLowerCase() === 'true'  // jag
              };
  
              var isGfeed = false;
              if (qryStr > 0) {
                isGfeed = true;
              }
              if (triggerElement != null && !isGfeed) {
                triggerElement.parentNode.querySelector('.extrasLoadingImg').style.display = "block";
              }
              ResetImprintCharges();
  
              var calcExtraRequest = ajax({
                method: "POST",
                url: "/productmvc/calculateextras",
                data: OrderSummary,
                headers: antiForgeryToken   // jag
              }).then(function (response, xhr) {
                if (triggerElement != null && !isGfeed) {
                  triggerElement.parentNode.querySelector('.extrasLoadingImg').style.dispaly = "none";
                }
                if (response.indexOf('extrasError') < 0) {
                  document.getElementById('setupChrgSummary').innerHTML = response;
                } else {
                  document.getElementById('setupChrgSummary').innerHTML = '<p class="textsemibold" role="alert" aria-atomic="true">Add To Cart To View Any Imprint Charges</p>';
                }
                if (triggerElement != null && !isGfeed) {
                  triggerElement.parentNode.querySelector('.extrasResult').innerHTML = response + "<div class='clear'></div>";
                }
  		
  		  if(triggerElement != null){
  		  	triggerElement.setAttribute("aria-expanded", "true");
  		  }
  
                //if(triggerElement.parentNode.getElementsByClassName('extrasResult')[0]){
                //	triggerElement.parentNode.getElementsByClassName('extrasResult')[0].innerHTML = data + "<div class='clear'></div>";
                //	tooltips.init(); // extras tooltips
                //}
  
  
                //var ExtraTemplate = document.getElementById('selectedExtrasBox').querySelector('.selectedExtraLine'); //cannot find this element
                //var Extras = document.createElement("div");
                //Extras.id = "ExtraDummy";
                var extraLines = [].slice.call(document.getElementById("setupChrgSummary").querySelectorAll(".extraDetailsLine"));
                extraLines.forEach(function (el, index, array) {
                  //var NewExtra = ExtraTemplate.clone(false); 
                  var LineTotal;
  
                  var lineTotals = el.querySelectorAll(".LineTotal");
                  for (var i = 0; i < lineTotals.length; i++) {
                    LineTotal = lineTotals[i].innerHTML;
                  }
  
                  if (LineTotal != undefined && LineTotal != "") {
                    ExtrasTotal += parseFloat(LineTotal.replace(LineTotal.substring(0, 1), ''));
                  }
                  //NewExtra.querySelector('.selectionExtraDesc').innerHTML = el.querySelector('.extraDetailsDescCol').innerHTML;
                  //NewExtra.querySelector('.selectionExtraQtyPrice').innerHTML = '';
                  //Extras.appendChild(NewExtra);
                });
  
                tooltips.init(); // extras tooltips	
  
                if (triggerElement != null && !isGfeed) {
                  if (triggerElement.parentNode.querySelector('.extrasLoadingImg')) {
                    triggerElement.parentNode.querySelector('.extrasLoadingImg').style.display = "none";
                  }
                  if (triggerElement.parentNode.querySelector('.extrasResult')) {
                    animate.fadeIn(triggerElement.parentNode.querySelector('.extrasResult'));
                  }
                }

                var qryStr2 = window.location.search;
            qryStr2 = qryStr2.indexOf("gfeed=1");
            if (qryStr2 > 0) {
              if (document.getElementById("GFeedData")) {
                tooltips.init(); //gfeed tooltip
              }
            }
  
            var total, totalDisplayed;
            currencySymbol = currencySymbol.replace(/\s+/g, '');
            if (document.getElementById("lblTotal") && !document.querySelector('.GFeedPanel1')) {
              totalDisplayed = document.getElementById('lblTotal').innerHTML;
              totalDisplayed = totalDisplayed.replace(/\s+/g, '');
              total = (ExtrasTotal + parseFloat(totalDisplayed.replace(totalDisplayed.substring(0, 1), ''))).toFixed(2);
            }
  
            
            if (qryStr2 > 0 && typeof total !== 'undefined' && !isNaN(total) && !isNaN(ExtrasTotal)) {
            	document.getElementById('currencySymbol').innerHTML = currencySymbol;
             document.getElementById('grandTotal').innerHTML = total;
            	var gfeedtotal;
              if (ukTaxRate != '0') {
                //UK locale, add VAT
                var vat = currencySymbol + localizedJS.VatTax(ExtrasTotal, totalDisplayed.replace(currencySymbol, ''), ukTaxRate);
                gfeedtotal = currencySymbol + localizedJS.TotalWithVat(ExtrasTotal, totalDisplayed.replace(currencySymbol, ''), ukTaxRate);
                document.getElementById('VatTax').innerHTML = vat;
                document.getElementById('GFeedFinalPrice').innerHTML = gfeedtotal;
                document.getElementById('GFeedQty').innerHTML = qty;
                if(document.querySelector(".glidePanel")){ //glide
	          	document.getElementById('GFeedUnitPrice').innerHTML = document.getElementById('lblPrice').value;
	          }else{ //apparel
	          	document.getElementById('GFeedUnitPrice').innerHTML = document.getElementById('lblPrice').innerHTML;
	          }
                document.getElementById('GFeedTotalPrice').innerHTML = document.getElementById('lblTotal').innerHTML;
                if (document.getElementById('GFeedPanel').display != 'none') {
                  document.getElementById('lblTotal').innerHTML = gfeedtotal;
                  
                  if(document.querySelector(".glidePanel")){ //glide
		          	document.getElementById('lblPrice').value = '';
		      }else{ //apparel
		          	document.getElementById('lblPrice').innerHTML = '';
		       }
                }
              } else {
                //Not UK
                gfeedtotal = currencySymbol + total;
                if (document.getElementById('GFeedPanel').display != 'none') {
                  document.getElementById('lblTotal').innerHTML = gfeedtotal;
                  if(document.querySelector(".glidePanel")){ //glide
	          	 document.getElementById('lblPrice').value = '';
	            }else{ //apparel
	          	 document.getElementById('lblPrice').innerHTML = '';
	            }
                }
                document.getElementById('GFeedFinalPrice').innerHTML = gfeedtotal;
  
              }
            }
		  return false;
              }).catch(function (response, xhr) {
                if (triggerElement != null && !isGfeed) {
                  triggerElement.parentNode.querySelector('.extrasLoadingImg').style.display = "none";
                  triggerElement.parentNode.querySelector('.extrasResult').innerHTML = '<div role="status">Sorry, an error occurred. Please <a href="#" onclick="return ajaxActions.GetExtras();">click here</a> to try again. You can also view the imprint charges in your cart by click the Add to Cart button below.</div>';
                }
              });
            }
  
          
          },
          addToCart = function () {
            //because of design on mobile, make sure they haven't forgotten to select color / quantity
            if (isMobile) {
              if (document.getElementById('colorSelected').value === '') {
                document.getElementById("productColors").querySelector(".PD_customizeHead").insertAdjacentHTML('afterend', '<div class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="colorError" class="btnToHyp text16 underline marginTop10">Please select one ' + localizedJS.Color + '.</button></div>');             
                document.getElementById("colorError").focus();
        	   document.getElementById("colorError").addEventListener("click", function(e){
        	       e.preventDefault();
        	       document.querySelector('.imgBox').focus();
                });
                processing = false;
                return false;
              }
  		
              if (GetQty() < lowestQty) {
                var quantityErrorHtml = '<div class="clear qtyErrorMsg errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="quantityError" class="btnToHyp textLeft text16 underline marginTop10">Minimum quantity for this item is ' + lowestQty + '.</button></div>';
                if (document.querySelector(".qtyErrorMsg")) {
                  document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
                }
                if (isApparelItem) {
                  document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                  var apparelQtys = document.querySelectorAll(".txtApparelQty");
                  for (var i = 0; i < apparelQtys.length; i++) {
                    if (apparelQtys[i].value != '') {
                      //apparelQtys[i].style.backgroundColor = '#ffd9d9';
                      apparelQtys[i].classList.add("input-validation-error");
                      apparelQtys[i].setAttribute('aria-invalid', 'true');
                    }
                  }
                  document.getElementById("quantityError").focus();
        	     document.getElementById("quantityError").addEventListener("click", function(e){
        	          e.preventDefault();
        	          apparelQtys[0].focus();
                  });
                } else {
                  document.querySelector('.glidePanel').insertAdjacentHTML('beforebegin', quantityErrorHtml);
                  //document.getElementById('txtQty').style.backgroundColor = '#ffd9d9';
                  document.getElementById('txtQty').classList.add("input-validation-error");
                  document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
                  document.getElementById("quantityError").focus();
	           document.getElementById("quantityError").addEventListener("click", function(e){
	        	e.preventDefault();
	        	document.getElementById('txtQty').focus();
	          });
                }
                processing = false;
                return false;
              }
            }
            GetSelectedImprintLocations();
            GetSelectedImprintColors();
  
            if (document.querySelector(".PD_Step_2").querySelector(".errorMsg")) {
              document.querySelector(".PD_Step_2").querySelector(".errorMsg").parentNode.removeChild(document.querySelector(".PD_Step_2").querySelector(".errorMsg"));
            }
  
            if (!validateSelections()) {
              return false;
            }
            ajaxActions.GetExtras();
  
            if (document.querySelector(".extrasResult")) {
              document.querySelector(".extrasResult").style.display = "none";
            }
  
            var selectedOptionalExtras = document.getElementById('SelectedOptionalExtras').value;
            var selectedSizes = GetSelectedSizes();
            var baseTrimColor = selBaseTrim.value.split('/');
            var arrImprintLocationIDs = listImprintLocationIDs;
            var arrProductImprintLocationIDs = listProductImprintLocationIDs;
            var arrImprintColorsIDs = listSelectedColors;
            /*
            console.log("selectedSizes " + selectedSizes);
            console.log("selectedOptionalExtras " + selectedOptionalExtras);
            console.log("arrImGetSelectedSizesprintLocationIDs " + arrImprintLocationIDs);
            console.log("arrProductImprintLocationIDs " + arrProductImprintLocationIDs);
            console.log("arrImprintColorsIDs " + arrImprintColorsIDs);
            */
  
            var priceEach;
            if(document.querySelector(".glidePanel")){ //glide
          		priceEach = document.getElementById("lblPrice").value;
          	}else{ //apparel
          		priceEach = document.getElementById("lblPrice").innerHTML;
          	}
            var colorSelected = document.getElementById("colorSelected").value;
  
            var qty = GetQty();
            var lblTotal = document.getElementById('lblTotal').innerHTML;
            document.getElementById('qtySummary').innerHTML = qty;
            document.getElementById('colorSummary').innerHTML = colorSelected;
  
            SetSummaryImprintColors();
  
            //get adhesive side selected
            if (document.querySelector(".PD_adhSideOptions")) {
              document.querySelector(".PD_adhSideOptions").parentNode.removeChild(document.querySelector(".PD_adhSideOptions"));
            }
            var adhesiveSide = document.getElementById('adhSideOptions').querySelectorAll('div').length;
            if (adhesiveSide > 0) {
              var adhesiveType = document.getElementById('adhSideOptions').querySelector('label').value;
  
              var adhesiveSideSelected;
              var adhesiveRadios = [].slice.call(document.getElementById("adhSideOptions").querySelectorAll("input"));
              adhesiveRadios.forEach(function (el, index, array) {
                if (el.checked) {
                  adhesiveSideSelected = el.value;
                }
              });
  
              document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="clear tinySpace"></div><div class="PD_adhSideOptions c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Adhesive Side</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="adhesiveSideSummary">' + adhesiveSideSelected + '</p></div>');
            }
  
            //get adhesive type selected
            if (document.querySelector(".PD_adhesiveOptions")) {
              document.querySelector(".PD_adhesiveOptions").parentNode.removeChild(document.querySelector(".PD_adhesiveOptions"));
            }
            var adhesiveType = document.getElementById('adhesiveOptions').querySelectorAll('div').length;
            if (adhesiveType > 0) {
              var adhesiveTypeSelected = document.getElementById('adhesiveOptions').querySelector('label').innerHTML;
  
              var adhesiveSideSelected;
              var adhesiveSideRadios = [].slice.call(document.getElementById("adhesiveOptions").querySelectorAll("input"));
              adhesiveSideRadios.forEach(function (el, index, array) {
                if (el.checked) {
                  adhesiveSideSelected = el.value;
                }
              });
  
              document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="clear tinySpace"></div><div class="PD_adhesiveOptions c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Adhesive Type</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="adhesiveTypeSummary">' + adhesiveTypeSelected + ' : ' + adhesiveSideSelected + '</p></div>');
            }
  
            //get nib type selected
            if (document.querySelector(".PD_NibTypeSummary")) {
              document.querySelector(".PD_NibTypeSummary").parentNode.removeChild(document.querySelector(".PD_NibTypeSummary"));
            }
            var nibType = document.getElementById('nibOptions').querySelectorAll('div').length;
            if (nibType > 0) {
              var nibTypeSelected;
              var nibRadios = [].slice.call(document.getElementById("nibOptions").querySelectorAll("input"));
              nibRadios.forEach(function (el, index, array) {
                if (el.checked) {
                  nibTypeSelected = el.value;
                }
              });
  
              document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="clear tinySpace"></div><div class="PD_NibTypeSummary c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Tip Size</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="nibTypeSummary">' + nibTypeSelected + '</p></div>');
            }
  
            //get ink color selected
            if (document.querySelector(".PD_inkColorSummary")) {
              document.querySelector(".PD_inkColorSummary").parentNode.removeChild(document.querySelector(".PD_inkColorSummary"));
            }
            var inkColors = document.getElementById('inkColorOptions').querySelectorAll('div').length;
            if (inkColors > 0) {
              var inkColorSelected;
              var inkRadios = [].slice.call(document.getElementById("inkColorOptions").querySelectorAll("input"));
              inkRadios.forEach(function (el, index, array) {
                if (el.checked) {
                  inkColorSelected = el.value;
                }
              });
              document.getElementById('colorSummary').parentNode.insertAdjacentHTML('afterend', '<div class="clear tinySpace"></div><div class="PD_inkColorSummary c-sm-quarter-2 c-xs-full floatLeft"><p class="textsemibold">Writing Ink ' + localizedJS.ColorCap + '</p></div><div class="c-sm-quarter-2 c-xs-full floatLeft"><p class="floatRightOnMedium" id="inkColorSummary">' + inkColorSelected + '</p></div>');
            }
  
            var OrderSummary = {
              ProductID: prodID,
              Quantity: qty,
              ImprintColors: arrImprintColorsIDs,
              ImprintLocations: arrImprintLocationIDs,
              SelectedSizes: selectedSizes,
              BaseColorID: baseTrimColor[0],
              TrimColorID: baseTrimColor[1],
              EditID: editID,
              ProductImprintLocations: arrProductImprintLocationIDs,
              NibColorAttributeID: GetNibColorAttributeID(),
              AdhesiveAttributeID: GetAdhesiveAttributeID(),
              SelectedOptionalExtras: selectedOptionalExtras,
              IsReorder: document.getElementById("isReorder").value.toLowerCase() === 'true'  // jag
            };
  
            document.querySelector('.cartLoadingImg').style.display = "block";
            document.querySelector('.cartError').innerHTML = '';
            var addToCartRequest = ajax({
              url: "/productmvc/addtocart",
              method: "POST",
              headers: antiForgeryToken,
              data: OrderSummary
            }).then(function (response, xhr) {
              if (response.success == "true") {
                OmniLogCartAdd(response.newCart == undefined ? true : response.newCart);
                //Item Summary will be disabled for now.
                //$('.PD_Step_2').fadeOut('slow', function () {
                //    $('.PD_Summary').fadeIn('100', function () {
                //        $('.PD_Summary').removeClass('hide');
                //        ScrollToElement('.PD_Summary', 500);
                //    });
                //}); 
                //This might be added back in the future. JWW 10/24
                cartUrl = response.redirectUrl;
                if (document.getElementById('HideAdvertisedPrice').value == 'True') {
                  if (editID < 0) {
                    editID = response.cartItemID;
  
                    //cart MS uses Sequence instead of CartItemID
                    // removing as of 10/29/19 as restricted items weren't being deleted from cart
                    /*if (response.sequence > 0) {
                      editID = response.sequence;
                    }*/
                    document.querySelector('.cartLoadingImg').style.display = "none";
                    RestrictedPricing.Open(response.cartID, editID);
                  } else {
                    window.location.href = response.redirectUrl;
                  }
                } else {
                  window.location.href = response.redirectUrl;
                }
              } else {
                document.querySelector('.cartLoadingImg').style.display = "none";
                document.querySelector('.cartError').innerHTML = '<div aria-live="polite" role="status">There was an error adding item to Cart. Please try again!</div>';
              }
              processing = false;
            }).catch(function (response, xhr) {
              document.querySelector('.cartError').innerHTML = '<div aria-live="polite" role="status">There was an error adding item to Cart. Please try again!</div>';
              document.querySelector('.cartLoadingImg').style.display = "none";
              processing = false;
            });
          },
          checkForReorderChanges = function () {
            var isReorder = document.getElementById("isReorder").value.toLowerCase() === 'true';
  
            if (!isReorder || editID < 1) {
              return;
            }
  
            var originalImprintLocationCount = parseInt(document.getElementById("reorderImprintCount").value);
            var originalImprintColorCount = parseInt(document.getElementById("reorderImprintColorCount").value);
  
            if (originalImprintLocationCount !== listImprintLocationIDs.length || originalImprintColorCount !== CountImprintColors(listSelectedColors)) {
  
              var selectedOptionalExtras = document.getElementById('SelectedOptionalExtras').value;
              var baseTrimColor = selBaseTrim.value.split('/');
  
              var OrderSummary = {
                ProductID: prodID,
                Quantity: GetQty(),
                ImprintColors: listSelectedColors,
                ImprintLocations: listImprintLocationIDs,
                BaseColorID: baseTrimColor[0],
                TrimColorID: baseTrimColor[1],
                EditID: editID,
                ProductImprintLocations: listProductImprintLocationIDs,
                NibColorAttributeID: GetNibColorAttributeID(),
                AdhesiveAttributeID: GetAdhesiveAttributeID(),
                SelectedOptionalExtras: selectedOptionalExtras,
                IsReorder: isReorder
              };
  
              ajax({
                method: "POST",
                url: "/product/setupcharge",
                data: OrderSummary,
                headers: antiForgeryToken
              }).then(function (response, xhr) {
                if (response.message) {
                  document.getElementById('reorderAlertBox').classList.add('alertWarning');
                  document.getElementById('reorderExtraAmount').innerHTML = response.message;
                  document.getElementById('reorderAlertBox').scrollIntoView({
                    behavior: "smooth"
                  });
                }
              }).catch(function (response, xhr) {
                document.getElementById('reorderExtraAmount').innerHTML = 'Sorry an error occured retrieving setup charges.';
              });
            } else {
              document.getElementById('reorderAlertBox').classList.remove('alertWarning');
              document.getElementById('reorderExtraAmount').innerHTML = '';
            }
          },
          // remove any trailing slash in URL to prevent 301 redirect to HTTP protocol which causes ASE to block request
          removeTrailingSlash = function (url) {
            if (url.charAt(url.length - 1) === "/") {
              url = url.substring(0, url.length - 1);
            }
            return url;
          };
        return {
          GetCustomerImagePage: getCustomerImagePage,
          GetQAPage: getQAPage,
          GetStoryPage: getStoryPage,
          GetReviewPage: getReviewPage,
          GetFitRatingPage: getFitRatingPage,
          LoadSizing: loadSizing,
          LoadOptionalExtras: loadOptionalExtras,
          ReviewChange: reviewChange,
          ReviewFilterChange: reviewFilterChange,
          DeleteRestrictedCart: deleteRestrictedCart,
          GetJumpToColors: getJumpToColors,
          LoadAdhesiveOptions: loadAdhesiveOptions,
          LoadNibInkColor: loadNibInkColor,
          SampleRequest: sampleRequest,
          FitRatingChange: fitRatingChange,
          SubmitQuestion: submitQuestion,
          PositiveReview: positiveReview,
          NegativeReview: negativeReview,
          PositiveAnswer: positiveAnswer,
          NegativeAnswer: negativeAnswer,
          SubmitAnswer: submitAnswer,
          SubmitQuickAnswer: submitQuickAnswer,
          LoadMiniRating: loadMiniRating,
          GetRelatedProducts: getRelatedProducts,
          GetDetailTabs: getDetailTabs,
          GetItemCategories: getItemCategories,
          GetTabbedScroller: getTabbedScroller,
          GetAlternativeItems: getAlternativeItems,
          GetAlternativeItemsList: getAlternativeItemsList,
          GetPropSixtyFive: getPropSixtyFive,
          UpdateOptionalExtraPrice: updateOptionalExtraPrice,
          GetExtras: getExtras,
          AddToCart: addToCart,
          CheckForReorderChanges: checkForReorderChanges
        };
      })();
  
    function GetAdhesiveAttributeID() {
  
      var adhesiveAttributeID;
  
      if (document.getElementById("adhSideOptions").querySelectorAll("input[type='radio']:checked").length > 0) {
        // example item: 3832-S
        adhesiveAttributeID = adhesiveInput.value;  // holds the real value, need to make sure a side was selected
      }
  
      if ((adhesiveAttributeID == "" || adhesiveAttributeID == undefined) && document.getElementById("adhesiveOptions").querySelectorAll("input[type='radio']:checked").length > 0) {
        // example item: 3832-M
        adhesiveAttributeID = adhesiveInput.value; // holds the real value, need to make sure an option was selected
      }
      
      return adhesiveAttributeID;
    }
  
  
    function GetNibColorAttributeID() {
      var checkedNibColor = "";
      var nibColorChecks = [].slice.call(document.getElementById("inkColorOptions").querySelectorAll("input"));
      nibColorChecks.forEach(function (el, index, array) {
        if (el.checked) {
          checkedNibColor = el;
        }
      });
      var nibColorAttributeID;
      if (checkedNibColor != "") {
        nibColorAttributeID = checkedNibColor.parentNode.querySelector(".inkColorValue").value;
      }
  
      return nibColorAttributeID;
    }
  
    function clearSizesEvent() { //TODO is this repeated twice?
      document.getElementsByClassName('clearAllSizes')[0].addEventListener('click', function (e) {
        e.preventDefault();
        animate.fadeOut(document.getElementsByClassName('moreSizes')[0]);
        [].forEach.call(document.getElementsByClassName('moreSizes')[0].getElementsByClassName('txtApparelQty'), function (el) { el.value = ''; });
        var newLabel = this.value.replace('Clear All', 'Add');
        this.value = newLabel;
        this.classList.remove('clearAllSizes');
        this.classList.add('addMoreSizes');
        addSizesEvent();
        CalcPrice();
      });
    }
  
    function addSizesEvent() { //TODO is this repeated twice?
      document.getElementsByClassName("addMoreSizes")[0].addEventListener('click', function (e) {
        e.preventDefault();
        animate.fadeIn(document.getElementsByClassName('moreSizes')[0]);
        var newLabel = this.value.replace('Add', 'Clear All');
        this.value = newLabel;
        this.classList.remove('addMoreSizes');
        this.classList.add('clearAllSizes');
        clearSizesEvent();
      });
    }
  
    function sizeInputsEvent() { //TODO is this repeated twice?
       var apparelQty = [].slice.call(document.getElementsByClassName('txtApparelQty'));
        apparelQty.forEach(function (el, index, array) {
          el.classList.remove("input-validation-error");
          el.removeAttribute('aria-invalid');
        });
      
      var thisQty = 0;
      if (isNumeric(this.value)) {
        apparelQty.forEach(function (el, index, array) {
          if (el.value != '') {
            if (isNumeric(this.value)) {
              thisQty += parseInt(this.value);
            }
          }
        });
      } else {
        this.value = '';
        return false;
      }
      var updateDelay = (thisQty < lowestQty) ? 750 : 600;
      txtTimer = setTimeout(function () {
        if (isGFeed) {
          document.getElementById('GFeedPanel').style.display = "none";
          document.getElementById("pricingarea").classList.remove("hide");
        }
        if (document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0]) {
          document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0].parentNode.removeChild(document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0]);
        }
        CalcPrice();
      }, updateDelay);
      return true;
    }
  
    var validateSelections = function () {
      if (listImprintLocationIDs.length == 0) {
        document.querySelector('.imprint-location').insertAdjacentHTML('beforebegin', '<div class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="imprintError" class="btnToHyp text16 underline marginTop10">Please select at least one imprint location and one imprint ' + localizedJS.Color + '.</button></div>');
        document.getElementById("imprintError").focus();
        document.getElementById("imprintError").addEventListener("click", function(e){
        	e.preventDefault();
        	document.querySelector('.imprint-location').querySelector('input').focus();
        });
        
        processing = false;
        return false;
      }
  
      if (listSelectedColors.length == 0 && totalImprintColors > 0) {
        document.querySelector('.imprint-location').insertAdjacentHTML('beforebegin', '<div class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="imprintColorError" class="btnToHyp text16 underline marginTop10">Please select at least one imprint ' + localizedJS.Color + '.</button></div>');
        document.getElementById("imprintColorError").focus();
        document.getElementById("imprintColorError").addEventListener("click", function(e){
        	e.preventDefault();
        	document.querySelector('.imprint-location').querySelector('input').focus();
        });

        processing = false;
        return false;
      }
      if (listSelectedColors.length !== listImprintLocationIDs.length && totalImprintColors > 0) {
        document.querySelector('.imprint-location').insertAdjacentHTML('beforebegin', '<div class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="imprintColorError2" class="btnToHyp text16 underline marginTop10">Please select at least one imprint ' + localizedJS.Color + '.</button></p>');
        document.getElementById("imprintColorError2").focus();
        document.getElementById("imprintColorError2").addEventListener("click", function(e){
        	e.preventDefault();
        	document.querySelector('.imprint-location').querySelector('input').focus();
        });
        
        processing = false;
        return false;
      }
      return true;
    };
  
    function lazyLoadFix() {
      setTimeout(function () {
        lazyloadImages.update();
      }, 800);
    }
  
    function initProductColorSlider() {
      prodColorSlider = new tns({
        container: '.prodColorSlider',
        mouseDrag: true,
        prevButton: document.getElementById('prodColorPrev'),
        nextButton: document.getElementById('prodColorNext'),
        items: 2,
        gutter: 10,
        loop: false,
        lazyload: true,
        slideBy: "page",
        nav: false,
        responsive: {
          1024: {
            items: 5
          },
          700: {
            items: 4
          },
          480: {
            items: 3
          }
        }
      });
      return prodColorSlider;
    }
  
    function rebuildProdColorSlider() {
      initProductColorSlider();
      prodColorSlider.destroy();
      prodColorSlider = prodColorSlider.rebuild();
    }
  
    function initProductColorScroller() {
      if (document.getElementById("productColorScroller")) {
        initProductColorSlider();
      }
      var imageColorChoices = [].slice.call(document.getElementsByClassName("imgBox"));
      imageColorChoices.forEach(function (el, index, array) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var triggerImg = el;
          SaveProdColor(triggerImg);
        });
      });
    }
  
    function initHandlers() {
      window.addEventListener("load", function () {
        lazyLoadFix();
      });
      if (!window.addEventListener && window.attachEvent) {
        window.attachEvent('load', lazyLoadFix);
      }
  
      var extraProdImgs = [].slice.call(document.getElementsByClassName("DetailsProdImg"));
      extraProdImgs.forEach(function (el, index, array) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
        });
      });
  
      var thumbSelectImgs = [].slice.call(document.getElementsByClassName("otherImagesJS"));
      thumbSelectImgs.forEach(function (el, index, array) {
        var image = el.querySelector("img");
        el.addEventListener("click", function (e) {
          var vals = image.id.split('_');
          mainImgSlider.goTo(vals[1]);
        });
      });
  
      mainImgSlider.events.on('indexChanged', function () {
        var index = mainImgSlider.getInfo().index;
        setBkgdBorderAndNextImage(index);
      });

      function getIsExclSiblings(elem) {
        var siblings = [];
        while (elem) {
          if (elem.nodeType === Node.ELEMENT_NODE && elem.classList.contains('inputIsExcl'))
            siblings.push(elem);
          elem = elem.nextElementSibling || elem.nextSibling;
        }
        return siblings;
      }
  
      var imprintCheckBoxes = [].slice.call(document.getElementsByClassName('chkbxImprintLocation'));
      imprintCheckBoxes.forEach(function (el, index, array) {
        el.addEventListener("click", function (e) {
          if (document.getElementById('GFeedData')) {
            document.getElementById('GFeedData').style.display = 'none';
          }
          document.getElementsByClassName('imprintButtonExtras')[0].classList.remove('hide');
          ResetImprintCharges();
          if (el.checked) {
            if (totalImprintColors > 0 && el.parentNode.getElementsByClassName('colorChipsCount')[0].value != '1') {
              animate.fadeIn(el.parentNode.parentNode.getElementsByClassName("imprint-colors-content")[0]);
              el.setAttribute("aria-expanded", "true");
            }
            if (getIsExclSiblings(el)[0].value == "True") {
              imprintCheckBoxes.forEach(function (elem) {
                if (el != elem) {
                  elem.checked = false;
                  animate.fadeOut(elem.parentNode.parentNode.getElementsByClassName("imprint-colors-content")[0]);
                  el.setAttribute("aria-expanded", "false");
                }
              });
            } else {
              imprintCheckBoxes.forEach(function (elem) {
                if (elem.checked && getIsExclSiblings(elem)[0].value == "True") {
                  elem.checked = false;
                  animate.fadeOut(elem.parentNode.parentNode.getElementsByClassName("imprint-colors-content")[0]);
                  el.setAttribute("aria-expanded", "false");
                }
              });
            }
          } else {
            if (el.parentNode.parentNode.getElementsByClassName('clearAllColors')[0]) {
              el.parentNode.parentNode.getElementsByClassName('clearAllColors')[0].click();
            }
            animate.fadeOut(el.parentNode.parentNode.getElementsByClassName('imprint-colors-content')[0]);
            if (totalImprintColors != undefined && totalImprintColors > 0) {
            	el.setAttribute("aria-expanded", "false");
            }
          }
          ValidateCustomizeSections();
        });
        el.addEventListener("keyup", function (e) {
          if (e.type == 'keyup' && (e.which != 13)) {
            return;
          }
          el.click();
        });
      });
  
      // not sure if this is used anymore
      if (document.getElementsByClassName('PD_QuantityBtnCell')[0]) {
        var qtyCellInputs = [].slice.call(document.getElementsByClassName('PD_QuantityBtnCell')[0].getElementsByTagName('input'));
        qtyCellInputs.forEach(function (el, index, array) {
          el.addEventListener("click", function () {
            if (!variableDefined('searchClicked') || (variableDefined('searchClicked') && searchClicked == false)) {
              document.getElementById('GFeedPanel').style.display = "none";
              SetQuantity();
              return false;
            }
          });
        });
      }
  
      if (document.getElementsByClassName('sampleRequest1')[0]) {
        document.getElementsByClassName('sampleRequest1')[0].addEventListener("click", function (e) {
          e.preventDefault();
          ajaxActions.SampleRequest();
        });
      }
  
      if (document.getElementsByClassName('addColors').length > 0) {
        var addColors = document.getElementsByClassName('addColors');
        for (var i = 0; i < addColors.length; i++) {
          addColors[i].addEventListener("click", UnlockMoreColors);
        }
      }
  
      if (document.getElementsByClassName('clearAllColors').length > 0) {
        var clearColors = document.getElementsByClassName('clearAllColors');
        for (var i = 0; i < clearColors.length; i++) {
          clearColors[i].addEventListener("click", ClearImprintColors);
        }
      }
  
      var colorChipSquare = [].slice.call(document.getElementsByClassName('spnColorChip'));
      colorChipSquare.forEach(function (el, index, array) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          SaveImprintColor(el);
        });
        el.addEventListener('keydown', function (e) {
          if (e.type == 'keydown' && (e.keyCode != 13)) {
            return;
          }
          el.click();
        });
      });
  
      var calcExtraBtns = [].slice.call(document.getElementsByClassName('calcExtrasBtn'));
      calcExtraBtns.forEach(function (el, index, array) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          if (el.parentNode.getElementsByClassName('extrasLoadingImg')[0]) {
            el.parentNode.getElementsByClassName('extrasLoadingImg')[0].classList.remove('hide');
          }
          if (el.parentNode.getElementsByClassName('extrasResult')[0].style.display == 'none') {
            el.value = 'Hide Imprint Charges';
            ajaxActions.GetExtras(el);
          } else {
            el.value = 'Show Imprint Charges';
            el.parentNode.getElementsByClassName('extrasResult')[0].style.display = "none";
            el.setAttribute("aria-expanded", "false");
          }
          if (el.parentNode.getElementsByClassName('extrasLoadingImg')[0]) {
            el.parentNode.getElementsByClassName('extrasLoadingImg')[0].classList.add('hide');
          }
        });
      });
  
      if (document.getElementsByClassName("skipMoreColors")[0]) {
        document.getElementsByClassName("skipMoreColors")[0].addEventListener('click', function (e) {
          e.preventDefault();
          this.parentNode.lastChild.getElementsByClassName('clearAllColors')[0].focus();
        });
  
        document.getElementsByClassName("skipMoreColors")[0].addEventListener('keyup', function (e) {
          if (((e.which && e.which == 9) || (e.keyCode && e.keyCode == 9)) && e.shiftKey) { }
          if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
            this.click();
          }
        });
      }
  
  
      imprintColorHandlers();
  
  
      if (document.getElementsByClassName('btnAddToCart')[0]) {
        document.getElementsByClassName('btnAddToCart')[0].addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
  
          if (!processing) {
            processing = true;
            ajaxActions.AddToCart();
          }
        });
      }
  
      if (document.getElementById('hypMoreDetails')) {
        document.getElementById('hypMoreDetails').addEventListener("click", function (e) {
          e.preventDefault();
          document.getElementsByClassName('prodDetails')[0].scrollIntoView({
            behavior: "smooth"
          });
        });
      }
  
      window.addEventListener("resize", clearFloat);
    }
  
    function imprintColorHandlers() {
      var clearImprintColorBtns = [].slice.call(document.getElementsByClassName("imprintClearColor"));
      var firstBtn = clearImprintColorBtns[0];
  
      function keyDownEvent(e) {
        var el = e.currentTarget;
        if (((e.which && e.which == 9) || (e.keyCode && e.keyCode == 9)) && !e.shiftKey) {
          var sectionDiv = el.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
          var imprintLocDiv = sectionDiv.getElementsByClassName("imprint-location")[0];
          var element = imprintLocDiv.querySelectorAll('.imprintColorID[value=""]')[0].parentNode.getElementsByClassName('imprintClearColor')[0];
          var firstColor = imprintLocDiv.getElementsByClassName('imprintClearColor')[0];
  
          if (element === firstBtn && firstBtn !== firstColor) {
            e.preventDefault();
            var sectionDiv = element.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
            sectionDiv.getElementsByClassName("imprint-location")[0].getElementsByClassName('skipMoreColors')[0].focus();
          }
        }
      }
  
      clearImprintColorBtns.forEach(function (el, index, array) {
        el.removeEventListener("click", DeleteImprintColor);
        el.addEventListener("click", DeleteImprintColor);
        el.removeEventListener("keydown", keyDownEvent);
        el.addEventListener("keydown", keyDownEvent);
      });
    }
  
    function pricingHandlers() {
      function checkSizeInput(e) {
        var el = e.currentTarget;
        var allInputs = [].slice.call(document.getElementsByClassName("txtApparelQty"));
        allInputs.forEach(function (el, index, array) {
        	el.classList.remove("input-validation-error");
        	el.removeAttribute('aria-invalid');
        });
        if (IsNumeric(el.value)) {
          var thisQty = 0;
          allInputs.forEach(function (el, index, array) {
            if (el.value != '') {
              if (IsNumeric(el.value)) {
                thisQty += parseInt(el.value);
              }
            }
          });
          var updateDelay = (thisQty < lowestQty) ? 750 : 600;
          txtTimer = setTimeout(function () {
            if (document.getElementById("GFeedPanel")) {
              document.getElementById("GFeedPanel").style.display = "none";
            }
            var hiddenInput = document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0];
            if (hiddenInput) hiddenInput.parentNode.removeChild(hiddenInput);
            document.getElementById("pricingarea").classList.remove("hide");
            CalcPrice();
          }, updateDelay);
        } else {
          el.value = '';
          el.focus();
          return false;
        }
        return true;
      }
  
      var sizeInputs = [].slice.call(document.getElementsByClassName("txtApparelQty"));
      sizeInputs.forEach(function (el, index, array) {
        el.addEventListener("keyup", checkSizeInput);
        el.addEventListener("focusout", checkSizeInput);
      });
    }
  
    function OmniLogCartAdd(newCart) {
      if (typeof s != "undefined") {
        s.events = (newCart) ? 'scOpen, scAdd' : 'scAdd';
        /************* DO NOT ALTER ANYTHING BELOW THIS LINE ! **************/
        var s_code = s.t();
        if (s_code) document.write(s_code);
      }
    }
  
   
	var ImageZoom = (function () {
        	var zoomImages = [].slice.call(document.querySelectorAll(".prodImage")),
        	productImages = [].slice.call(document.querySelectorAll(".DetailsProdImg")),
        	increment = 40,
        	zoomSliderHTML,
        	dialogTriggerEl,
        	init = function () {
            		zoomImages.forEach(function (el, index, array) {
                		el.removeEventListener("mousemove", zoomThis);
                		el.removeEventListener("mouseleave", removeZoom);
                		el.addEventListener("mousemove", zoomThis);
                		el.addEventListener("mouseleave", removeZoom);
            		});

            		document.getElementById("zoomOutMain").removeEventListener("click", zoomOut);
            		document.getElementById("zoomOutMain").addEventListener("click", zoomOut);
           	 	document.getElementById("zoomInMain").removeEventListener("click", zoomIn);
            		document.getElementById("zoomInMain").addEventListener("click", zoomIn);
			
			 /* temporary until zoom dialog is approved on desktop */
			document.getElementById("panLeftMain").removeEventListener("click", moveZoomLeft);
            		document.getElementById("panLeftMain").addEventListener("click", moveZoomLeft);
            		document.getElementById("panRightMain").removeEventListener("click", moveZoomRight);
            		document.getElementById("panRightMain").addEventListener("click", moveZoomRight);
            		document.getElementById("panUpMain").removeEventListener("click", moveZoomUp);
            		document.getElementById("panUpMain").addEventListener("click", moveZoomUp);
            		document.getElementById("panDownMain").removeEventListener("click", moveZoomDown);
            		document.getElementById("panDownMain").addEventListener("click", moveZoomDown);

            		mainImgSlider.events.on('transitionStart', function () {
                		if (document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").hasAttribute("style")) {
                    			removeZoom();
                		}
                		if (document.getElementById("zoomInMain").classList.contains("hide")) {
                    			document.getElementById("zoomOutMain").click();
                		}
            		});
            		
            		if(window.innerWidth <= 800){
            			// initiate zoom dialog on mobile & tablet since mouse events may not be registered
            			productImages.forEach(function(el, index, array){
					el.removeEventListener("click", openZoomDialog);
					el.addEventListener("click", openZoomDialog);
					el.setAttribute("aria-haspopup", "true");
					el.setAttribute("aria-expanded", "false");
					el.setAttribute("aria-describedby", "tapDescription");
				});
				zoomDialog.init(document.getElementById("zoomDialog"));
            		}else{  /* temporary until zoom dialog is approved on desktop */
            			productImages.forEach(function(el, index, array){
					el.removeAttribute("aria-haspopup");
					el.removeAttribute("aria-expanded");
					el.removeAttribute("aria-describedby");
				});
            		}
        	},
        	zoomThis = function (e) {
            		var el = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg"); // img parent div
            		el.getElementsByTagName("img")[0].style.opacity = "0";
            		if (el.style.backgroundImage == "") { // no need to assign this with every move of mouse
                		el.style.backgroundImage = "url(" + el.getAttribute("href") + ")";
            		}
            		var offsetX = e.offsetX;
            		var offsetY = e.offsetY;
            		
	            	var x = offsetX / el.offsetWidth * 100;
	            	var y = offsetY / el.offsetHeight * 100;
	            	el.style.backgroundPositionX = x + '%';
	            	el.style.backgroundPositionY = y + '%';
	            	el.style.backgroundRepeat = "no-repeat";
        	},
        	removeZoom = function (e) {
            		var el = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg"); // img parent div
            		el.removeAttribute("style"); // remove background styles
            		el.getElementsByTagName("img")[0].removeAttribute("style"); // remove 0 opacity
        	},
        	zoomOut = function (e) {
            		e.preventDefault();
           	 	var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
            		removeZoom();
            		document.querySelector(".moreGestures").classList.remove("show");
            		document.querySelector(".moreGestures").classList.add("hide");
            		if (document.querySelector(".otherImagesJS")) { // if arrows are showing in the first place
                		document.getElementById("leftArrowClick").style.display = "block";
                		document.getElementById("rightArrowClick").style.display = "block";
            		}
            		document.getElementById("zoomInMain").classList.remove("hide");
            		document.getElementById("zoomInMain").classList.add("show");
            		document.getElementById("zoomInMain").focus();
            		zoomImg.removeEventListener("mouseleave", closeZoom);
        	},
        	zoomIn = function (e) {
            		e.preventDefault();
            		var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
            		zoomImg.getElementsByTagName("img")[0].style.opacity = 0;
            		zoomImg.style.backgroundImage = "url(" + zoomImg.getAttribute("href") + ")";
            		zoomImg.style.backgroundPositionY = "-200px";
            		zoomImg.style.backgroundPositionX = "-200px";
            		zoomImg.style.backgroundRepeat = "no-repeat";
            		document.querySelector(".moreGestures").classList.remove("hide");
            		document.querySelector(".moreGestures").classList.add("show");
            		document.getElementById("zoomInMain").classList.remove("show");
            		document.getElementById("zoomInMain").classList.add("hide");
            		if (document.querySelector(".otherImagesJS")) { // if arrows are showing in the first place
                		document.getElementById("leftArrowClick").style.display = "none";
                		document.getElementById("rightArrowClick").style.display = "none";
            		}
            		document.getElementById("zoomOutMain").focus();
            		zoomImg.addEventListener("mouseleave", closeZoom);
        	},
        	closeZoom = function () {
            		document.getElementById("zoomOutMain").click();
        	},
        	moveZoomRight = function (e) {
            		e.preventDefault();
            		var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
            		var left = zoomImg.style.backgroundPositionX;
            		if (left.length > 2) {
                		var leftNum = +left.substring(0, left.length - 2);
                		if (leftNum > -321) {
                    			leftNum = leftNum - increment;
                    			if (leftNum < -321) {
                        			leftNum = -321;
                    			}
                		}
                		zoomImg.style.backgroundPositionX = leftNum + 'px';
            		}
        	},
        	moveZoomLeft = function (e) {
            		e.preventDefault();
            		var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
            		var left = zoomImg.style.backgroundPositionX;
            		if (left.length > 2) {
                		var leftNum = +left.substring(0, left.length - 2);
                		if (leftNum < 0) {
                    			leftNum = leftNum + increment;
                    			if (leftNum > 0) {
                        			leftNum = 0;
                    			}
                		}
                		zoomImg.style.backgroundPositionX = leftNum + 'px';
            		}
        	},
        	moveZoomUp = function (e) {
            		e.preventDefault();
            		var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
            		var top = zoomImg.style.backgroundPositionY;
            		if (top.length > 2) {
                		var topNum = +top.substring(0, top.length - 2);
                		if (topNum < 0) {
                    			topNum = topNum + increment;
                    			if (topNum > 0) {
                        			topNum = 0;
                    			}
                		}
                		zoomImg.style.backgroundPositionY = topNum + 'px';
            		}
        	},
        	moveZoomDown = function (e) {
            		e.preventDefault();
            		var zoomImg = document.getElementById("photoSwipeBox").querySelector(".tns-slide-active").querySelector(".DetailsProdImg");
            		var top = zoomImg.style.backgroundPositionY;
            		if (top.length > 2) {
                		var topNum = +top.substring(0, top.length - 2);
                		if (topNum > -401) {
                    			topNum = topNum - increment;
                    			if (topNum < -401) {
                        			topNum = -401;
                    			}
                		}
                		zoomImg.style.backgroundPositionY = topNum + 'px';
           	 	}
        	},
        	setUpZoomDialogScroller = function(){
			var mainImgSrc = document.querySelector(".mainProdImg").getAttribute("data-src").replace("/300/", "/700/");
			zoomSliderHTML = 
	    			'<div class="posRelative" aria-describedby="tapDescription">' +
	        			'<button class="zoomDialog-prev slider-prev" aria-label="Previous Image"><svg class="textDarkestGray rotate270" height="20px" width="20px"> <use xlink:href="#svgIcon-arrowLine"></use> </svg></button>' +
	        			'<div class="Scroller zoomDialogSlider marginTop20 floatLeft c-xs-quarter-2">' +
	            				'<div class="textCenter" data-zoom="' + mainImgSrc + '">' +
	                				'<img class="responsiveImg tns-lazy-img" data-src="' + mainImgSrc + '" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="Large Product Photo" />' +
	            				'</div>';
	            				
	            	var extras = [].slice.call(document.querySelectorAll(".extraProdImg"));
	            	for(var i = 0; i < extras.length; i++){
	            		var imageSrc = extras[i].getElementsByTagName("img")[0].getAttribute("data-src").replace("/300/", "/700/");
	            		var imageAlt = extras[i].getElementsByTagName("img")[0].getAttribute("alt");
	            		zoomSliderHTML += '<div class="textCenter" data-zoom="' + imageSrc + '"><img class="responsiveImg tns-lazy-img" data-src="' + imageSrc + '" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="' + imageAlt + '" /></div>';
	            	}	
	            	
			zoomSliderHTML += '</div>' +
	        			'<button class="zoomDialog-next slider-next" aria-label="Next Image"><svg class="textDarkestGray rotate90" height="20px" width="20px"> <use xlink:href="#svgIcon-arrowLine"></use> </svg></button>' +
	    			'</div>' +
	    			'<p id="tapDescription" class="text16 textCenter marginTop20">Use fingers to zoom</p>';
	    			
	    		return zoomSliderHTML;
		},
		openZoomDialog = function(e){
			e.preventDefault();
			document.getElementById("tapDescription").classList.add("hide");
			dialogTriggerEl = e.currentTarget;
			dialogTriggerEl.setAttribute("aria-expanded", "true");
			document.getElementById("zoomDialog").setAttribute("aria-hidden", "false");
			setUpZoomDialogScroller();
			document.getElementById("zoomWindow").innerHTML = zoomSliderHTML;
			document.getElementById("zoomDialog").querySelector("h2").textContent = "Viewing Larger " + document.querySelector("h1").textContent;
			
			zoomSlider = new tns({
			      container: document.querySelector('.zoomDialogSlider'),
			      rewind: true,
			      lazyload: true,
			      prevButton: document.querySelector('.zoomDialog-prev'),
			      nextButton: document.querySelector('.zoomDialog-next'),
			      speed: 500,
			      nav: true,
			      touch: false,
			      navPosition: "bottom"
			});
			var info = mainImgSlider.getInfo();
			var currentSlide = info.index;
			zoomSlider.goTo(currentSlide);

			zoomDialog.open();
			bindDialogEvents();
			
			//prevent vertical scrolling while open - works on desktop but not ios bummer
			document.body.style.overflow = "hidden";
			document.body.style.position = "fixed";
			
			disableSlideScroll(); //disabling scrolling on touch/drag so zooming with fingers on mobile does not trigger a slide change
		},
		closeZoomDialog = function(e){
			e.preventDefault();
			document.getElementById("tapDescription").classList.remove("hide");
			dialogTriggerEl.setAttribute("aria-expanded", "false");
			document.getElementById("zoomDialog").setAttribute("aria-hidden", "true");
			var info = zoomSlider.getInfo();
			var currentSlide = info.index;
			mainImgSlider.goTo(currentSlide);	
			document.getElementById("zoomWindow").innerHTML= "";	
			document.querySelector(".tns-nav-active").focus();
			document.body.removeAttribute("style"); //allow scrolling again
		},
		disableSlideScroll = function(){
			var preventDrag = function(){
				zoomSlider.event.stopPropagation();
			};
			zoomSlider.events.off("dragStart", preventDrag);
			zoomSlider.events.on("dragStart", preventDrag);
		},
		bindDialogEvents = function(){
			zoomSlider.events.on('transitionStart', function(){
				if(document.getElementById("zoomWindow").querySelector(".tns-slide-active").hasAttribute("style")){
					removeZoom();
				}
			});

	    		document.getElementById("zoomDialog").querySelector(".close4iDialog").removeEventListener("click", closeZoomDialog);
	    		document.getElementById("zoomDialog").querySelector(".close4iDialog").addEventListener("click", closeZoomDialog);
	    		
	    		document.getElementById("zoomDialog").addEventListener("keydown", function(e){
				if(e.which == 27){ // escape 
					closeZoomDialog(e);
					document.getElementById("zoomDialog").removeEventListener("keydown", [0]);
				}
			});
	    		
			var sliderNavBtns = [].slice.call(document.getElementById("zoomDialog").querySelector(".tns-nav").querySelectorAll("button"));
			sliderNavBtns.forEach(function(el, index, array){
		    		el.addEventListener("keydown", function(e){
		    			if(e.which == 9){
		    				document.getElementById("zoomDialog").querySelector(".close4iDialog").focus();
		    			}
		    		});
	    		});
	    	};
        	return {
            		Init: init
        	};
	})(); // end zoom
   
   
    function MobileTweaks() {
      if (isMobile) {
        var social = document.querySelectorAll(".SocialMediaButtons"); //need to return a nodelist to work
        var beforeProdDetails = document.querySelectorAll(".prodDetails");
        beforeProdDetails[0].parentNode.insertBefore(social[0], beforeProdDetails[0]);
  
        var relatedProds = document.querySelectorAll("#relatedProductsContainer");
        var lastElement = document.querySelectorAll(".back-to-top");
        lastElement[0].parentNode.insertBefore(relatedProds[0], lastElement[0]);
  
        document.getElementsByClassName("PD_Step_1")[0].classList.remove("borderDkGray");
        document.getElementsByClassName("PD_Step_2")[0].classList.remove("hide");
        if (document.querySelector('.glidePanel') !== null) {
          document.getElementsByClassName('glidePanel')[0].classList.add('marginTop10');
          document.getElementsByClassName('glidePanel')[0].classList.remove('marginTop40');
        }
      }
    }
  
    function FixIE11SVG() {
      var isIE11 = !!navigator.userAgent.match(/Trident\/7\./);
      if (isIE11) {
        var svgs = document.getElementsByTagName("svg");
        var i = svgs.length;
        while (i--) {
          svgs[i].setAttribute("focusable", "false");
        }
      }
    }
  
    function GetQty() {
      if (document.getElementById("txtQty")) {
        if (!isApparelItem) {
          return parseInt(document.getElementById("txtQty").value);
        } else {
          return parseInt(document.getElementById("txtQty").innerHTML);
        }
      }
    }
  
    function showHideTabs() {
      if (isApparelItem) {
        document.getElementById("fitRatingTS").classList.remove("hide");
      }
      if (localizedJS.showCustomerImages) {
        document.getElementById("customerImagesTS").classList.remove("hide");
      }
    }
  
    var showColorOptions = function () {
      document.getElementById('colorOptions').style.display = "block";
      document.getElementById('colorOptions').setAttribute('aria-hidden', 'false');
      document.getElementById('selectBaseColor').style.display = "block";
      document.getElementById('selectBaseColor').setAttribute('aria-hidden', 'false');
      document.getElementById('prodColorCountContainer').style.display = "none";
      document.getElementById('prodColorCountContainer').setAttribute('aria-hidden', 'true');
      document.getElementById('productColorScroller').style.display = "none";
      document.getElementById('productColorScroller').setAttribute('aria-hidden', 'true');
      document.getElementById('jumpToColor').style.display = "none";
      document.getElementById('jumpToColor').setAttribute('aria-hidden', 'true');
      tooltips.init(); // color tooltip
    };
  
    var jumpToColor = function (triggerElement) {
      var chosenColorID = '';
      var elementId;
      if (triggerElement == document.getElementById('removeColorFilter')) {
        chosenColorID = '-1';
      } else if (triggerElement.classList.contains('colorOption')) {
        elementId = triggerElement.id;
        chosenColorID = elementId.substring(11, elementId.indexOf('_')); // color ID is the number after "colorOption" and before the underscore
      } else {
        elementId = triggerElement.parentNode.id;
        chosenColorID = elementId.substring(11, elementId.indexOf('_'));
      }
      ajaxActions.GetJumpToColors(chosenColorID);
    };
  
    var jumpToTheColor = function (e) {
      e.preventDefault();
      showColorOptions();
      document.getElementById('colorOptions').getElementsByClassName('colorOption')[0].focus();
    };
  
    var colorOptionClick = function (e) {
      e.preventDefault();
      jumpToColor(this);
      rebuildProdColorSlider();
    };
  
    var colorOptionsClicksOff = function () {
      if (document.getElementById('jumpToColor')) {
        document.getElementById('jumpToColor').removeEventListener("click", jumpToTheColor);
      }
      var colorOpts = [].slice.call(document.getElementsByClassName('colorOption'));
      colorOpts.forEach(function (el, index, array) {
        el.removeEventListener("click", colorOptionClick);
      });
    };
  
    var colorOptionsClicks = function () {
      if (document.getElementById('jumpToColor')) {
        document.getElementById('jumpToColor').addEventListener("click", jumpToTheColor);
      }
  
      var colorOpts = [].slice.call(document.getElementsByClassName('colorOption'));
      colorOpts.forEach(function (el, index, array) {
        el.addEventListener("click", colorOptionClick);
      });
  
      if (document.getElementById('removeColorFilter')) {
        document.getElementById('removeColorFilter').addEventListener("click", function (e) {
          e.preventDefault();
          jumpToColor(this);
        });
      }
    };
  
    var isNumeric = function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    };
  
    function SaveImprintColor(triggerElement) {
      ResetImprintCharges();
  
      if (document.querySelector(".errorMsg")) {
        document.querySelector(".errorMsg").parentNode.removeChild(document.querySelector(".errorMsg"));
      }
      var selectedColor = triggerElement.style.backgroundColor;
      var colorTitle = triggerElement.getAttribute('title');
      var imprintLocID = triggerElement.parentNode.querySelector('.imprintLocationID').value;
      var imprintColorID = triggerElement.parentNode.querySelector('.imprintColorID').value;
      var productImprintLocationID = triggerElement.parentNode.querySelector('.productImprintLocationID').value;
      var child;
      var oneColor = true;
  
      var colorLists = [].slice.call(document.getElementsByClassName(imprintLocID)[0].querySelectorAll('.colorList'));
      var emptyColorBoxes = [];
      colorLists.forEach(function (el, index, array) {
        var rgbColor = el.querySelector('.imprintColorBox').style.backgroundColor;
        if (rgbColor == "rgba(0, 0, 0, 0)" || rgbColor == "transparent") {
          emptyColorBoxes.push(el);
          child = el.querySelector('.imprintColorBox');
        }
      });
      if (emptyColorBoxes.length > 0) {
        emptyColorBoxes[0].querySelector('.imprintLocationID').value = imprintLocID;
        emptyColorBoxes[0].querySelector('.imprintColorID').value = imprintColorID;
        emptyColorBoxes[0].querySelector('.productImprintLocationID').value = productImprintLocationID;
        emptyColorBoxes[0].querySelector('.imprintColorBox').style.backgroundColor = selectedColor;
        emptyColorBoxes[0].querySelector('.imprintColorBox').setAttribute('title', colorTitle);
        emptyColorBoxes[0].querySelector('.imprintClearColor').focus();
        oneColor = false;
      }
      if (oneColor && colorLists.length > 0) {
        child = document.getElementsByClassName(imprintLocID)[0].querySelector('.colorList').querySelector('.imprintColorBox');
        document.getElementsByClassName(imprintLocID)[0].querySelector('.colorList').querySelector('.imprintColorBox').style.backgroundColor = selectedColor;
        document.getElementsByClassName(imprintLocID)[0].querySelector('.colorList').querySelector('.imprintColorBox').setAttribute('title', colorTitle);
        document.getElementsByClassName(imprintLocID)[0].querySelector('.colorList').querySelector('.imprintClearColor').focus();
        document.getElementsByClassName(imprintLocID)[0].querySelector('.colorList').querySelector('.imprintLocationID').value = imprintLocID;
        document.getElementsByClassName(imprintLocID)[0].querySelector('.colorList').querySelector('.imprintColorID').value = imprintColorID;
        document.getElementsByClassName(imprintLocID)[0].querySelector('.colorList').querySelector('.productImprintLocationID').value = productImprintLocationID;
      }
  
      ValidateCustomizeSections();
    }
  
    var initCustomerImagesPages = function () {
      var pagingLinks = [].slice.call(document.getElementsByClassName('imagespageselect'));
      pagingLinks.forEach(function (el, index, array) {
        el.removeEventListener("click", ajaxActions.GetCustomerImagePage);
        el.addEventListener("click", ajaxActions.GetCustomerImagePage);
      });
    };
  
    var initQAPages = function () {
      var pagingLinks = [].slice.call(document.getElementsByClassName('qapageselect'));
      pagingLinks.forEach(function (el, index, array) {
        el.removeEventListener("click", ajaxActions.GetQAPage);
        el.addEventListener("click", ajaxActions.GetQAPage);
      });
    };
  
    var initSuccessPages = function () {
      var pagingLinks = [].slice.call(document.getElementsByClassName('storiespageselect'));
      pagingLinks.forEach(function (el, index, array) {
        el.removeEventListener("click", ajaxActions.GetStoryPage);
        el.addEventListener("click", ajaxActions.GetStoryPage);
      });
    };
  
    var initReviewPages = function () {
      var pagingLinks = [].slice.call(document.getElementsByClassName('reviewspageselect'));
      pagingLinks.forEach(function (el, index, array) {
        el.removeEventListener("click", ajaxActions.GetReviewPage);
        el.addEventListener("click", ajaxActions.GetReviewPage);
      });
    };
  
    function ResetImprintCharges() { 
      var extraButtons = [].slice.call(document.querySelectorAll(".calcExtrasBtn"));
      extraButtons.forEach(function(el, index, array){
      	  el.value = 'Show Imprint Charges';
      	  el.parentNode.querySelector(".extrasResult").innerHTML = "";
      	  el.parentNode.querySelector(".extrasResult").style.display = "none";
      	  var isHidden =  el.parentNode.querySelector(".extrasResult").style.display == 'none';
      	  return !isHidden;
      });
    }
  
    function SetSummaryImprintColors() {
      var newContent = "";
      if (listSelectedImprintLocationName.length > 0 && listSelectedColorsRGB.length > 0 && totalImprintColors > 0) {
        for (var i = 0; i < listSelectedImprintLocationName.length; i++) {
          newContent += "<div class='clear tinySpace'></div><h5 class='textsemibold'>Imprint Location</h5>" +
            "<p>" + listSelectedImprintLocationName[i] +
            "</p><div class='clear tinySpace'></div><h5 class='textsemibold'>Imprint " + localizedJS.ColorCap + "(s)</h5>";
          for (var j = 0; j < listSelectedColorsRGB[i].length; j++) {
            newContent += "<div class='imprintColorSummary floatLeft marginTop5 marginBtm20 marginRight5 borderDkGray' style='background-color: " + listSelectedColorsRGB[i][j] + "'></div>";
          }
        }
      } else if (totalImprintColors == 0) {
        for (var i = 0; i < listSelectedImprintLocationName.length; i++) {
          newContent += "<div class='clear tinySpace'></div><h5 class='c-sm-quarter-2 c-xs-full floatLeft textsemibold'>Imprint Location</h5>" +
            "<div class='c-sm-quarter-2 c-xs-full floatLeft'><p class='floatRightOnMedium'>" + listSelectedImprintLocationName[i] +
            "</p></div><div class='clear'></div>";
        }
      }
      var newContentDiv = document.createElement('div');
      newContentDiv.innerHTML = newContent;
      document.querySelector('.imprint-location-summary').insertBefore(newContentDiv, document.querySelector('.imprint-location-summary').firstChild);
    }
  
    function ValidateCustomizeSections() {
      GetSelectedImprintLocations();
      GetSelectedImprintColors();
      ajaxActions.CheckForReorderChanges();   // jag added
  
      var addToCartBtn = document.getElementsByClassName('btnAddToCart')[0];
      if (isMobile) { //because of design decision to show everything at once, need to make sure they've selected a product color
        if (document.getElementById('colorSelected').value == '') {
          addToCartBtn.classList.remove('bkgdRed');
          addToCartBtn.classList.remove('whiteLink');
          addToCartBtn.classList.add('disabledBtn');
          addToCartBtn.classList.add('bkgdMdGray');
          return false;
        }
      }
      if (listImprintLocationIDs.length > 0) {
        addToCartBtn.classList.remove('disabledBtn');
        addToCartBtn.classList.remove('bkgdMdGray');
        addToCartBtn.classList.add('bkgdRed');
        addToCartBtn.classList.add('whiteLink');
      }
    }
  
    function GetSelectedImprintLocations() {
      listImprintLocationIDs = [];
      listProductImprintLocationIDs = [];
      if (totalImprintColors == 0) {
        listSelectedImprintLocationName = [];
      }
  
      var locationChexBoxes = [].slice.call(document.getElementsByClassName("chkbxImprintLocation"));
      locationChexBoxes.forEach(function (el, index, array) {
        if (el.checked) {
          var x = [];
          var inputImpLocID = el.parentNode.getElementsByClassName('imprintLocationID')[0].value;
          var imprintLocationName = el.parentNode.getElementsByClassName('imprintLocationName')[0].value;
          var impl = null;
          var prodimploc = null;
          //unsure where this is in the DOM?
          var imprintColorsFound = el.parentNode.parentNode.getElementsByClassName('imprintColorsFound')[0] ? el.parentNode.parentNode.getElementsByClassName('imprintColorsFound')[0].value : "";
  
          if (totalImprintColors == 0) {
            listImprintLocationIDs.push(inputImpLocID);
            listSelectedImprintLocationName.push(imprintLocationName);
          } else {
            if (imprintColorsFound == undefined || imprintColorsFound == '') {
              var colorLists = [].slice.call(document.getElementsByClassName(inputImpLocID)[0].getElementsByClassName('colorList'));
              colorLists.forEach(function (el, index, array) {
                var imprintLocationID = el.getElementsByClassName('imprintLocationID')[0].value;
                var imprintColorID = el.getElementsByClassName('imprintColorID')[0].value;
                var productImprintLocationID = el.getElementsByClassName('productImprintLocationID')[0].value;
                if (imprintLocationID != undefined && imprintColorID != undefined && productImprintLocationID != undefined) {
                  if (imprintLocationID != "" && imprintColorID != "" && productImprintLocationID != "") {
                    impl = imprintLocationID;
                    prodimploc = productImprintLocationID;
                  }
                }
              });
            } else {
              impl = inputImpLocID;
            }
  
            if (impl != null) {
              listImprintLocationIDs.push(impl);
            }
            if (prodimploc != null) {
              listProductImprintLocationIDs.push(prodimploc);
            }
          }
        }
      });
    }
  
    function GetSelectedSizes() {
      //console.log("GetSelectedSizes");//
      var sizeHash = "";
      if (isApparelItem) {
        //console.log("isApparelItem true");
        var sizeOptions = [].slice.call(document.getElementsByClassName("sizeOptionQty"));
        //console.log("sizeOptions " + sizeOptions);
        sizeOptions.forEach(function (el, index, array) {
  
          var sizeQty = el.getElementsByClassName('txtApparelQty')[0].value;
          //console.log("sizeQty " + sizeQty);
          if (sizeQty != '' && sizeQty != undefined && sizeQty != '0') {
            var saPID = el.getElementsByClassName('sizeAttrProdID')[0].value;
            var saID = el.getElementsByClassName('sizeAttrID')[0].value;
            var qty = el.getElementsByClassName('txtApparelQty')[0].value;
            //console.log("saPID " + saPID);
            //console.log("saID " + saID);
            //console.log("qty " + qty);
            sizeHash += saPID + '-' + saID + '-' + qty + '|';
          }
        });
      }
      return sizeHash;
    }
  
    // jag
    function CountImprintColors(imprintColors) {
      var count = 0;
  
      imprintColors.forEach(function (colors) {
        count += colors.length;
      });
  
      return count;
    }
  
    function formatMoney(x) {
      return Number.parseFloat(x).toFixed(2);
    }
  
    function AddSelectedExtra(cb) {
      if (document.getElementsByClassName("GFeedPanel1")[0]) {
        document.getElementsByClassName("GFeedPanel1")[0].parentNode.removeChild(document.getElementsByClassName("GFeedPanel1")[0]);
      }
      var currentselection = document.getElementById('SelectedOptionalExtras'); // this holds all the selected extras in '*11, *33,'
      if (cb.checked) {
        if (currentselection.value.indexOf('*' + cb.value + ',') == -1) {
          newExtra = currentselection.value + '*' + cb.value + ',';
          currentselection.value = newExtra;
        }
      } else {
        // remove from if is there
        if (currentselection.value.indexOf('*' + cb.value + ',') != -1) {
          currentselection.value = currentselection.value.replace('*' + cb.value + ',', '');
          document.getElementById('selectedOptionalExtraResult').style.display = "none";
          return false;
        }
      }
  
      document.getElementsByClassName('optionalExtrasLoadingImg')[0].style.display = "block";
      document.getElementById('selectedOptionalExtraResult').style.display = "none";
      ajaxActions.UpdateOptionalExtraPrice(); // add to the total
    }
  
    function ResetCalcExtras() {
      document.getElementsByClassName('extrasLoadingImg')[0].style.display = "none";
      animate.fadeOut(document.querySelector(".extrasResult"));
      animate.fadeIn(document.querySelector(".calcExtrasBtn"));
      animate.slideUp(document.getElementById('selectedExtras'));
    }
  
    function SaveProdColor(triggerElement) {
      if (document.querySelector(".errorMsg")) {
        document.querySelector(".errorMsg").parentNode.removeChild(document.querySelector(".errorMsg"));
      }
      var selectedImg;
      if (triggerElement.querySelector('img')) {
        selectedImg = triggerElement.querySelector('img').getAttribute('data-src');  // jag - use data-src attribute instead of src do to lazy loading
      } else if (triggerElement.getAttribute('src')) {
        selectedImg = triggerElement.getAttribute('src');
      } else if (triggerElement.getAttribute('data-lazy')) {
        selectedImg = triggerElement.getAttribute('data-lazy');
      } else if (recolorAvailable.value == "True") {
        selectedImg = triggerElement.parentNode.getAttribute('href').replace("rend/700", "rend/300");
      }
      var selectedBaseTrimID = "";
      var selectedColorName = "";
      var trimColorHex = "";
      var baseColorHex = "";
      mainImgSlider.goTo(0);
      var prodColorImgs = [].slice.call(document.querySelectorAll(".imgBox"));
      if (recolorAvailable.value == "True") {
        if (document.querySelector('.imgActive')) { // remove previous active image
          document.querySelector('.imgActive').setAttribute("aria-selected", "false");
          document.querySelector('.imgActive').classList.remove("imgActive");
        }
        triggerElement.classList.add('imgActive');
        triggerElement.setAttribute("aria-selected", "true");
        
        if (selectedImg){ 
       	 document.getElementById('hypProdImg').querySelector('.mainProdImg').setAttribute("src", selectedImg.replace("rend/60", "rend/300"));
        	document.getElementById('hypProdImg').querySelector('.mainProdImg').setAttribute("data-src", selectedImg.replace("rend/60", "rend/300"));
	 	 document.getElementById('hypProdImg').setAttribute("href", selectedImg.replace("rend/60", "rend/700")); 
        	//selectedImg = selectedImg.replace("rend/300", "rend/700");
        	//document.getElementById('hypProdImg').setAttribute("href", selectedImg);
      }
  
        document.getElementById('colorSelected').value = triggerElement.getAttribute("title");
        selectedBaseTrimID = triggerElement.parentNode.querySelector('.selectedColorID').value;
        document.getElementById('colorSummary').textContent = triggerElement.getAttribute('title');
        selectedColorName = triggerElement.parentNode.querySelector('.selectedColorName').value;
        baseColorHex = triggerElement.parentNode.querySelector('.baseColorHex').value;
        trimColorHex = triggerElement.parentNode.querySelector('.trimColorHex').value;
      } else {
        selectedBaseTrimID = triggerElement.parentNode.querySelector('.selectedColorID').value;
        selectedColorName = triggerElement.parentNode.querySelector(".selectedColorName").value;
        baseColorHex = triggerElement.parentNode.querySelector('.baseColorHex').value;
        trimColorHex = triggerElement.parentNode.querySelector('.trimColorHex').value;
  
        prodColorImgs.forEach(function (el, index, array) {
          el.querySelector('.selectedImgDesc').classList.add('textDarkestGray');
          el.querySelector('.selectedImgDesc').classList.remove('bkgdBlue');
          el.setAttribute("aria-selected", "false");
          if (el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc')) {
            el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.add('textRed');
            el.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.remove('textWhite');
          }
        });
  	 triggerElement.setAttribute("aria-selected", "true");
        triggerElement.querySelector('.selectedImgDesc').classList.add('textWhite');
        triggerElement.querySelector('.selectedImgDesc').classList.add('bkgdBlue');
        triggerElement.querySelector('.selectedImgDesc').classList.remove('textDarkestGray');
        if (triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc')) {
          triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.add('textWhite');
          triggerElement.querySelector('.selectedImgDesc').querySelector('.selectedImgOutOfStockDesc').classList.remove('textRed');
        }
      }
  	
      if (document.getElementById('baseSpan')) {
        document.getElementById('baseSpan').style.backgroundColor = '#' + baseColorHex;
        document.getElementById('baseSpan').setAttribute("aria-label", triggerElement.parentNode.querySelector(".baseColorName").value);
      }
      if (document.getElementById('trimSpan')) {
        document.getElementById('trimSpan').style.backgroundColor = '#' + trimColorHex;
         document.getElementById('trimSpan').setAttribute("aria-label", triggerElement.parentNode.querySelector(".trimColorName").value);
      }
  
      if (selectedBaseTrimID != undefined && selectedBaseTrimID != "") {
        selBaseTrim.value = selectedBaseTrimID;
        document.getElementById('colorSelected').value = selectedColorName;
        document.getElementById('selColors').innerHTML = selectedColorName;
      }
  
      if (!isApparelItem) {
        document.querySelector('.step1').classList.remove('disabledBtn');
        document.querySelector('.step1').classList.add('bkgdBlue');
        document.querySelector('.step1').classList.add('whiteLink');
        if (isMobile) {
          ajaxActions.LoadOptionalExtras();
          ajaxActions.LoadNibInkColor();
          ajaxActions.LoadAdhesiveOptions();
  
          if (qryStr > 0) {
            CheckQueryString();
  
            var gFeedSummary = '<div class="GFeedPanel1">';
            gFeedSummary += document.getElementById('GFeedPanel').innerHTML + '</div>';
            document.getElementById('GFeedPanel').innerHTML = "";
  
            if (totalImprintColors > 0) {
              var checkedImprint = [];
              var impLocChecks = [].slice.call(document.querySelectorAll(".chkbxImprintLocation"));
              impLocChecks.forEach(function (el, index, array) {
                if (el.checked) {
                  checkedImprint.push(el);
                }
              });
              checkedImprint[0].parentNode.parentNode.querySelector('.imprintButtonExtras').classList.add('hide');
              checkedImprint[0].parentNode.parentNode.querySelector('.imprintButtonExtras').insertAdjacentHTML("afterend", gFeedSummary);
            } else {
              document.querySelector('.imprintButtonExtras').classList.add('hide');
              document.querySelector('.imprintButtonExtras').insertAdjacentHTML("afterend", gFeedSummary);
            }
          }
          ValidateCustomizeSections();
        }
      }
      if (selectedBaseTrimID != '' && isApparelItem) {
        //Load apparel size grid
        if (document.getElementById('PD_SizeGrid')) {
          document.getElementById('PD_SizeGrid').innerHTML = '';
        }
        if (document.getElementById('PD_SizeGridLoading')) {
          document.getElementById('PD_SizeGridLoading').style.display = "block";
        }
        if (document.querySelector('.PD_QuantityBtnCell')) {
          document.querySelector('.PD_QuantityBtnCell').querySelector('input').disabled = true; // Disables the qty button to keep it from opening multiple windows
          document.querySelector('.PD_QuantityBtnCell').style.opacity = "0.3";
        }
        if (document.querySelector('.PD_SizeChoicePanel')) {
          animate.fadeIn(document.querySelector('.PD_SizeChoicePanel'));
        }
  
        var hidePricing = document.getElementById('HideAdvertisedPrice').value.toUpperCase() === 'TRUE';
        ajaxActions.LoadSizing(selectedBaseTrimID, hidePricing);
        CheckQueryString();
  
        /*if(isGFeed){
          document.getElementById('GFeedPanel').style.display = "block";
        }*/
      }
    } //end product color
  
    // google feed 
    var qryStr = window.location.search;
    qryStr = qryStr.indexOf("gfeed=1");
  
  
    function CheckQueryString() {
      if (qryStr > 0) {
        var txtQty = GetQty();
        selBaseTrim.value = document.getElementsByClassName('selectedColorID')[0].value;
        var glideUnitPrice = 0;
        var glideTotal = 0;
        //glideUnitPrice = document.getElementById('lblPrice') ? document.getElementById('lblPrice').innerHTML : "";
        glideUnitPrice = document.getElementById('lblPrice') ? document.getElementById('lblPrice').value : "";
        glideTotal = document.getElementById('lblTotal') ? document.getElementById('lblTotal').innerHTML : "";
  
        if (document.getElementById('GFeedQty') ) {
          //commenting these out as google's scraper sucks but not so much on the UK side
          if(!(ukTaxRate != '0')){
	          document.getElementById('GFeedQty').innerHTML = ''; //txtQty;
	          document.getElementById('GFeedUnitPrice').innerHTML = ''; //glideUnitPrice;
	          document.getElementById('GFeedTotalPrice').innerHTML = ''; //glideTotal;
  		}
          SaveImprintColor(document.getElementById('gFeedDefaultImprintColor').parentNode.querySelector('.spnColorChip'));
        }
        if (optionalExtras == null) {
          ajaxActions.LoadOptionalExtras();
        }
        if (nibInkOptions == null) {
          ajaxActions.LoadNibInkColor();
        }
        if (adhSidesOptions == null) {
          ajaxActions.LoadAdhesiveOptions();
        }
        ajaxActions.GetExtras(document.getElementById('GFeedData'));
      }
    }
  
    var cartUrl = '';
	var RestrictedPricing = (function(){
		var open = function(cartID, cartItemID){
			restrictedPricingDialog.init(document.getElementById('restrictedPricingProduct'));
	      		
	      		var headerLinks = new header4i();
	      		headerLinks.loadUserLinks();
	      		
	      		fillDialogInfo();
	  
	      		if (isApparelItem) {
	        		document.getElementById('pricingArea').appendChild(document.getElementById('priceTblSizeChoice'));
	        		document.getElementById('priceTblSizeChoice').classList.remove("hide");
	        		document.getElementById('pricingArea').appendChild(document.getElementById('sizingBox'));
	        		document.getElementById('priceTblSizeChoice').classList.add('hide');
	        		document.getElementById('pnlFitRating').classList.add('hide');
	      		} else {
	       		document.getElementById('pricingArea').appendChild(document.getElementsByClassName('glide')[0]);
	       		document.querySelector(".glideToolTip ").style.display = "none";
	       		document.querySelector(".glide").style.padding = "0px 10px";
	      		}
	  
	      		document.getElementsByClassName('showp')[0].classList.remove('hide');
	      		document.getElementsByClassName('showpm')[0].classList.add('hide');
	      		console.log("data-cart-item: " + cartItemID);
	      		document.getElementById("restrictedPricingProduct").setAttribute("data-cart-item", cartItemID);
	      		
	      		restrictedPricingDialog.open();
	      		document.getElementById("btnGoToCart").focus();
	      		document.getElementsByClassName('cartLoadingImg')[0].classList.add('hide');
	  
	      		var closeRestrictedBtn = [].slice.call(document.getElementById("restrictedPricingProduct").getElementsByClassName("close4iDialog"));
	      		closeRestrictedBtn.forEach(function (el, index, array) {
	        		el.addEventListener("click", function (e) {
	          			e.preventDefault();
	          			close();
	          			document.getElementById("restrictedPricingProduct").setAttribute("data-cart-item", "");
	          			editID = -1;
	        		});
	      		});
	      		document.getElementById("btnRemoveCart").addEventListener('click', function (e) {
	        		e.preventDefault();
	        		ajaxActions.DeleteRestrictedCart(cartID);
	      		});
	      		document.getElementById("btnGoToCart").addEventListener('click', function (e) {
	        		e.preventDefault();
	        		e.stopPropagation();
	        		editID = document.getElementById("restrictedPricingProduct").getAttribute("data-cart-item"); //temporary fix
	        		ajaxActions.AddToCart();
	      		});
		},
		close = function(){
			var headerLinks = new header4i();
	      		headerLinks.loadUserLinks();
	      		if (isApparelItem) {
	        		document.getElementById('pnlSizing').appendChild(document.getElementById('sizingBox'));
	      		} else {
	        		//var newDiv = document.createElement('div');
	        		//newDiv.innerHTML = document.getElementsByClassName('glide')[0];
	        		//document.getElementsByClassName('glidePanel')[0].appendChild(newDiv);
	        		document.getElementsByClassName('glidePanel')[0].appendChild(document.getElementsByClassName('glide')[0]);
	        		document.querySelector(".glideToolTip ").removeAttribute("style");
	        		document.querySelector(".glide").removeAttribute("style");
	      		}
	      		document.getElementById("imgforrestricted").innerHTML = "";
	      		if(document.getElementById("gcheck")){
	      			document.getElementById("gcheck").parentNode.removeChild(document.getElementById("gcheck"));
	      		}
	      		document.getElementsByClassName('showp')[0].classList.add('hide');
	      		document.getElementsByClassName('showpm')[0].classList.remove('hide');
	      		document.getElementsByClassName("goToStep1")[0].focus();
		},
		fillDialogInfo = function(){
			var productName = document.getElementsByClassName("prodName")[0].textContent;
	      		var productNameNoQuote = productName.replace(/'/g, "");
	      		var newImg = document.createElement('img');
	      		newImg.setAttribute("id", "restrictedProductImg");
	      		newImg.setAttribute("src", document.getElementById("hypProdImg").getAttribute("href"));
	      		newImg.setAttribute("alt", productNameNoQuote);
	      		newImg.setAttribute("class", 'responsiveImg');
	      		document.getElementById("imgforrestricted").appendChild(newImg);
	      		document.querySelector(".prodNameRestricted").textContent = productName;
		};
		return{
			Open: open,
			Close: close
		};
	})();
  
    var loadingPage = function (container) {
      container.getElementsByClassName('loadingPage')[0].classList.remove('hide');
    };
  
    var hideLoading = function (container) {
      container.getElementsByClassName('loadingPage')[0].classList.add('hide');
    };
  
    var initReviewFilters = function () {
      var reviewOpts = [].slice.call(document.getElementsByClassName('reviewOptions'));
      reviewOpts.forEach(function (el, index, array) {
        el.addEventListener('change', ajaxActions.ReviewChange);
      });
  
      var reviewFilters = [].slice.call(document.getElementsByClassName('reviewFilter'));
      reviewFilters.forEach(function (el, index, array) {
        el.addEventListener("click", function (e) {
          var vals = el.id.split('_');
          var filter = '';
          if (vals.length > 1) {
            filter = vals[1];
          }
          ajaxActions.ReviewFilterChange(filter);
          return false;
        });
      });
    };
  
    var initFitRatingPages = function () {
      var fitPaging = [].slice.call(document.getElementsByClassName('fitratingpageselect'));
      fitPaging.forEach(function (el, index, array) {
        el.addEventListener("click", ajaxActions.GetFitRatingPage);
      });
    };
  
    function CalcPrice() {
      var TotalQty = 0;
      var apparelInputs = [].slice.call(document.querySelectorAll(".txtApparelQty"));
      apparelInputs.forEach(function (el, index, array) {
        if (el.value != '') {
          if (IsNumeric(el.value)) {
            TotalQty += parseInt(el.value);
          }
        }
      });
      if (document.getElementById('txtQty')) {
        document.getElementById('txtQty').innerHTML = TotalQty;
      }
      if (TotalQty >= lowestQty) {
        if (document.querySelector('.qtyErrorMsg')) {
          document.querySelector('.qtyErrorMsg').parentNode.removeChild(document.querySelector('.qtyErrorMsg'));
        }
        document.getElementById('txtQty').removeAttribute('style');
        if (selBaseTrim.value != "") {
          document.querySelector('.step1').classList.remove('disabledBtn');
          document.querySelector('.step1').classList.add('bkgdBlue');
          document.querySelector('.step1').classList.add('whiteLink');
        }
        var BreakNumBelow = -1;
        var BreakNumAbove = -1;
        for (var i = 0; i < arrBreak.length; i++) {
          if ((i + 1 >= arrBreak.length || arrBreak[i + 1] < 1) && TotalQty >= arrBreak[i] && arrBreak[i] > 0) {
            BreakNumBelow = i;
            BreakNumAbove = i;
          } else {
            if (TotalQty >= arrBreak[i] && TotalQty < arrBreak[i + 1]) {
              BreakNumBelow = i;
              BreakNumAbove = i + 1;
            }
          }
        }
        var newPrice = glide.GetPriceEstimate(BreakNumBelow, TotalQty, 0);
        if (document.getElementById('lblPrice')) {
          if(document.querySelector(".glidePanel")){ //glide
          	document.getElementById('lblPrice').value = currencySymbol + newPrice.toFixed(2);
          }else{ //apparel
          	document.getElementById('lblPrice').innerHTML = currencySymbol + newPrice.toFixed(2);
          }
        }
        if (document.getElementById('lblTotal')) {
          document.getElementById('lblTotal').innerHTML = currencySymbol + (newPrice * TotalQty).toFixed(2);
        }
      } else {
        document.querySelector('.step1').classList.add('disabledBtn');
        document.querySelector('.step1').classList.remove('bkgdBlue');
        document.querySelector('.step1').classList.remove('whiteLink');
        if (document.getElementById('lblPrice')) {
	          if(document.querySelector(".glidePanel")){ //glide
	          	document.getElementById('lblPrice').value = '';
	          }else{ //apparel
	          	document.getElementById('lblPrice').innerHTML = '';
	          }
        }
        if (document.getElementById('lblTotal')) {
          document.getElementById('lblTotal').innerHTML = '';
        }
      }
    }
  
    function UnlockMoreColors(e) {
      /// <summary>Called after clicking the more colors button, this displays the boxes after the first for additional color entries</summary>
      var divNeedMoreColors = e.currentTarget;
      var colorsDisplayed = divNeedMoreColors.parentNode.parentNode.getElementsByClassName('colorList').length;
      var colorsToAdd = totalImprintColors - colorsDisplayed;
      if (document.getElementById("GFeedData")) {
        document.getElementById("GFeedData").style.display = "none";
      }
      divNeedMoreColors.parentNode.parentNode.parentNode.parentNode.getElementsByClassName("imprintButtonExtras")[0].classList.remove('hide');
      var newContent = "";
      for (var i = colorsDisplayed + 1; i <= totalImprintColors; i++) {
        colorsDisplayed = divNeedMoreColors.parentNode.parentNode.getElementsByClassName('colorList').length;
        var HTMLString = '<div class="colorList marginTop5"><label for="imprintColorAdd' + i + '" class="inlineMiddle paddingRight20">' + localizedJS.ColorCap + " " + i + '</label>' +
          '<input readonly id="imprintColorAdd' + i + '" class="imprintColorBox inlineMiddle selectedColor borderMdGray" title="Please select a ' + localizedJS.Color + ' from the ' + localizedJS.Color + ' picker" style="background-color: transparent;" />' +
          '<input class="imprintLocationID" type="hidden" value="" /><input class="imprintColorID" type="hidden" value="" /><input class="productImprintLocationID" type="hidden" value="" />' +
          '<a href="#" class="inlineMiddle imprintClearColor darkestLink noLine padding10 pointer" role="button" aria-label="Clear ' + localizedJS.Color + " " + i + '"><svg class="show" height="20px" width="20px"><title>Clear ' + localizedJS.Color + " " + i + '</title><use xlink:href="#svgIcon-remove"></use></svg></a></div>';
  
        divNeedMoreColors.parentNode.parentNode.getElementsByClassName('colorList')[colorsDisplayed - 1].insertAdjacentHTML("afterend", HTMLString); // insert after last colorList	
      }
      divNeedMoreColors.parentNode.style.display = "none";
      imprintColorHandlers();
      var section = divNeedMoreColors.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
      section.getElementsByClassName('spnColorChip')[0].focus();
    }
  
    function getOrderTotal() {
      var priceEach;
      if(document.querySelector(".glidePanel")){ //glide
      		priceEach = document.getElementById("lblPrice").value;
      }else{ //apparel
      		priceEach = document.getElementById("lblPrice").innerHTML;
      }
      var shipCost = 0;
      var setupCharge = 0;
      var quantity = GetQty();
      return (priceEach * quantity) + setupCharge + shipCost;
    }

    var SetQuantity = function () {
      var totalLabel = document.getElementById('lblTotal').textContent;
      var priceLabel;
      if(document.querySelector(".glidePanel")){ //glide
          	priceLabel = document.getElementById('lblPrice').value;
      }else{ //apparel
      		priceLabel = document.getElementById('lblPrice').innerHTML;
      }
      if (checkQty() && StoreColor()) {
        resetCalcExtras();
        document.getElementsByClassName('selectedQty')[0].innerHTML = document.getElementById('txtQty').value;
        document.getElementById('SelectedQtyPrice').innerHTML = document.getElementById(priceLabel).innerHTML.replace(currencySymbol, '');
        document.getElementById('SelectedQtyTotal').innerHTML = document.getElementById(totalLabel).innerHTML.replace(currencySymbol, '');
        /* where is this element?
        animate.slideDown(document.getElementsByClassName('PD_SelectionPanel')[0]);
        document.getElementsByClassName('PD_SelectionBox')[0].classList.remove('hide');
        animate.fadeIn(document.getElementsByClassName('PD_SelectionBox')[0]);
        */
        animate.fadeOut(document.getElementsByClassName('PD_QuantityChoicePanel')[0]);
        animate.fadeIn(document.getElementsByClassName('PD_ImprintChoicePanel')[0]);
        ajaxActions.LoadOptionalExtras();
      }
    };
  
    function IsNumeric(strString) {
      var strValidChars = "0123456789";
      var strChar;
      var blnResult = true;
  
      for (i = 0; i < strString.length && blnResult == true; i++) {
        strChar = strString.charAt(i);
        if (strValidChars.indexOf(strChar) == -1) {
          blnResult = false;
        }
      }
      return blnResult;
    }
  
    function adhesiveOptionChanged() {
      toggleAvailableAdhesiveSides();
  
      // Find the selected nib and ink color in the master list and set the id to the hidden input
      var selectedAdhesive;
      var adhChecks = [].slice.call(document.getElementById("adhesiveOptions").querySelectorAll("input"));
      adhChecks.forEach(function (el, index, array) {
        //console.log("adhChecks el " + el + " index " + index + " array " + array);
  
        if (el.checked) {
          //console.log("checked el.value " + el.value );
          selectedAdhesive = el.value;
        }
      });
  
      var selectedAdhSide;
      var checkedAdhSide;
      var adhSideChecks = [].slice.call(document.getElementById("adhSideOptions").querySelectorAll("input"));
      adhSideChecks.forEach(function (el, index, array) {
        //console.log("adhSideChecks el " + el + " index " + index + " array " + array);
  
        if (el.checked) {
          //console.log("checked el.value " + el.value );
          //console.log("checked el " + el );
          selectedAdhSide = el.value;
          checkedAdhSide = el;
        }
      });
  
      for (var i = 0; i < adhSidesOptions.adhesive.length; i++) {
        if ((selectedAdhSide == adhSidesOptions.adhesive[i].side && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
          (typeof selectedAdhSide == 'undefined' && selectedAdhesive == adhSidesOptions.adhesive[i].adh) ||
          (selectedAdhSide == adhSidesOptions.adhesive[i].side && typeof selectedAdhesive == 'undefined')) {
  
          //console.log("checkedAdhSide.nextElementSibling.value " + checkedAdhSide.nextElementSibling.value);
          //console.log("adhSidesOptions.adhesive[i].id " + adhSidesOptions.adhesive[i].id);
          //console.log("selectedAdhSide " + selectedAdhSide + " adhSidesOptions.adhesive[i].side " + adhSidesOptions.adhesive[i].side);
          //console.log("selectedAdhesive " + selectedAdhesive + " adhSidesOptions.adhesive[i].adh " + adhSidesOptions.adhesive[i].adh);
  
          //checkedAdhSide.nextElementSibling.value = adhSidesOptions.adhesive[i].id; // correct?
          adhesiveInput.value = adhSidesOptions.adhesive[i].id;
          return;
        }
      }
    }
  
    function toggleAvailableAdhesiveSides() {
      // Need to hide ink colors that are not available for the selected nib size
      var selectedAdh = "";
      var adhInputs = [].slice.call(document.getElementById("adhesiveOptions").querySelectorAll("input"));
      adhInputs.forEach(function (el, index, array) {
        if (el.checked) {
          selectedAdh = el.value;
        }
      });
  
      // Don't bother unless there are nib options and there are ink options set
      if (typeof selectedAdh != "" && adhSidesOptions.adhesive.length > 0) {
        var adhSideOptions = document.getElementById('adhSideOptions').querySelectorAll('span');
        if (adhSideOptions.length > 0) {
          var selectedAdhesiveSides = [];
  
          // Populate the array with all of the possible ink colors for this nib
          for (var i = 0; i < adhSidesOptions.adhesive.length; i++) {
            if (selectedAdh == adhSidesOptions.adhesive[i].adh) {
              selectedAdhesiveSides[selectedAdhesiveSides.length] = adhSidesOptions.adhesive[i];
            }
          }
  
          // Toggle the side options
          for (var i = 0; i < selectedAdhesiveSides.length; i++) {
            var sideFound = false;
  
            for (var j = 0; j < adhSideOptions.length; j++) {
              if (!sideFound && selectedAdhesiveSides[i].getAttribute('name') == adhSideOptions[j].adh) {
                colorFound = true;
              }
            }
  
            if (colorFound) {
              adhSideOptions[i].style.display = "block";
            } else {
              adhSideOptions[i].style.display = "none";
  
              // If the option being hidden is checked, move the option to the first visible ink option
              if (adhSideOptions[i].querySelector('input').checked == true) {
                var visibleSpans = [];
                var spans = document.getElementById('adhSideOptions').querySelectorAll("span");
                spans.forEach(function (el, index, array) {
                  if (el.offsetParent != null) {
                    visibleSpans.push(el);
                  }
                });
                visibleSpans[0].querySelector("input").checked = true;
              }
            }
          }
        }
      }
    }
  
    function NibInkOptionChanged() {
      //console.log("NibInkOptionChanged()");
      toggleAvailableInkColors();
  
      // Find the selected nib and ink color in the master list and set the id to the hidden input
      var selectedInk;
      var inkChecks = [].slice.call(document.getElementById("inkColorOptions").querySelectorAll("input"));
      inkChecks.forEach(function (el, index, array) {
        if (el.checked) {
          selectedInk = el.value;
        }
      });
  
      var selectedNib;
      var nibChecks = [].slice.call(document.getElementById("nibOptions").querySelectorAll("input"));
      nibChecks.forEach(function (el, index, array) {
        if (el.checked) {
          selectedNib = el.value;
        }
      });
  
      for (var i = 0; i < nibInkOptions.inknib.length; i++) {
        if ((selectedInk == nibInkOptions.inknib[i].ink && selectedNib == nibInkOptions.inknib[i].nib) ||
          (typeof selectedInk == 'undefined' && selectedNib == nibInkOptions.inknib[i].nib) ||
          (selectedInk == nibInkOptions.inknib[i].ink && typeof selectedNib == 'undefined')) {
          //console.log("pre change check");
          nibInkInput.value = nibInkOptions.inknib[i].id;
          //Update the hidden input that holds the value to properly match the nib type selected.
          document.querySelector(".colorName" + nibInkOptions.inknib[i].ink).value = nibInkOptions.inknib[i].id;
          return;
        }
      }
    }
  
    function toggleAvailableInkColors() {
      // Need to hide ink colors that are not available for the selected nib size
      var selectedNib;
      var nibChecks = [].slice.call(document.getElementById("nibOptions").querySelectorAll("input"));
      nibChecks.forEach(function (el, index, array) {
        if (el.checked) {
          selectedNib = el.value;
        }
      });
  
      // Don't bother unless there are nib options and there are ink options set
      if (typeof selectedNib != 'undefined' && nibInkOptions.inknib.length > 0) {
        var inkOptions = document.getElementById('inkColorOptions').querySelectorAll('div');
        if (inkOptions.length > 0) {
          var nibInkColors = [];
  
          // Populate the array with all of the possible ink colors for this nib
          for (var i = 0; i < nibInkOptions.inknib.length; i++) {
            if (selectedNib == nibInkOptions.inknib[i].nib) {
              nibInkColors[nibInkColors.length] = nibInkOptions.inknib[i];
            }
          }
  
          // Toggle the ink colors
          for (var i = 0; i < inkOptions.length; i++) {
            var colorFound = false;
  
            for (var j = 0; j < nibInkColors.length; j++) {
              if (!colorFound && inkOptions[i].querySelector('label').getAttribute('name') == nibInkColors[j].ink) {
                colorFound = true;
              }
            }
  
            if (colorFound) {
              inkOptions[i].style.display = "block";
            } else {
              inkOptions[i].style.display = "none";
  
              // If the option being hidden is checked, move the option to the first visible ink option
              if (inkOptions[i].querySelector('input').checked == true) {
                var visibleDivs = [];
                var divs = document.getElementById('inkColorOptions').querySelectorAll("div");
                divs.forEach(function (el, index, array) {
                  if (el.offsetParent != null) {
                    visibleDivs.push(el);
                  }
                });
                visibleDivs[0].querySelector("input").checked = true;
              }
            }
          }
        }
      }
    }
  
    function DeleteImprintColor(e) {
      ///<summary>Called after clicking delete all colors button, removes any additional imprint color</summary>
      e.preventDefault();
      var el = e.currentTarget;
      el.parentNode.getElementsByClassName('selectedColor')[0].style.backgroundColor = "rgba(0, 0, 0, 0)";
      el.parentNode.getElementsByClassName('selectedColor')[0].setAttribute('title', 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker');
  
      // jag - cleared imprintColorID as well or else imprint location will "look" like it is selected when it shouldn't be if there are no colors selected
      el.parentNode.getElementsByClassName('imprintColorID')[0].value = '';
  
      ResetImprintCharges();
      ValidateCustomizeSections();
    }
  
    function ClearImprintColors(e) {
      ///<summary>Called after clicking delete all colors button, removes any additional imprint color</summary>
      var elem = e.currentTarget;
      var imprintColors = [].slice.call(elem.parentNode.parentNode.getElementsByClassName('colorList'));
      var firstImprintColor = imprintColors[0];
      imprintColors.forEach(function (el, index, array) {
        if (el !== firstImprintColor) {
          el.parentNode.removeChild(el);
        }
      });
      imprintColors[0].getElementsByClassName('selectedColor')[0].removeAttribute('style');
      imprintColors[0].getElementsByClassName('selectedColor')[0].setAttribute('title', 'Please select a "' + localizedJS.Color + '" from the "' + localizedJS.Color + '" picker');
  
      // jage - cleared imprintColorID as well or else imprint location will "look" like it is selected when it shouldn't be if there are no colors selected
      imprintColors[0].getElementsByClassName('imprintColorID')[0].value = '';
  
      ResetImprintCharges();
      ValidateCustomizeSections();
      elem.parentNode.parentNode.getElementsByClassName("addColors")[0].style.display = "block";
      elem.parentNode.parentNode.getElementsByClassName("moreImprintColors")[0].style.display = "block";
      var sectionEl = elem.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
      sectionEl.getElementsByClassName('spnColorChip')[0].focus();
    }
  
    function CheckImprints() { // Is this method still used?
      var count = 0;
      var imprintOptions = [].slice.call(document.getElementsByClassName("chkbxImprintLocation"));
      imprintOptions.forEach(function (el, index, array) {
        if (el.checked) {
          count++;
        }
      });
      if (count > 0) {
        return true;
      }
      return false;
    }
   
    function GetSelectedImprintColors() {
      listSelectedColors = [];
      listSelectedColorsRGB = [];
      listSelectedImprintLocationName = [];
      var colorIDs = [];
      var colorRGBs = [];
      var checkImprintLocs = [].slice.call(document.getElementsByClassName("chkbxImprintLocation"));
      checkImprintLocs.forEach(function (el, index, array) {
        if (el.checked) {
          var colorsLists = [].slice.call(el.parentNode.parentNode.getElementsByClassName('imprint-colors-content')[0].getElementsByClassName('colorList'));
          colorIDs = [];
          colorRGBs = [];
          colorsLists.forEach(function (el, index, array) {
            var backgroundColor = el.getElementsByClassName('selectedColor')[0].style.backgroundColor;
            if (backgroundColor != "rgba(0, 0, 0, 0)" && backgroundColor != 'transparent') {
              var colorID = el.getElementsByClassName('imprintColorID')[0].value;
              if (!(colorID === undefined || colorID == "")) colorIDs.push(colorID);
              colorRGBs.push(backgroundColor);
            }
          });
          if (colorIDs.length > 0) {
            listSelectedColors.push(colorIDs);
          }
          if (colorRGBs.length > 0) {
            listSelectedColorsRGB.push(colorRGBs);
            listSelectedImprintLocationName.push(el.parentNode.getElementsByClassName('imprintLocationName')[0].value);
          }
        }
      });
    }
  
    function clearFloat() {
      //add margin to push details down and floatleft
      if (isDesktop) {
      	  var imageHeight;
      	  if(document.querySelector('.extraImgsBox')){
      	  	imageHeight = 370 + document.querySelector('.extraImgsBox').offsetHeight;
      	  }else {
      	  	imageHeight = 370;
      	  }
          var infoHeight = document.getElementsByClassName('prodInfo')[0].offsetHeight,
          summaryHeight = document.getElementsByClassName('prodSummary')[0].offsetHeight,
          infoSummary = infoHeight + summaryHeight;
  
        if (imageHeight > infoSummary) {
          var H = imageHeight - infoSummary;
          document.getElementsByClassName('prodSummary')[0].style.marginBottom = H;
        }
      } else if (isTabMobile && document.getElementsByClassName('prodSummary')[0]) { //don't add the extra margin
        document.getElementsByClassName('prodSummary')[0].style.marginBottom = '20px';
      }
    }
  
    var ByPassFullColor = function () {
      var colorChips = [].slice.call(document.getElementsByClassName('colorChipsCount'));
      colorChips.forEach(function (el, index, array) {
        if (el.value == '1') {
          el.parentNode.parentNode.getElementsByClassName('imprint-colors-content')[0].style.display = "none";
          var spnColorChip = el.parentNode.parentNode.getElementsByClassName('imprint-colors-content')[0].getElementsByClassName('spnColorChip')[0];
          SaveImprintColor(spnColorChip);
        }
      });
    };
  
   
    var setDetailTabEvents = function () {
      initReviewPages();
      initReviewFilters();
      initSuccessPages();
      initFitRatingPages();
      initQAPages();
      if (localizedJS.showCustomerImages) {
        initCustomerImagesPages();
      }
  
      questionEvents();
      reviewEvents();
  
      var filterTags = [].slice.call(document.getElementsByClassName("filterTag"));
      filterTags.forEach(function (el, index, array) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          var vals = el.id.split('_');
          var filter = '';
          if (vals.length > 1) {
            filter = vals[1];
            document.getElementById('fitratingfilter').style.display = "block";
            document.getElementById('fitratingfilter').classList.remove('hide');
          } else {
            document.getElementById('fitratingfilter').style.display = "none";
            document.getElementById('fitratingfilter').classList.add('hide');
          }
          ajaxActions.FitRatingChange(filter);
          return false;
        });
      });
  
      document.getElementsByClassName('btnSubmitProdQuestion')[0].addEventListener('click', function (e) {
        e.preventDefault();
        if (document.getElementsByClassName('prodQuestionMsg')[0]) {
          document.getElementsByClassName('prodQuestionMsg')[0].parentNode.removeChild(document.getElementsByClassName('prodQuestionMsg')[0]);
        }
        if (document.getElementById('prodQstn').value.trim().length < 6) {
          document.getElementById('prodQstn').classList.add("input-validation-error");
          document.getElementById('prodQstn').setAttribute('aria-invalid', 'true');
          document.getElementById('prodQstn').parentNode.getElementsByClassName("errorMessage")[0].classList.remove("hide");
           document.getElementById('prodQstn').parentNode.getElementsByClassName("errorMessage")[0].textContent = "Questions need to be longer than 5 characters.";
          document.getElementById('prodQstn').focus();
          return false;
        } else {
          document.getElementById('prodQstn').classList.remove("input-validation-error");
          document.getElementById('prodQstn').removeAttribute('aria-invalid');
          document.getElementById('prodQstn').parentNode.getElementsByClassName("errorMessage")[0].classList.add("hide");
          document.getElementById('prodQstn').parentNode.getElementsByClassName("errorMessage")[0].textContent = "";
        }
  
        ajaxActions.SubmitQuestion();
      });
  
      if (document.getElementById("customerImagesTS")) {
        document.getElementById("customerImagesTS").getElementsByTagName("a")[0].addEventListener("click", function (e) {
          lazyloadImages.update();
        });
      }
    };
  
    var reviewEvents = function () {
      var posReviewBtns = [].slice.call(document.getElementsByClassName('positiveReview'));
      posReviewBtns.forEach(function (el, index, array) {
        el.addEventListener('click', ajaxActions.PositiveReview);
      });
  
      var negReviewBtns = [].slice.call(document.getElementsByClassName('negativeReview'));
      negReviewBtns.forEach(function (el, index, array) {
        el.addEventListener('click', ajaxActions.NegativeReview);
      });
    };
    var questionEvents = function () {
      /* do these elements still exist?
      document.getElementsByClassName('readMoreAnswers')[0].addEventListener('click', function (e) {
        document.getElementsByClassName('product-moreanswers-dropdown')[0].style.display = "none";
                  if (this.parentNode.getElementsByClassName('product-moreanswers-dropdown')[0].style.display == "none") {
                      animate.slideDown(this.parentNode.getElementsByClassName('product-moreanswers-dropdown')[0]);
                  } else {
                      this.parentNode.getElementsByClassName('product-moreanswers-dropdown')[0].style.display = "none";
                  }
      });
      
      document.getElementsByClassName("exitReadAll")[0].addEventListener("click", function (e) { 
        animate.fadeOut(document.getElementsByClassName('viewModeAll')[0]);
                  document.getElementsByClassName('viewModeAll')[0].parentNode.removeChild(document.getElementsByClassName('viewModeAll')[0]);
                  animate.fadeIn(document.getElementsByClassName('halfPageContent')[0]);
      });
      */
  
      var qstTexts = [].slice.call(document.getElementsByClassName("questionText"));
      qstTexts.forEach(function (el, index, array) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          if (el.parentNode.getElementsByClassName("prodAnswerMsg")[0]) {
            el.parentNode.getElementsByClassName("prodAnswerMsg")[0].parentNode.removeChild(el.parentNode.getElementsByClassName("prodAnswerMsg")[0]);
          }
          var answerQuestDiv = el.parentNode.getElementsByClassName('answerQuestion')[0];
          if (answerQuestDiv.classList.contains('hide')) {
            el.setAttribute("aria-expanded", "true");
            el.querySelector("svg").setAttribute("class", "textDkGray"); // IE 11 does not support classList.remove() on SVG elements
            answerQuestDiv.getElementsByClassName("prodAnswer")[0].value = "";
            animate.slideDown(answerQuestDiv);
            answerQuestDiv.getElementsByClassName("prodAnswer")[0].focus();
          } else {
            animate.slideUp(answerQuestDiv);
            el.setAttribute("aria-expanded", "false");
            el.querySelector("svg").setAttribute("class", "textDkGray rotate180"); // IE 11 does not support classList.add() on SVG elements
            el.focus();
          }
        });
      });
  
      var posAnswers = [].slice.call(document.getElementsByClassName('positiveAnswer'));
      posAnswers.forEach(function (el, index, array) {
        el.addEventListener("click", ajaxActions.PositiveAnswer);
      });
  
      var negAnswers = [].slice.call(document.getElementsByClassName('negativeAnswer'));
      negAnswers.forEach(function (el, index, array) {
        el.addEventListener("click", ajaxActions.NegativeAnswer);
      });
  
      var submitAnswerBtns = [].slice.call(document.getElementsByClassName('btnSubmitProdAnswer'));
      submitAnswerBtns.forEach(function (el, index, array) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          var vals = el.id.split('_');
          var question_ID = vals[1];
          var answer = document.getElementById('answerQuestion_' + question_ID);
  
          if (document.getElementsByClassName("prodAnswerMsg")[0]) {
            document.getElementsByClassName("prodAnswerMsg")[0].parentNode.removeChild(document.getElementsByClassName("prodAnswerMsg")[0]);
          }
          answer.parentNode.getElementsByClassName("errorMessage")[0].classList.add("hide");
          if (answer.value.trim().length < 2) {
            answer.classList.add("input-validation-error");
            answer.setAttribute('aria-invalid', 'true');
            answer.parentNode.getElementsByClassName("errorMessage")[0].classList.remove("hide");
            answer.parentNode.getElementsByClassName("errorMessage")[0].textContent = "Answers must be longer than 1 character.";
            answer.focus();
            return false;
          } else {
            answer.classList.remove("input-validation-error");
            answer.removeAttribute('aria-invalid');
            answer.parentNode.getElementsByClassName("errorMessage")[0].classList.add("hide");
            answer.parentNode.getElementsByClassName("errorMessage")[0].textContent = "";
          }
          var data = {
            productID: prodID,
            questionID: question_ID,
            quickAnswer: answer.value
          };
          ajaxActions.SubmitAnswer(el, data);
        });
      });
  
      if (document.getElementsByClassName('addQuickAnswer')[0]) {
        document.getElementsByClassName('addQuickAnswer')[0].addEventListener('click', function (e) {
          document.getElementsByClassName('quickAnswerContent')[0].style.display = "none";
          document.getElementsByClassName('addQuickAnswer')[0].style.display = "block";
          document.getElementsByClassName('quickAnswSubmitMsg')[0].parentNode.removeChild(document.getElementsByClassName('quickAnswSubmitMsg')[0]);
          document.getElementsByClassName('quickAnswerContent')[0].parentNode.removeChild(document.getElementsByClassName('quickAnswerContent')[0]);
          this.insertAdjacentHTML('afterend', '<div class=\'quickAnswerContent\' ><textarea class=\"newQuickAnswer floatLeft\" col=\'4\', rows=\'5\'></textarea> <input value=\'Submit Answer\' type=\'button\' class=\'clear submitQuickAnswer button-md-thin text14 bkgdBlue whiteLink floatLeft\' />' +
            '<input value=\'Cancel\' type=\'button\' class=\'cancelQuickAnswer clear button-md-thin button-white-textBlue\' /></div>');
          this.style.display = "none";
          animate.slideDown(document.getElementsByClassName('quickAnswerContent')[0]);
          document.getElementsByClassName("cancelQuickAnswer")[0].addEventListener("click", function (e) {
            document.getElementsByClassName('quickAnswerContent')[0].style.display = "none";
            document.getElementsByClassName('quickAnswerContent')[0].parentNode.removeChild(document.getElementsByClassName('quickAnswerContent')[0]);
            document.getElementsByClassName('addQuickAnswer')[0].style.display = "block";
          });
          document.getElementsByClassName('submitQuickAnswer')[0].addEventListener('click', function (e) {
            var quickAnswer = this.parentNode.getElementsByClassName('newQuickAnswer')[0].value;
            var questionID = this.parentNode.parentNode.getElementsByClassName('questionID')[0].value;
            var data = {
              productID: prodID,
              questionID: questionID,
              quickAnswer: quickAnswer
            };
            document.getElementsByClassName('quickAnswSubmitMsg')[0].parentNode.removeChild(document.getElementsByClassName('quickAnswSubmitMsg')[0]);
            ajaxActions.SubmitQuickAnswer(data);
          });
        });
      }
    };
  
    function setBkgdBorderAndNextImage(index) {
      var thumbs = [].slice.call(document.getElementsByClassName('thumbSelectImage'));
      thumbs.forEach(function (el, index, array) {
        el.classList.remove('borderDkGray');
        el.classList.add('borderMdGray');
      });
      if (index > 0) { // not first slide that doesn't have a thumbnail
        var newthumb = document.getElementById('thumbSelectImage_' + index);
        newthumb.classList.remove('borderMdGray');
        newthumb.classList.add('borderDkGray');
      }
      var nextSlide = index + 1;
      var lastSlide = mainImgSlider.slideCount;
      if (mainImgSlider.index == 0) {
        document.getElementById('thumbSelectImage_1').classList.remove('borderMdGray');
        document.getElementById('thumbSelectImage_1').classList.add('borderDkGray');
      } else if (mainImgSlider.index != lastSlide) {
        document.getElementById('thumbSelectImage_' + nextSlide).classList.remove('borderMdGray');
        document.getElementById('thumbSelectImage_' + nextSlide).classList.add('borderDkGray');
      }
    }
  
    	var initAppear = function() {
		var options;
		var observer = new IntersectionObserver(callBack, options);
		
		/* once element is in view - do this */
		function callBack(entries, observer) {
		  	entries.forEach(function(entry){
		  		if(entry.intersectionRatio > 0){
			  		if(entry.target === document.getElementById('relatedProductsContainer')){
			  			ajaxActions.GetRelatedProducts();
		            			observer.unobserve(document.getElementById('relatedProductsContainer'));
			  		}
			  		if(entry.target === document.getElementById('detailTabs')){
			  			ajaxActions.GetDetailTabs();
		            			observer.unobserve(document.getElementById('detailTabs'));
			  		}
			  		if(entry.target === document.getElementById('productCats')){
			  			ajaxActions.GetItemCategories();
		            			observer.unobserve(document.getElementById('productCats'));
			  		}
			  		if(entry.target === document.getElementById('tabProd')){
			  			ajaxActions.GetTabbedScroller();
		            			observer.unobserve(document.getElementById('tabProd'));
			  		}
			  		if(entry.target === document.getElementById('altitemslist')){
			  			 ajaxActions.GetAlternativeItemsList();
		            			 observer.unobserve(document.getElementById('altitemslist'));
			  		}
		            		if(entry.target === document.getElementById('altrelated')){
			  			 ajaxActions.GetAlternativeItems();
		            			 observer.unobserve(document.getElementById('altrelated'));
			  		}  	 
		  		}
		  	});
		}
		
    		/* related product scroller */
    		if(document.getElementById('relatedProductsContainer')){
    			options = { root: document.getElementById('relatedProductsContainer'), threshold: 1.0 };
	    		observer.observe(document.getElementById('relatedProductsContainer'));
		}

    		/* reviews, stories, photos... tabs */
    		if(document.getElementById('detailTabs')){
    			options = { root: document.getElementById('detailTabs'), threshold: 1.0 };
	    		observer.observe(document.getElementById('detailTabs'));
    		}
    		
    		/* product categories */
    		if(document.getElementById('productCats')){
    			options = { root: document.getElementById('productCats'), threshold: 1.0 };
			observer.observe(document.getElementById('productCats'));
    		}
    		
    		/* tabbed scroller */
    		if(document.getElementById('tabProd')){
    			options = { root: document.getElementById('tabProd'), threshold: 1.0 };
			observer.observe(document.getElementById('tabProd'));
		}

    		/* alternate items list */
		if (document.getElementById('altitemslist')) {
			options = { root: document.getElementById('altitemslist'), threshold: 1.0 };
	    		observer.observe(document.getElementById('altitemslist'));
 		}
 		
 		/* alternate items */
 		if (document.getElementById('altitemslist')) {
 			options = { root: document.getElementById('altrelated'), threshold: 1.0 };
 			observer.observe(document.getElementById('altrelated'));
 		}
	};
  
	var threeSixtyView = function () {
      		if (document.getElementById("hyp360View")) {
        		var threeSixtyBtns = document.querySelectorAll(".hyp360View"),
        		threeSixtyDialogContent = document.getElementsByClassName("three60View")[0],
			threeSixtyImage = document.getElementById('hyp360ViewZOOM'),
          		get360Class = function () {
            			var boxWidth = document.querySelector('.flyoutImg').naturalWidth;
            			var boxHeight = document.querySelector('.flyoutImg').naturalHeight;
            			threeSixtyDialogContent.classList.remove('landscape');
            			threeSixtyDialogContent.classList.remove('portrait');
            			if (boxWidth > boxHeight) {
              			threeSixtyDialogContent.classList.add('landscape');
            			} else {
              			threeSixtyDialogContent.classList.add('portrait');
            			}
            			//add in the actual height/width of the image to the image tag
            			document.querySelector(".flyoutImg").height = boxHeight;
            			document.querySelector(".flyoutImg").width = boxWidth;
          		},
          		get360Map = function () {
           			var mapPos = [];
           	 		if (mapPos.length == 0) {
              			try {
                				var backgroundPositions = threeSixtyImage.style.backgroundPosition;
                				var backgroundImages = threeSixtyImage.style.backgroundImage;
                				var positions = backgroundPositions.split(',');
                				var images = backgroundImages.split(',');
                				var imagePattern = /\/[0-9][0-9].jpg/;
                				for (var i = 0; i < positions.length; i++) {
                  					var matches = imagePattern.exec(images[i]);
                  					mapPos.push(+matches[0].substring(1, 3) - 1);
                				}
              			} catch (e) { }
            			}
            			return mapPos;
          		},
          		determine360Position = function () {
            			try {
              			var backgroundPositions = threeSixtyImage.style.backgroundPosition;
              			var positions = backgroundPositions.split(',');
              			for (var i = 0; i < positions.length; i++) {
                				if (positions[i].trim() == '0px 0px') {
                  					return get360Map()[i];
                				}
              			}
            			} catch (e) { }
          		},
          		set360Position = function (position) {
            			try {
              			var backgroundPositions = threeSixtyImage.style.backgroundPosition;
              			var positions = backgroundPositions.split(',');
              			var pos = (position + positions.length) % positions.length;
              			var bgPositions = [];
              			for (var i = 0; i < positions.length; i++) {
                				if (get360Map()[i] == pos) {
                  					bgPositions.push('0px 0px');
                				} else {
                  					bgPositions.push('0px -10000px');
                				}
              			}
              			threeSixtyImage.style.backgroundPosition = bgPositions.join(', ');
            			} catch (e) { }
          		};
          
        		threeSixtyDialog.init(document.getElementById("PD_360Flyout"));
        
			var focusBack; 
			for(var i = 0; i < threeSixtyBtns.length; i++){ 
		        	threeSixtyBtns[i].addEventListener("click", function (e) {
		          		e.preventDefault();
		          		focusBack = this;
		          		this.setAttribute("aria-expanded", "true");
		          		get360Class();
		          		threeSixtyDialog.open();
		          		
		          		document.getElementById("PD_360Flyout").addEventListener("keydown", function(e){
		          			if(e.which == 27){ //escape
		          				focusBack.setAttribute("aria-expanded", "false");	
		          				focusBack.focus();
		          				document.getElementById("PD_360Flyout").removeEventListener("keydown", [0]);
		          			}
		          		});
		  		});
		  	}
			document.getElementById("spanItemRight").addEventListener("click", function (e) {
		            e.preventDefault();
		            var pos = determine360Position();
		            set360Position(pos + 1);
			});
			document.getElementById("spanItemRight").addEventListener("keyup", function (e) {
				if(e.which == 13){//enter
					this.click();
				}
			});
			document.getElementById("spanItemLeft").addEventListener("click", function (e) {
		            e.preventDefault();
		            var pos = determine360Position();
		            set360Position(pos - 1);
			});
			document.getElementById("spanItemLeft").addEventListener("keyup", function (e) {
				if(e.which == 13){//enter
					this.click();
				}
			});
			document.getElementById("PD_360Flyout").getElementsByClassName("close4iDialog")[0].addEventListener("click", function () {
		            focusBack.focus();
		            focusBack.setAttribute("aria-expanded", "false"); 
			});
		} 
	}; // end 360 view
  
    // 360 guarantee
    var initGuaranteeDialog = function () {
      if (document.getElementById('div360dialog')) {
        guaranteeDialog.init(document.getElementById('div360dialog'), document.getElementsByClassName('the360link'));
  
        if (document.getElementsByClassName("the360link").length > 0) {
          document.getElementsByClassName("the360link")[0].addEventListener("click", function (e) {
            e.preventDefault();
            lazyloadImages.update();
          });
        }
      }
    };
  
    var initArtDialog = function () {
      // How to send my artwork
      if (document.getElementById('divArtInstdialog')) {
        artInstDialog.init(document.getElementById('divArtInstdialog'), document.getElementsByClassName('artInstLink'));
  
        if (document.getElementsByClassName("artInstLink").length > 0) {
          document.getElementsByClassName("artInstLink")[0].addEventListener("click", function (e) {
            e.preventDefault();
            lazyloadImages.update();
          });
        }
      }
    };
  
    function goToNextStep(e) {
      if (e.type == 'keyup' && (e.keyCode != 13)) return;
      if (document.querySelectorAll('.errorMsg')[0]) {
        var errorMsgs = [].slice.call(document.querySelectorAll('.errorMsg'));
        errorMsgs.forEach(function (el, index, array) {
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }
        });
      }
      var colorSelected = document.getElementById('colorSelected').value;
      var selectedColorID = selBaseTrim.value;
      var qty = GetQty();
      
      var priceEach = "";
      if(document.getElementById("lblPrice")){
      	   if(document.querySelector(".glidePanel")){ //glide
          	priceEach = document.getElementById("lblPrice").value;
          }else{ //apparel
          	priceEach = document.getElementById("lblPrice").innerHTML;
          }
      }
      var grandTotal = document.getElementById('lblTotal') ? document.getElementById('lblTotal').innerHTML : "";
  	
      if (this.classList.contains('step1')) {
        ResetImprintCharges();
  
        if (isApparelItem && document.getElementById('SizingGrid').innerHTML.length > 0) {
          CalcPrice();
        }
        if (selectedColorID == undefined || selectedColorID == "") {
          if (recolorAvailable.value == 'True') {
            document.getElementById('productColorScroller').insertAdjacentHTML('beforebegin', '<div class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="colorScrollerError" class="btnToHyp text16 underline marginTop10">Please select a product ' + localizedJS.Color + '.</button></div>');
            document.getElementById("colorScrollerError").focus();
            document.getElementById("colorScrollerError").addEventListener("click", function(e){
            	  e.preventDefault();
            	  document.getElementById('productColorScroller').querySelectorAll('.imgBox')[0].focus();
            }); 
          } else {
            document.querySelector('.PD_ColorList').insertAdjacentHTML('beforebegin', '<div class="clear errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="colorListError" class="btnToHyp text16 underline marginTop10">Please select a product ' + localizedJS.Color + '.</button></div>');
            document.getElementById("colorListError").focus();
            document.getElementById("colorListError").addEventListener("click", function(e){
            	  e.preventDefault();
            	  document.getElementById('listView').querySelectorAll('.selectedImgDesc')[0].focus();
            }); 
          }
          return false;
        }
        
         var quantityErrorHtml = '<div class="clear qtyErrorMsg errorMsg ErrorMsgPanel" role="alert" aria-atomic="true"><h3 class="validationHeading">Please correct the following errors and resubmit:</h3><button id="quantityError" class="btnToHyp text16 underline marginTop10">Minimum quantity for this item is ' + lowestQty + '.</button></div>';

        if (qty == isNaN || qty == undefined || qty == '0' || !IsNumeric(qty)) {
          if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
          
          if (isApparelItem) {
             document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);

            var allQtyInputs = document.getElementsByClassName("txtApparelQty");
            for (var x = 0; x < allQtyInputs.length; x++) {
              //allQtyInputs[x].style.backgroundColor = "#ffd9d9";
              allQtyInputs[x].classList.add("input-validation-error");
              allQtyInputs[x].setAttribute('aria-invalid', 'true');
            }
             document.getElementById("quantityError").focus();
	        document.getElementById("quantityError").addEventListener("click", function(e){
	        	e.preventDefault();
	        	allQtyInputs[0].focus();
	        });
            
          } else {
          	document.querySelector('.glidePanel').insertAdjacentHTML('beforebegin', quantityErrorHtml);
            //document.getElementById('txtQty').style.backgroundColor = '#ffd9d9';
            document.getElementById('txtQty').classList.add("input-validation-error");
            document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
            document.getElementById("quantityError").focus();
	        document.getElementById("quantityError").addEventListener("click", function(e){
	        	e.preventDefault();
	        	document.getElementById('txtQty').focus();
	        });
          }
  
          return false;
        }
        if (qty < lowestQty) {
            if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));

          if (isApparelItem) {
          	 document.getElementById('PD_SizeGrid').insertAdjacentHTML('beforebegin', quantityErrorHtml);
            var apparelInputs = document.getElementsByClassName("txtApparelQty");
            for (var y = 0; y < apparelInputs.length; y++) {
              if (apparelInputs[y].value != '') {
                //apparelInputs[y].style.backgroundColor = '#ffd9d9';
                apparelInputs[y].classList.add("input-validation-error");
                apparelInputs[y].setAttribute('aria-invalid', 'true');
                document.getElementById("quantityError").focus();
	          document.getElementById("quantityError").addEventListener("click", function(e){
	        	e.preventDefault();
	        	apparelInputs[0].focus();
	        });
              }
            }
          } else {
          	document.querySelector('.glidePanel').insertAdjacentHTML('afterend', quantityErrorHtml);
            //document.getElementById('txtQty').style.backgroundColor = '#ffd9d9';
            document.getElementById('txtQty').classList.add("input-validation-error");
            document.getElementById('txtQty').setAttribute('aria-invalid', 'true');
            document.getElementById("quantityError").focus();
	        document.getElementById("quantityError").addEventListener("click", function(e){
	        	e.preventDefault();
	        	document.getElementById('txtQty').focus();
	        });
          }
          return false;
        }
        if (qty >= lowestQty && selectedColorID != "") {
          if (document.querySelector(".qtyErrorMsg")) document.querySelector(".qtyErrorMsg").parentNode.removeChild(document.querySelector(".qtyErrorMsg"));
          document.getElementById('txtQty').classList.remove('input-validation-error');
          document.getElementById('txtQty').removeAttribute('aria-invalid');
          animate.fadeOut(document.querySelectorAll(".PD_Step_1")[0], 200);
          animate.fadeOut(document.querySelectorAll(".PD_Step_1")[1], 200);
          setTimeout(function () { // give fade out time to do its thing before fading in
            animate.fadeIn(document.querySelector(".PD_Step_2"), 200);
          }, 200);
          setTimeout(function () { // once step 2 is visible
            ajaxActions.LoadOptionalExtras();
            ajaxActions.LoadNibInkColor();
            ajaxActions.LoadAdhesiveOptions();
            if (qryStr > 0) {
              CheckQueryString();
              var gFeedSummary = '<div class="GFeedPanel1">';
              gFeedSummary += document.getElementById('GFeedPanel').innerHTML + '</div>';
              document.getElementById('GFeedPanel').innerHTML = '';
              if (totalImprintColors > 0) {
                var checkedImprints = [];
                var imprintcheckbox = [].slice.call(document.getElementsByClassName("chkbxImprintLocation"));
                imprintcheckbox.forEach(function (el, index, array) {
                  if (el.checked) {
                    checkedImprints.push(el);
                  }
                });
                checkedImprints[0].parentNode.parentNode.getElementsByClassName('imprintButtonExtras')[0].classList.add('hide');
                checkedImprints[0].parentNode.parentNode.getElementsByClassName('imprintButtonExtras')[0].insertAdjacentHTML('afterend', gFeedSummary);
              } else { // one imprint color
                document.getElementsByClassName("imprintButtonExtras")[0].classList.add("hide");
                document.getElementsByClassName("imprintButtonExtras")[0].insertAdjacentHTML("afterend", gFeedSummary);
              }
              tooltips.init(); //gfeed tooltip
            }
            document.getElementsByClassName('PD_Step_2')[0].scrollIntoView({
              behavior: "smooth"
            });
            document.getElementsByClassName("chkbxImprintLocation")[0].focus();
          }, 200);
        }
      } else if (this.classList.contains('goToStep1')) {
        if (document.getElementById('GFeedPanel')) {
          //var gFeedSummary = document.querySelector('.GFeedPanel1').innerHTML;
          //document.getElementById('GFeedPanel').innerHTML = gFeedSummary;
          document.getElementById('GFeedPanel').classList.add("hide");
          document.getElementById('GFeedPanel').style.display = "block";
          document.querySelector('.GFeedPanel1').parentNode.removeChild(document.querySelector('.GFeedPanel1'));
        }
        animate.fadeOut(document.querySelector(".PD_Step_2"), 200);
        setTimeout(function () { // give fade out time to do its thing before fading in
          animate.fadeIn(document.querySelectorAll(".PD_Step_1")[0], 200);
          animate.fadeIn(document.querySelectorAll(".PD_Step_1")[1], 200);
        }, 200);
        setTimeout(function () { // once step 1 is visible
          if (!isApparelItem) {
            document.getElementById("litGlideTotal").classList.remove("hide");
            document.getElementById("lblQuantityTxtCaption").classList.remove("hide");
            document.getElementsByClassName("glide")[0].lastElementChild.classList.remove("hide"); //unit price
             sliderGlide.UpdateToolTip(); // added to update the tooltip position espeically with restricted pricing items
          }
          if (document.getElementById("pricingarea")) {
            document.getElementById("pricingarea").classList.remove("hide");
          }
          document.getElementsByClassName('PD_Step_1')[0].scrollIntoView({
            behavior: "smooth"
          });
          if (document.getElementById("jumpToColor")) {
            document.getElementById("jumpToColor").focus();
          } else if (document.querySelector('.PD_Step_1').getElementsByTagName('a')[0]) {
            document.querySelector('.PD_Step_1').getElementsByTagName('a')[0].focus();
          } else {
            document.querySelector('.PD_Step_1').getElementsByTagName('button')[0].focus();
          }
        }, 200);
        e.preventDefault();
      }
    }
  
    var initProp65 = function () {
      if (document.getElementById('prop65dialog')) {
        prop65Dialog.init(document.getElementById('prop65dialog'), document.getElementsByClassName('prop65'), document.getElementById('btnProp65OK'));
        document.getElementsByClassName('prop65')[0].addEventListener('click', ajaxActions.GetPropSixtyFive);
      }
    };
  
    var setUpHashOptions = function () {
      switch (window.location.hash) {
        case '#reviews':
          setTimeout(function () {
            document.querySelector("#detailTabs").scrollIntoView();
            //document.getElementById('reviewsTS').click(); //TODO click once appear() is finished
          }, 1200);
          break;
        case '#stories':
          setTimeout(function () {
            document.querySelector("#detailTabs").scrollIntoView();
            //document.getElementById('successStoriesTS').click(); //TODO click once appear() is finished
          }, 1200);
          break;
        case '#fit':
          setTimeout(function () {
            document.querySelector("#detailTabs").scrollIntoView();
            //document.getElementById('fitRatingTS').click(); //TODO click once appear() is finished
          }, 1200);
          break;
        case '#questions':
          setTimeout(function () {
            document.querySelector("#detailTabs").scrollIntoView();
            //document.getElementById('QATS').click(); //TODO click once appear() is finished
          }, 1200);
          break;
        default:
          break;
      }
      if (document.getElementById('InfoType').length > 0) {
        var InfoType = document.getElementById('InfoType').value;
        switch (InfoType) {
          case '1':
            setTimeout(function () {
              document.querySelector("#detailTabs").scrollIntoView();
              //document.getElementById('reviewsTS').click(); //TODO click once appear() is finished
            }, 1200);
            break;
          case '2':
            setTimeout(function () {
              document.querySelector("#detailTabs").scrollIntoView();
              //document.getElementById('successStoriesTS').click(); //TODO click once appear() is finished
            }, 1200);
            break;
          case '3':
            setTimeout(function () {
              document.querySelector("#detailTabs").scrollIntoView();
              //document.getElementById('fitRatingTS').click(); //TODO click once appear() is finished
            }, 1200);
            break;
          case '4':
            setTimeout(function () {
              document.querySelector("#detailTabs").scrollIntoView();
              //document.getElementById('QATS').click(); //TODO click once appear() is finished
            }, 1200);
            break;
        }
      }
    };
  
    //used for setting apparel events, specifically for apparel items with only 1 color
    // example item: 148213-M
    function setApparelEvents() {
      //tooltips.init(); //glide tooltip
  
      //animate.fadeIn(document.getElementsByClassName('PD_SizeChoicePanel')[0]);
      //if (editID < 0 && qryStr > 0) {
      //	document.getElementsByClassName('txtApparelQty')[0].value = lowestQty;
      //}
      //CalcPrice();
      //if (noPrice) {
      //	document.getElementsByClassName('showp')[0].classList.add('hide');
      //	document.getElementsByClassName('showpm')[0].classList.remove('hide');
      //}
  
      if (document.getElementsByClassName("addMoreSizes")[0]) {
        addSizesEvent();
      } else if (document.getElementsByClassName('clearAllSizes')[0]) { // occurs when editing
        clearSizesEvent();
      }
  
      function clearSizesEvent() {
        document.getElementsByClassName('clearAllSizes')[0].addEventListener('click', function (e) {
          e.preventDefault();
          animate.fadeOut(document.getElementsByClassName('moreSizes')[0]);
          [].forEach.call(document.getElementsByClassName('moreSizes')[0].getElementsByClassName('txtApparelQty'), function (el) { el.value = ''; });
          var newLabel = this.value.replace('Clear All', 'Add');
          this.value = newLabel;
          this.classList.remove('clearAllSizes');
          this.classList.add('addMoreSizes');
          addSizesEvent();
          CalcPrice();
        });
      }
  
      function addSizesEvent() {
        document.getElementsByClassName("addMoreSizes")[0].addEventListener('click', function (e) {
          e.preventDefault();
          animate.fadeIn(document.getElementsByClassName('moreSizes')[0]);
          var newLabel = this.value.replace('Add', 'Clear All');
          this.value = newLabel;
          this.classList.remove('addMoreSizes');
          this.classList.add('clearAllSizes');
          clearSizesEvent();
        });
      }
  
      function sizeInputsEvent() {
      	  var apparelQty = [].slice.call(document.getElementsByClassName('txtApparelQty'));
          apparelQty.forEach(function (el, index, array) {
          	el.classList.remove("input-validation-error");
        	el.removeAttribute('aria-invalid');
          });
        
        var thisQty = 0;
        if (isNumeric(this.value)) {
          apparelQty.forEach(function (el, index, array) {
            if (el.value != '') {
              if (isNumeric(this.value)) {
                thisQty += parseInt(this.value);
              }
            }
          });
        } else {
          this.value = '';
          return false;
        }
        var updateDelay = (thisQty < lowestQty) ? 750 : 600;
        txtTimer = setTimeout(function () {
          if (isGFeed) {
            document.getElementById('GFeedPanel').style.display = "none";
            document.getElementById("pricingarea").classList.remove("hide");
          }
          if (document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0]) {
            document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0].parentNode.removeChild(document.getElementById('txtQty').parentNode.parentNode.getElementsByTagName('input')[0]);
          }
          CalcPrice();
        }, updateDelay);
        return true;
      }
  
      var sizingInputs = [].slice.call(document.getElementsByClassName('txtApparelQty'));
      sizingInputs.forEach(function (el, index, array) {
        el.addEventListener("focusout", sizeInputsEvent);
        el.addEventListener("keyup", sizeInputsEvent);
      });
  
      //CheckQueryString();
      //$('#GFeedPanel').show();
      // if (document.getElementById("GFeedPanel")) {
      // 	if (document.getElementById("GFeedPanel").style.display == "block") {
      // 		// apparel pricing is repeated, should be hidden until gfeed is hidden, then shown
      // 		document.getElementById("pricingarea").classList.add("hide");
      // 	} else {
      // 		document.getElementById("pricingarea").classList.remove("hide");
      // 	}
      // }
      //pricingHandlers();
    }
  
    var initVideo = function () {
      // if video link
      if (document.getElementsByClassName("videoLink")[0]) {
        var videoData = new videos4i();
        videoData.initLinks();
      }
    };
  
    var checkSetEdit = function () {
      if (editID < 0) {
        //check first location and display imprint colors if more than one
        var impLocCheckboxes = document.getElementsByClassName('chkbxImprintLocation');
        if (impLocCheckboxes.length > 0) {
          var firstImpLocChkbox = impLocCheckboxes[0];
          firstImpLocChkbox.checked = true;
          if (totalImprintColors > 0) {
            document.getElementsByClassName('imprint-colors-content')[0].classList.remove("hide"); // simpler code than the statement below, but still trips up Kaspersky
            firstImpLocChkbox.setAttribute("aria-expanded", "true");
          }
        }
      } else {
        //cart item is being edited.. show imprint colors for all checked imprint locations
        var allChecks = [].slice.call(document.querySelectorAll(".chkbxImprintLocation"));
        var checkedImprints = [];
        allChecks.forEach(function (el, index, array) {
          if (el.checked) {
            checkedImprints.push(el);
          }
        });
        if (totalImprintColors != undefined && totalImprintColors > 0) {
          checkedImprints[0].parentNode.nextElementSibling.style.display = "block";
	   checkedImprints[0].setAttribute("aria-expanded", "true");
        } else {
          checkedImprints[0].parentNode.nextElementSibling.style.display = "none";
          if (totalImprintColors != undefined && totalImprintColors > 0) {
          	checkedImprints[0].setAttribute("aria-expanded", "false");
          }
        }
        var selectedColor = document.getElementById("selectedColorID").value;
        var productColorOptions = [].slice.call(document.getElementsByClassName("selectedColorID"));
        productColorOptions.forEach(function (el, index, array) {
          if (el.value === selectedColor) {
            setTimeout(function () {
              if (el.parentNode.getElementsByTagName("button")[0]) {
                el.parentNode.getElementsByTagName("button")[0].click();
              }
              if (el.parentNode.getElementsByTagName("a")[0]) {
                el.parentNode.getElementsByTagName("a")[0].click();
              }
            }, 1200);
          }
        });
        //$('.imgActive').trigger("click");
      }
    };
  
    var bindDesktopStepLink = function () {
      if (!isMobile) {
        var nextLinks = [].slice.call(document.getElementsByClassName("nextStep"));
        nextLinks.forEach(function (el, index, array) {
          //el.removeEventListener("click", goToNextStep);
          //el.removeEventListener("keyup", goToNextStep);
          el.addEventListener("click", goToNextStep);
          el.addEventListener("keyup", goToNextStep);
        });
      }
    };
  
  
    var selectedColorID = selBaseTrim.value;
    if (selectedColorID != "") {
      var selectedColors = [].slice.call(document.getElementsByClassName('selectedColorID'));
      selectedColors.forEach(function (el, index, array) {
        if (el.value == selectedColorID) {
          setTimeout(function () {
            el.previousElementSibling.click();
          }, 1200);
        }
      });
    }
  
  
    if (totalProductImages == 1 || editID > 0) {
      if (document.getElementsByClassName("step1")[0]) {
        document.getElementsByClassName("step1")[0].classList.remove("disabledBtn");
        document.getElementsByClassName("step1")[0].classList.add("bkgdBlue");
        document.getElementsByClassName("step1")[0].classList.add("whiteLink");
      }
    }
  
    if (!isSuspended) {
      sliderGlide.Init();
    }
    if (optionalExtras == null) {
      ajaxActions.LoadOptionalExtras();
    }
    if (nibInkOptions == null) {
      ajaxActions.LoadNibInkColor();
    }
    if (adhSidesOptions == null) {
      ajaxActions.LoadAdhesiveOptions();
    }
    if (currencySymbol) {
      currencySymbol = currencySymbol.replace(/\s+/g, '');
    }
  
  
   if (qryStr > 0) {
    
    	if(!isApparelItem){
        setTimeout(function () {
            var imgBox = document.querySelector('.imgBox');
      
            if (imgBox) {
              imgBox.click();

            }
            if (!isMobile) { CheckQueryString(); }
          }, 1200);
          
          //var imgBox = document.querySelector('.imgBox');
      
           // if (imgBox) {
           //  SaveProdColor(imgBox);
             
           // }
          
          // per shawn a - glide pricing should be hidden to avoid ad disapprovals
          document.getElementById("litGlideTotal").classList.add("hide");
          document.getElementById("lblQuantityTxtCaption").classList.add("hide");
          document.getElementsByClassName("glide")[0].lastElementChild.classList.add("hide"); //unit price
      
          //causes the extras to get added twice on mobile, think this is a good place to not run it twice
          	
	    }  else if (totalProductImages > 1) {
	     document.getElementById('GFeedPanel').style.display = "none";
	     setTimeout(function () {
	       document.querySelector('.imgBox').click();
	     }, 1200);
	   } else if (totalProductImages == 1) {
	     document.getElementsByClassName('txtApparelQty')[0].value = lowestQty;
	     CalcPrice();
	     CheckQueryString();
	   }
	   var productColorImgs = [].slice.call(document.getElementsByClassName("imgBox"));
	   if (productColorImgs.length > 0) {
	     setTimeout(function () {
	       productColorImgs[0].click();
	     }, 1200);
	   }
	}
  
    //if (document.getElementById('oneColorCheck')) {
    //  setApparelEvents();
    //}
  
    if (recolorAvailable.value === "False" && isApparelItem) {
      setApparelEvents();
    }

    checkSetEdit();
    bindDesktopStepLink();
    initGuaranteeDialog();
    initArtDialog();
    setUpHashOptions();
    initProductColorScroller();
    tooltips.init();
    ajaxActions.LoadMiniRating();
    initProp65();
    initVideo();
    initHandlers();
    ImageZoom.Init();
    MobileTweaks();
    clearFloat();
    ValidateCustomizeSections();
    sliderGlide.CheckForSingleQtyBreak();
    ByPassFullColor();
    initAppear();
    colorOptionsClicks();
    threeSixtyView();

    setTimeout(function () {
      copyTabs.init(document.getElementById("copyTabs"));
    }, 1200);
  })();